"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6741],{

/***/ 93282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(387);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30575);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61730);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5616);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69417);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23795);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42660);







var AssistedBioIndicator = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showAssistedBioModal = ref[0], setAssistedBioModal = ref[1];
    var isDesktop = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var handleAssistedBioClick = function() {
        setAssistedBioModal(true);
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)("CTA Interacted", {
            screen_name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .ScreenName.PROVIDER */ .CG.PROVIDER,
            cta_text: "Assisted bio",
            cta_intent: "Click on assisted bio badge"
        });
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.providerProfileViewed */ .Sj.providerProfileViewed, {
            screen_name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .ScreenName.AI_BIO */ .CG.AI_BIO
        });
    };
    var closeAssistedBioModal = function() {
        setAssistedBioModal(false);
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)("CTA Interacted", {
            screen_name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .ScreenName.AI_BIO */ .CG.AI_BIO,
            cta_text: "OK",
            cta_intent: "Dismiss assisted bio modal"
        });
    };
    var handleLearnMoreClick = function() {
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)("CTA Interacted", {
            screen_name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .ScreenName.PROVIDER */ .CG.PROVIDER,
            cta_text: "Learn more",
            cta_intent: "Click to learn more about assisted bio"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                display: "flex",
                alignItems: "center",
                mt: 1.5,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "text",
                        sx: {
                            height: "30px",
                            fontWeight: "400",
                            fontSize: "info1.fontSize"
                        },
                        onClick: handleAssistedBioClick,
                        size: "large",
                        children: "Assisted bio"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                open: showAssistedBioModal,
                onClose: closeAssistedBioModal,
                title: "What is an assisted bio?",
                children: [
                    "This caregiver wrote their bio using our AI tool, which summarizes their background based on their answers to questions about their skills and experience.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        color: "secondary",
                        variant: "contained",
                        sx: {
                            mt: 3,
                            mb: 2
                        },
                        onClick: closeAssistedBioModal,
                        children: "OK"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        sx: {
                            fontWeight: "700"
                        },
                        variant: "body2",
                        href: "https://help.care.com/families/s/article/What-is-an-Assisted-bio?language=en_US",
                        onClick: handleLearnMoreClick,
                        target: isDesktop ? "_blank" : "_self",
                        children: "Learn more"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AssistedBioIndicator);


/***/ }),

/***/ 5823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ GAMAds; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _care_htl_bid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80976);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5616);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42660);
/* harmony import */ var _hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19147);







var GAMAds = function(param) {
    var slotName = param.slotName, slotProps = param.slotProps;
    var ref = (0,_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__/* .useResponsive */ .F)(), isSmallViewport = ref.isSmallViewport, isMediumViewport = ref.isMediumViewport;
    var dimensions = function() {
        if (isSmallViewport) {
            return {
                width: 320,
                height: 50
            };
        }
        if (isMediumViewport) {
            return {
                width: 468,
                height: 50
            };
        }
        if (slotName === _constants__WEBPACK_IMPORTED_MODULE_2__/* .HTL_SLOTS.SEO_DIRECTORY_RR_1 */ .YQ.SEO_DIRECTORY_RR_1) {
            return {
                width: 300,
                height: 250
            };
        }
        if (slotName === _constants__WEBPACK_IMPORTED_MODULE_2__/* .HTL_SLOTS.SEO_PROV_PROFILE_RR_1 */ .YQ.SEO_PROV_PROFILE_RR_1) {
            return {
                width: 300,
                height: 600
            };
        }
        return {
            width: 728,
            height: 90
        };
    }();
    var width = dimensions.width, height = dimensions.height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        className: slotName,
        item: true,
        xs: 12,
        display: "flex",
        justifyContent: "center",
        pt: {
            xs: 1,
            sm: 5
        },
        pb: {
            xs: 4,
            sm: 8
        },
        sx: {
            "&.seo-prov-profile-inline-1, &.seo-prov-profile-inline-2": {
                pt: {
                    xs: 4,
                    md: 16
                },
                pb: 4
            },
            "&.seo-prov-profile-inline-2": {
                pt: {
                    xs: 4
                },
                pb: 4
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            width: "".concat(width, "px"),
            height: "".concat(height, "px")
        }, slotProps), {
            overflow: "visible",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_htl_bid__WEBPACK_IMPORTED_MODULE_1__/* .HTLBIDSlot */ .qF, {
                slotName: slotName
            })
        }))
    });
};



/***/ }),

/***/ 65477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68368);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82297);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43685);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2809);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54383);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61730);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5616);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69417);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42660);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(883);
/* eslint-disable complexity */ 






var ref = next_config__WEBPACK_IMPORTED_MODULE_1___default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var HowItWorks = function(param) {
    var serviceIdForMember = param.serviceIdForMember, segmentNamePluralLowerCase = param.segmentNamePluralLowerCase, segmentNameSingularLowerCase = param.segmentNameSingularLowerCase, _isCostGuidePage = param.isCostGuidePage, isCostGuidePage = _isCostGuidePage === void 0 ? false : _isCostGuidePage, segmentationUrl = param.segmentationUrl, _isCostGuideLandingPage = param.isCostGuideLandingPage, isCostGuideLandingPage = _isCostGuideLandingPage === void 0 ? false : _isCostGuideLandingPage;
    var isMobileOrSmaller = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var costGuideHeadlineSubstring = isCostGuideLandingPage ? "caregivers" : segmentNamePluralLowerCase;
    var costGuideHeadline = "Find ".concat(costGuideHeadlineSubstring, " near you that you'll love");
    var costGuideCtaText = isCostGuideLandingPage ? "Join free to get started" : "View ".concat(segmentNameSingularLowerCase, " profiles");
    var isChildCareLocation = serviceIdForMember === _constants__WEBPACK_IMPORTED_MODULE_2__/* .ServiceIdForMember.CHILD_CARE_LOCATION */ .u2.CHILD_CARE_LOCATION;
    var handleCtaBtn = function() {
        var amplitudeData = {
            cta_text: costGuideCtaText,
            cta_type: "button",
            url: "".concat(NEXT_PUBLIC_APP_URL).concat(segmentationUrl),
            url_path: segmentationUrl
        };
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .AmplitudeEvent.ctaInteracted */ .Sj.ctaInteracted, amplitudeData);
    };
    var hiwIconOne = isChildCareLocation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        sx: {
            width: "65px",
            height: "65px",
            marginTop: -1.5,
            marginLeft: -0.6
        }
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        sx: {
            width: "65px",
            height: "65px",
            marginTop: -1.5,
            marginLeft: -0.6
        }
    });
    var hiwIconThree = isChildCareLocation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        sx: {
            width: "65px",
            height: "65px",
            marginTop: -1.5,
            marginLeft: -0.6
        }
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        sx: {
            width: "65px",
            height: "65px",
            marginTop: -1.5,
            marginLeft: -0.6
        }
    });
    var hiwContentSubStringOne = isCostGuideLandingPage ? "" : " ".concat(segmentNameSingularLowerCase);
    var hiwContentSubStringTwo = isCostGuideLandingPage ? "caregivers" : segmentNamePluralLowerCase;
    var hiwIconThreeHeadline = isChildCareLocation ? "Compare".concat(hiwContentSubStringOne, " and tour the ones that best fit your family") : "Compare".concat(hiwContentSubStringOne, " options and choose the best fit");
    var howItWorksList = [
        {
            icon: hiwIconOne,
            content: "Share details about your".concat(hiwContentSubStringOne, " needs")
        },
        {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                sx: {
                    width: "65px",
                    height: "65px",
                    marginTop: -1.5,
                    marginLeft: -0.6
                }
            }),
            content: "Match with highly rated local ".concat(hiwContentSubStringTwo, " near you")
        },
        {
            icon: hiwIconThree,
            content: hiwIconThreeHeadline
        }, 
    ];
    var howItWorksContent = howItWorksList.map(function(item, idx) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            className: isCostGuidePage || isCostGuideLandingPage ? "hiw-cost-guide" : "hiw",
            sx: {
                display: {
                    xs: "flex",
                    sm: "inline-block"
                },
                alignItems: "center",
                alignContent: "center",
                flexWrap: "wrap",
                position: "relative",
                pb: {
                    xs: 3.7,
                    sm: 3
                },
                width: {
                    sm: "240px"
                },
                "&.hiw-cost-guide:not(:last-child)": {
                    "&:after": {
                        content: '""'
                    }
                },
                "&.hiw:not(:last-child)": {
                    "&:after": {
                        content: {
                            xs: '"⋮"',
                            sm: '"......"'
                        }
                    }
                },
                "&:not(:last-child)": {
                    "&:after": {
                        color: "brand.main",
                        display: "block",
                        fontSize: "h1.fontSize",
                        left: {
                            xs: "22px",
                            sm: "90%",
                            md: "95%",
                            lg: "125%"
                        },
                        position: "absolute",
                        top: {
                            xs: "70%",
                            sm: "0"
                        },
                        letterSpacing: {
                            sm: "3px"
                        }
                    }
                }
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    sx: {
                        width: {
                            xs: "50px",
                            sm: "100%"
                        },
                        height: "50px",
                        mr: 3,
                        textAlign: "center",
                        alignSelf: "flex-start",
                        pt: {
                            xs: 1,
                            sm: 0
                        },
                        mx: {
                            sm: 0
                        },
                        mt: {
                            sm: 0
                        },
                        mb: {
                            sm: 1
                        }
                    },
                    children: item.icon
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    maxWidth: {
                        xs: "245px",
                        sm: "100%"
                    },
                    flex: 1,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        variant: "body2",
                        mb: 0.5,
                        children: item.content
                    })
                })
            ]
        }, "".concat(item.content, "-").concat(idx + 1));
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
        className: isCostGuideLandingPage ? "landing-page" : "local-page",
        sx: {
            "&.landing-page": {
                backgroundColor: "background.default"
            },
            "&.local-page": {
                background: "care.grey.100"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
            item: true,
            xs: 12,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                pt: 3,
                px: 2,
                pb: 0,
                sx: {
                    textAlign: {
                        sm: "center"
                    }
                },
                children: [
                    !isCostGuidePage && !isCostGuideLandingPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        mb: {
                            xs: 1.5,
                            sm: 3
                        },
                        variant: "h2",
                        align: "center",
                        children: "How it works"
                    }),
                    (isCostGuidePage || isCostGuideLandingPage) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        sx: function(theme) {
                            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                                fontSize: "h2.fontSize",
                                pb: 2
                            }, theme.breakpoints.up("md"), {
                                padding: theme.spacing(1, 10, 4, 10),
                                fontSize: "h1.fontSize"
                            });
                        },
                        variant: "h2",
                        align: "center",
                        children: costGuideHeadline
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        sx: {
                            display: "flex",
                            flexDirection: {
                                xs: "column",
                                sm: "row"
                            },
                            justifyContent: {
                                sm: "space-evenly"
                            },
                            pl: 1
                        },
                        children: howItWorksContent
                    }),
                    (isCostGuidePage || isCostGuideLandingPage) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        pb: 5,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            width: {
                                xs: "270px",
                                sm: "315px",
                                md: "362px"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                sx: {
                                    mt: {
                                        xs: 2,
                                        md: 1
                                    }
                                },
                                color: "primary",
                                component: "a",
                                fullWidth: true,
                                onClick: handleCtaBtn,
                                href: segmentationUrl,
                                size: isMobileOrSmaller ? "medium" : "large",
                                variant: "contained",
                                rel: isCostGuideLandingPage ? "nofollow" : "",
                                children: costGuideCtaText
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HowItWorks);


/***/ }),

/***/ 35492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export splitValueIntoParts */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23795);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_6__);
/* eslint-disable jsx-a11y/anchor-is-valid */ 






var SPACE_CHAR = " ";
var WHITE_SPACE_REGEXP = /\s*$/;
var DOUBLE_QUOTES = '"';
var splitValueIntoParts = function(value, charLimit) {
    if (!value) {
        return {
            teaser: value
        };
    }
    var remainingWords = [];
    var teaserWords = value.split(SPACE_CHAR);
    while(teaserWords.join(SPACE_CHAR).length > charLimit){
        remainingWords.unshift(teaserWords.pop());
    }
    return {
        teaser: teaserWords.join(SPACE_CHAR),
        remaining: remainingWords.join(SPACE_CHAR)
    };
};
var ReadMore = function(_param) {
    var value = _param.value, _charLimit = _param.charLimit, charLimit = _charLimit === void 0 ? 500 : _charLimit, _ellipses = _param.ellipses, ellipses = _ellipses === void 0 ? "..." : _ellipses, _showLessButton = _param.showLessButton, showLessButton = _showLessButton === void 0 ? true : _showLessButton, _showDoubleQuotes = _param.showDoubleQuotes, showDoubleQuotes = _showDoubleQuotes === void 0 ? false : _showDoubleQuotes, _onShowMoreClick = _param.onShowMoreClick, onShowMoreClick = _onShowMoreClick === void 0 ? function() {} : _onShowMoreClick, _onShowLessClick = _param.onShowLessClick, onShowLessClick = _onShowLessClick === void 0 ? function() {} : _onShowLessClick, _showMoreLabel = _param.showMoreLabel, showMoreLabel = _showMoreLabel === void 0 ? "more" : _showMoreLabel, _showLessLabel = _param.showLessLabel, showLessLabel = _showLessLabel === void 0 ? "less" : _showLessLabel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "value",
        "charLimit",
        "ellipses",
        "showLessButton",
        "showDoubleQuotes",
        "onShowMoreClick",
        "onShowLessClick",
        "showMoreLabel",
        "showLessLabel"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var handleToggle = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setIsExpanded(!isExpanded);
        if (isExpanded) {
            onShowLessClick();
        } else {
            onShowMoreClick();
        }
    }, [
        isExpanded,
        onShowMoreClick,
        onShowLessClick
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return splitValueIntoParts(value, charLimit);
    }, [
        value,
        charLimit
    ]), teaser = ref1.teaser, remaining = ref1.remaining;
    var canBeToggled = value.length > charLimit;
    var splitContent = !isExpanded ? "".concat(teaser.replace(WHITE_SPACE_REGEXP, "")) : "".concat(teaser, " ").concat(remaining);
    var content = canBeToggled ? splitContent : value;
    var toggleLabel = isExpanded ? "".concat(showLessLabel) : "".concat(showMoreLabel);
    var hideToggle = canBeToggled && (!isExpanded || showLessButton);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        children: [
            showDoubleQuotes && "".concat(DOUBLE_QUOTES),
            content,
            showDoubleQuotes && !hideToggle && "".concat(DOUBLE_QUOTES),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("noscript", {
                dangerouslySetInnerHTML: {
                    __html: remaining ? sanitize_html__WEBPACK_IMPORTED_MODULE_6___default()(remaining) : ""
                }
            }),
            hideToggle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    isExpanded && showDoubleQuotes && "".concat(DOUBLE_QUOTES),
                    isExpanded && "".concat(SPACE_CHAR),
                    !isExpanded && "".concat(ellipses).concat(SPACE_CHAR),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        sx: {
                            font: "inherit",
                            verticalAlign: "inherit",
                            textDecoration: "underline"
                        },
                        component: "button",
                        onClick: handleToggle,
                        children: toggleLabel
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ReadMore);


/***/ }),

/***/ 6150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ SafetyModalWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _care_caregiver_profile_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55138);
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79967);
/* harmony import */ var _utils_getZipcodeFromGeoInfo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7360);
/* harmony import */ var _contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73739);
/* harmony import */ var _hooks_useZipCodeValidation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89698);









var SafetyModalWrapper = function(param) {
    var openModal = param.openModal, setOpenModal = param.setOpenModal, _isCaregiverProfilePage = param.isCaregiverProfilePage, isCaregiverProfilePage = _isCaregiverProfilePage === void 0 ? false : _isCaregiverProfilePage, _caregiverStateCode = param.caregiverStateCode, caregiverStateCode = _caregiverStateCode === void 0 ? null : _caregiverStateCode;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isFromMassachusetts = ref[0], setIsFromMassachusetts = ref[1];
    var ref1 = (0,_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_3__/* .usePageAttributes */ .l)(), userGeoInfo = ref1.userGeoInfo, seoSegmentId = ref1.seoSegmentId;
    var validate = (0,_hooks_useZipCodeValidation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().validate;
    var getStateCodeFromSegmentId = function(segmentId) {
        var segment = segmentId.split("/").pop();
        if (segment === null || segment === void 0 ? void 0 : segment.includes("-")) {
            var state = segment.split("-").pop();
            var ref;
            return (ref = state === null || state === void 0 ? void 0 : state.toUpperCase()) !== null && ref !== void 0 ? ref : null;
        }
        return null;
    };
    var stateCodeFromSegmentId = getStateCodeFromSegmentId(seoSegmentId);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var fetchStateLocation = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var zipCode, data;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            zipCode = (0,_utils_getZipcodeFromGeoInfo__WEBPACK_IMPORTED_MODULE_7__/* .getZipcodeFromGeoInfo */ .Z)(userGeoInfo);
                            return [
                                4,
                                validate(zipCode)
                            ];
                        case 1:
                            data = _state.sent();
                            if ((data === null || data === void 0 ? void 0 : data.state) === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_2__/* .UsStateCode.MA */ .y9.MA) {
                                setIsFromMassachusetts(true);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchStateLocation() {
                return _ref.apply(this, arguments);
            };
        }();
        if (isCaregiverProfilePage) {
            setIsFromMassachusetts(caregiverStateCode === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_2__/* .UsStateCode.MA */ .y9.MA);
        } else {
            setIsFromMassachusetts(stateCodeFromSegmentId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_2__/* .UsStateCode.MA */ .y9.MA);
        }
        fetchStateLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_caregiver_profile_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        open: openModal,
        onClose: function() {
            return setOpenModal(false);
        },
        newSafetyExperienceEnabled: true,
        isMAProviderOrSeeker: isFromMassachusetts
    });
};



/***/ }),

/***/ 58291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61730);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5616);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69417);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15861);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
/* eslint-disable no-nested-ternary */ 



var SeoConversionBox = function(param) {
    var city = param.city, crossSell = param.crossSell, enrollmentURL = param.enrollmentURL, header = param.header, pageType = param.pageType, resultType = param.resultType, serviceId = param.serviceId, state = param.state;
    var isMobile = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var isCCProvider = typeof resultType !== "undefined" && _constants__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULT_TYPE */ .sM[resultType] === _constants__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULT_TYPE.PROVIDER */ .sM.PROVIDER && serviceId === "CHILDCARE" && crossSell;
    var avgPayRates = crossSell === null || crossSell === void 0 ? void 0 : crossSell.avgPayRates;
    var handleCareButton = function(e) {
        var ref;
        var amplitudeData = {
            cta_location: "header",
            cta_text: (ref = e.target.textContent) === null || ref === void 0 ? void 0 : ref.toString(),
            cta_type: "button"
        };
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.ctaInteracted */ .Sj.ctaInteracted, amplitudeData);
    };
    var renderHeading = function() {
        if (isCCProvider) {
            return "Find other affordable childcare options" + "".concat(pageType === "LOCAL" ? " near you in ".concat(city, ", ").concat(state) : " in your area");
        }
        return header;
    };
    var renderCtaBtns = function() {
        if (isCCProvider) {
            return avgPayRates === null || avgPayRates === void 0 ? void 0 : avgPayRates.map(function(param) {
                var title = param.title, url = param.url, avgPayRate = param.avgPayRate;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    minWidth: "200px",
                    mx: 1.5,
                    mt: 1.5,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        component: "a",
                        href: url,
                        variant: "contained",
                        size: "large",
                        fullWidth: true,
                        color: "secondary",
                        "data-testid": "conversion-cta-link",
                        onClick: handleCareButton,
                        children: [
                            title,
                            " $",
                            parseFloat(avgPayRate.rate.amount).toFixed(2),
                            "/",
                            _constants__WEBPACK_IMPORTED_MODULE_1__/* .RATE_DURATION_ABBREVIATIONS */ .r7[avgPayRate.rateDuration]
                        ]
                    })
                }, title);
            });
        }
        return _constants__WEBPACK_IMPORTED_MODULE_1__/* .CONVERSION_CTA_LABELS.map */ .dA.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                minWidth: "144px",
                mt: 1.5,
                mx: 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    component: "a",
                    href: "".concat(enrollmentURL, "&intent=").concat(item.intent),
                    variant: "contained",
                    color: "secondary",
                    size: "medium",
                    sx: {
                        fontSize: "16px"
                    },
                    fullWidth: true,
                    "data-testid": "conversion-cta-link",
                    onClick: handleCareButton,
                    rel: "nofollow",
                    children: item.label
                })
            }, item.intent);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
        container: true,
        bgcolor: function(theme) {
            return theme.palette.care.grey[100];
        },
        py: {
            xs: 3,
            sm: 5
        },
        px: 0,
        ml: "auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    mb: 1,
                    textAlign: "center",
                    component: "h3",
                    variant: "h2",
                    children: renderHeading()
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                display: "flex",
                justifyContent: "center",
                flexWrap: !isMobile ? "nowrap" : "wrap",
                flexBasis: "100%",
                children: renderCtaBtns()
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoConversionBox);


/***/ }),

/***/ 19500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var _components_contexts_FeatureFlagsContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63880);

function useFeatureFlag(flagName) {
    var ref;
    var featureFlags = (0,_components_contexts_FeatureFlagsContext__WEBPACK_IMPORTED_MODULE_0__/* .useFeatureFlags */ .g)();
    return featureFlags === null || featureFlags === void 0 ? void 0 : (ref = featureFlags.flags) === null || ref === void 0 ? void 0 : ref[flagName];
}


/***/ }),

/***/ 32778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useLDClientFlags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);
/* harmony import */ var _components_contexts_FeatureFlagsContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63880);



var useLDClientFlags = function() {
    var featureFlags = (0,_components_contexts_FeatureFlagsContext__WEBPACK_IMPORTED_MODULE_1__/* .useFeatureFlags */ .g)();
    var activeFlags = {};
    return Object.entries(_constants__WEBPACK_IMPORTED_MODULE_0__/* .UI_FEATURE_FLAGS */ .WV).reduce(function(acc, flag) {
        var ref;
        var _flag = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(flag, 2), flagName = _flag[0], flagDetails = _flag[1];
        var currentFlag = featureFlags === null || featureFlags === void 0 ? void 0 : (ref = featureFlags.flags) === null || ref === void 0 ? void 0 : ref[flagDetails.id];
        acc[flagName] = currentFlag;
        return acc;
    }, activeFlags);
};


/***/ }),

/***/ 89698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useZipCodeValidation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js + 2 modules
var useLazyQuery = __webpack_require__(45910);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(68806);
;// CONCATENATED MODULE: ./src/API/seoSegmentationValidateZipCode.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query validateZipCode($input: SEOValidateZipCodeInput!) {\n    seoSegmentationValidateZipCode(input: $input) {\n      ... on SEOValidateZipCodeSuccess {\n        __typename\n        city\n        state\n      }\n      ... on SEOValidateZipCodeError {\n        __typename\n        error {\n          message\n          ... on DataNotAvailableError {\n            message\n          }\n          ... on DataNotAvailableForGivenPageNumberError {\n            message\n          }\n          ... on UrlNotFoundError {\n            message\n          }\n          ... on InvalidSEOZipCodeError {\n            message\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var VALIDATE_ZIP_CODE = (0,lib/* gql */.Ps)(_templateObject());
/* harmony default export */ var seoSegmentationValidateZipCode = (VALIDATE_ZIP_CODE);

;// CONCATENATED MODULE: ./src/components/hooks/useZipCodeValidation.tsx






function useZipCodeValidation() {
    var ref = (0,react.useState)(""), zipCode = ref[0], setZipCode = ref[1];
    var ref1 = (0,react.useState)(""), city = ref1[0], setCity = ref1[1];
    var ref2 = (0,react.useState)(""), state = ref2[0], setState = ref2[1];
    var ref3 = (0,react.useState)(false), hasError = ref3[0], setHasError = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(seoSegmentationValidateZipCode, {
        variables: {
            input: {
                zipcode: zipCode
            }
        }
    }), 1), validateZipCode = ref4[0];
    var validate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var newZipCode, ref, ref1, response, res;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        newZipCode = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "";
                        setHasError(false);
                        setZipCode(newZipCode);
                        if (newZipCode.length < 5) {
                            setCity("");
                            setState("");
                            setHasError(false);
                            return [
                                2,
                                Promise.resolve({
                                    zipCode: zipCode,
                                    city: "",
                                    state: ""
                                })
                            ];
                        }
                        if (!(newZipCode.length === 5)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            validateZipCode({
                                variables: {
                                    input: {
                                        zipcode: newZipCode
                                    }
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        res = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.seoSegmentationValidateZipCode;
                        if ((res === null || res === void 0 ? void 0 : res.__typename) === "SEOValidateZipCodeSuccess") {
                            setCity(res === null || res === void 0 ? void 0 : res.city);
                            setState(res === null || res === void 0 ? void 0 : res.state);
                            return [
                                2,
                                Promise.resolve({
                                    zipCode: newZipCode,
                                    city: res === null || res === void 0 ? void 0 : res.city,
                                    state: res === null || res === void 0 ? void 0 : res.state
                                })
                            ];
                        }
                        if (newZipCode.length === 5 && (res === null || res === void 0 ? void 0 : (ref1 = res.error) === null || ref1 === void 0 ? void 0 : ref1.__typename) === "InvalidSEOZipCodeError") {
                            setCity("");
                            setState("");
                            setHasError(true);
                            return [
                                2,
                                Promise.resolve({
                                    zipCode: newZipCode,
                                    city: "",
                                    state: ""
                                })
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2,
                            Promise.resolve({
                                zipCode: zipCode,
                                city: city,
                                state: state
                            })
                        ];
                }
            });
        });
        return function validate() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        validate: validate,
        hasError: hasError
    };
}


/***/ }),

/***/ 76741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ segmentationListings_SegmentationListingPage; }
});

// UNUSED EXPORTS: getServerSideProps

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/CoreGlobalFooter/CoreGlobalFooter.js + 8 modules
var CoreGlobalFooter = __webpack_require__(69388);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Divider/Divider.js
var Divider = __webpack_require__(81956);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js + 2 modules
var useLazyQuery = __webpack_require__(45910);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/lib/ApolloClient.ts + 75 modules
var ApolloClient = __webpack_require__(77414);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(49093);
// EXTERNAL MODULE: ./src/utils/getQueryParams.ts
var getQueryParams = __webpack_require__(21961);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/utils/getDeviceCharacteristics.ts
var getDeviceCharacteristics = __webpack_require__(93867);
// EXTERNAL MODULE: ./src/utils/reqHeaderToEntriesObj.ts
var reqHeaderToEntriesObj = __webpack_require__(28906);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(68806);
// EXTERNAL MODULE: ./src/API/fragments/common.ts
var fragments_common = __webpack_require__(37349);
// EXTERNAL MODULE: ./src/API/utils.ts
var utils = __webpack_require__(36630);
;// CONCATENATED MODULE: ./src/API/seoSegmentationListingPage.ts



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  query seoSegmentationListingPage(\n    $seoSegmentId: ID!\n    $pageNumber: Int\n    $filters: SEOSegmentationFilterInput\n    $ipAddress: String!\n    $userGeoInfo: String!\n    $botInfo: String!\n    $userAgent: String!\n    $numberOfReviewsPerProfile: Int\n    $local: Boolean!\n    $locationId: ID!\n    $isJobSegment: Boolean!\n  ) {\n    seoSegmentationSearchResults(\n      filters: $filters\n      pageNumber: $pageNumber\n      testCell: null\n      seoSegmentId: $seoSegmentId\n      ipAddress: $ipAddress\n      botInfo: $botInfo\n      userGeoInfo: $userGeoInfo\n      userAgent: $userAgent\n      numberOfReviewsPerProfile: $numberOfReviewsPerProfile\n    ) {\n      ... on SEOSegmentationSearchResultsSuccess {\n        ...CaregiverSearchResultFields\n        ...ProviderSearchResultFields\n        ...JobSearchResultFields\n        ...ArchivedJobSearchResultFields\n        ...ActivitySearchResultFields\n        tests {\n          testName\n          testVariant\n        }\n        filters {\n          location {\n            city\n            state\n            zipcode\n          }\n        }\n      }\n      ... on SEOSegmentationSearchResultsError {\n        errors {\n          __typename\n          message\n        }\n      }\n    }\n    seoSegmentationDetails(seoSegmentId: $seoSegmentId) {\n      __typename\n      ... on SEOSegmentationDetailsSuccess {\n        segmentationDetails {\n          seoPageMetadata {\n            title\n            metaKeywords\n            indexable\n            metaDescriptions\n            canonicalURL\n            seoPageId\n            hrefLangLinks {\n              countryCode\n              languageCode\n              url\n            }\n          }\n          headline\n          subHeadline\n          conversionHeader\n          searchResultsHeader\n          searchFilters\n          searchingFor\n          pageType\n          smbHeadline\n          crossSell {\n            avgPayRates {\n              title\n              url\n              avgPayRate {\n                rate {\n                  amount\n                  currencyCode\n                }\n                rateDuration\n              }\n            }\n          }\n          city\n          state\n          segmentationSubService\n          serviceId\n          serviceIdForMember\n          avgPayRate {\n            rate {\n              amount\n              currencyCode\n            }\n            rateDuration\n          }\n          minPayRate {\n            rate {\n              amount\n              currencyCode\n            }\n            rateDuration\n          }\n          maxPayRate {\n            rate {\n              amount\n              currencyCode\n            }\n            rateDuration\n          }\n          segmentNamePlural\n          segmentNamePluralLowerCase\n          segmentNameSingular\n          segmentNameSingularLowerCase\n          avgReviewRating\n          smbHeadline\n          internalLinkingHeadline\n        }\n      }\n      ... on SEOSegmentationDetailsError {\n        __typename\n        errors {\n          __typename\n          message\n        }\n      }\n    }\n    seoSegmentationHeroImage(seoSegmentId: $seoSegmentId) {\n      __typename\n      ... on SEOSegmentationHeroImageSuccess {\n        heroImage {\n          largeImageURL\n          smallImageURL\n        }\n      }\n      ... on SEOSegmentationHeroImageError {\n        errors {\n          message\n          __typename\n        }\n      }\n    }\n    seoSegmentationBreadcrumbs(seoSegmentId: $seoSegmentId) {\n      ... on SEOSegmentationBreadcrumbsSuccess {\n        breadcrumbs {\n          content\n          url\n        }\n      }\n      ... on SEOSegmentationBreadcrumbsError {\n        errors {\n          message\n        }\n      }\n    }\n    getSEOSegmentationIntro(seoSegmentId: $seoSegmentId) @skip(if: $local) {\n      title\n      description\n    }\n    seoSegmentationStats(seoSegmentId: $seoSegmentId) @skip(if: $isJobSegment) {\n      ... on SEOSegmentationStatsSuccess {\n        caregiverStats {\n          title\n          totalProviders\n          avgYearsOfExperience\n          totalReviewCount\n          avgReviewRating\n          avgPayRate {\n            amount\n            currencyCode\n          }\n          jobCount\n        }\n      }\n      ... on SEOSegmentationStatsError {\n        errors {\n          __typename\n          message\n        }\n      }\n    }\n    getSEOSegmentationFAQs(seoSegmentId: $seoSegmentId) {\n      title\n      faqList {\n        question\n        answer\n      }\n    }\n    getSEOSegmentationLinkSections(seoSegmentId: $seoSegmentId) {\n      id\n      linkList {\n        content\n        createDate\n        description\n        url\n        imageDetails {\n          imageHeight\n          imageSize\n          imageUrl\n          imageWidth\n        }\n      }\n      title\n    }\n    seoArticlesList(seoSegmentId: $seoSegmentId) {\n      ... on SEOArticlesListSuccess {\n        __typename\n        seoArticlesList {\n          articles {\n            createDate\n            description\n            largeImage {\n              imageHeight\n              imageSize\n              imageUrl\n              imageWidth\n            }\n            smallImage {\n              imageHeight\n              imageSize\n              imageUrl\n              imageWidth\n            }\n            title\n            url\n          }\n        }\n      }\n      ... on SEOArticlesListError {\n        __typename\n        errors {\n          message\n        }\n      }\n    }\n    seoNavigationLinkSection(locationId: $locationId) @include(if: $local) {\n      ... on SEONavigationLinkSectionSuccess {\n        __typename\n        seoNavigationLinkSection {\n          childCareLinks {\n            title\n            urlPath\n          }\n          housekeepingLinks {\n            title\n            urlPath\n          }\n          jobsLinks {\n            title\n            urlPath\n          }\n          petCareLinks {\n            title\n            urlPath\n          }\n          seniorCareLinks {\n            title\n            urlPath\n          }\n          tutoringLinks {\n            title\n            urlPath\n          }\n        }\n      }\n      ... on SEONavigationLinkSectionError {\n        __typename\n        errors {\n          message\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var SEO_SEGMENTATION_LISTING_PAGE = (0,lib/* gql */.Ps)(_templateObject(), fragments_common/* CAREGIVER_SEARCH_RESULT_FIELDS */.ut, fragments_common/* PROVIDER_SEARCH_RESULT_FIELDS */.GF, fragments_common/* JOB_SEARCH_RESULT_FIELDS */.OS, fragments_common/* ARCHIVED_JOB_SEARCH_RESULT_FIELDS */.d7, fragments_common/* ACTIVITY_SEARCH_RESULT_FIELDS */.CT);
var seoSegmentationListingPage_seoSegmentationListingPage = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(client, variables) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                (0,utils/* apolloClientQuery */.M)(client, SEO_SEGMENTATION_LISTING_PAGE, variables)
            ];
        });
    });
    return function seoSegmentationListingPage(client, variables) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(79967);
// EXTERNAL MODULE: ./src/utils/GoogleAdsManager/getGAMVerticalShortName.ts
var getGAMVerticalShortName = __webpack_require__(28057);
// EXTERNAL MODULE: ./src/utils/GoogleAdsManager/getGAMContentType.ts
var getGAMContentType = __webpack_require__(37424);
;// CONCATENATED MODULE: ./src/components/pages/segmentationListings/segmentationListingPageProps.ts















var isLocal = "production" === "development";
// eslint-disable-next-line complexity
var getListPageData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var query, req, res, ref, ref1, ref2, ref3, ref4, ref5, startPageGSSP, apolloOptions, startApolloClient, apolloClient, stopApolloClient, shuffleSeed, ref6, serverFeatureFlags, userAgent, deviceCharHeader, deviceChar, ref7, seoSegmentId, pageNumber, local, location, testIDToFireTestExposureEvent, isJobSegment, botInfo, userGeoInfo, ipAddressArray, ipAddress, ref8, numberOfReviewsPerProfile, startGetPageData, seoSegmentationListingPage, stopGetPageData, seoSegmentationListingPageData, errors, startLD, ldClientFlags, _segmentationDetails, pageType, serviceIdForMember, serviceId, segmentationSubService, searchingFor, pageTemplate, ldTargetAttributes, ref9, ldClient, ldUser, clientFlagPromises, stopLD, additionalGAMRules, _getSEOSegmentationIntro, _seoSegmentationStats, _seoNavigationLinkSection, pageProps, stopPageGSSP;
        function getAllErrors(queryResult) {
            var ref;
            var errors = {};
            if (queryResult.data.seoSegmentationDetails.__typename === "SEOSegmentationDetailsError") {
                errors.seoSegmentationDetailsError = queryResult.data.seoSegmentationDetails.errors;
            }
            if (queryResult.data.seoSegmentationSearchResults.__typename === "SEOSegmentationSearchResultsError") {
                errors.seoSegmentationSearchResultsError = queryResult.data.seoSegmentationSearchResults.errors;
            }
            (ref = queryResult.errors) === null || ref === void 0 ? void 0 : ref.forEach(function(error) {
                if (error.path) {
                    // path is the query name (e.g. getSEOSegmentationSearchResults) its represented as a singleton array
                    errors["".concat(error.path[0], "Error")] = error;
                }
            });
            return errors;
        }
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query, req = param.req, res = param.res;
                    startPageGSSP = performance.now();
                    apolloOptions = {
                        logError: req.log.error.bind(req.log),
                        logInfo: req.log.info.bind(req.log)
                    };
                    startApolloClient = performance.now();
                    apolloClient = (0,ApolloClient/* getApolloClient */.W)(apolloOptions);
                    stopApolloClient = performance.now();
                    shuffleSeed = Math.floor(Math.random() * 2147483647);
                    serverFeatureFlags = (ref6 = (ref = req.careContext) === null || ref === void 0 ? void 0 : ref.ldServerFlags) !== null && ref6 !== void 0 ? ref6 : false;
                    userAgent = req.headers["user-agent"] || "";
                    deviceCharHeader = ((ref1 = req.headers["x-akamai-device-characteristics"]) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "";
                    deviceChar = isLocal ? (0,getDeviceCharacteristics/* default */.Z)(userAgent, deviceCharHeader) : (0,reqHeaderToEntriesObj/* default */.Z)(deviceCharHeader, ";");
                    ref7 = (0,getQueryParams/* default */.Z)(query), seoSegmentId = ref7.seoSegmentId, pageNumber = ref7.pageNumber, local = ref7.local, location = ref7.location, testIDToFireTestExposureEvent = ref7.testIDToFireTestExposureEvent;
                    isJobSegment = Boolean((ref2 = query.segment) === null || ref2 === void 0 ? void 0 : ref2.toString().includes("jobs"));
                    botInfo = ((ref3 = req.headers["Akamai-Bot"]) === null || ref3 === void 0 ? void 0 : ref3.toString()) || "";
                    userGeoInfo = ((ref4 = req.headers["x-akamai-edgescape"]) === null || ref4 === void 0 ? void 0 : ref4.toString()) || "";
                    ipAddressArray = req.headers["x-forwarded-for"];
                    if (typeof ipAddressArray !== "undefined") {
                        ;
                        ref8 = (0,_sliced_to_array/* default */.Z)(ipAddressArray.toString().split(","), 1), ipAddress = ref8[0], ref8;
                    } else {
                        ipAddress = "";
                    }
                    numberOfReviewsPerProfile = 1;
                    startGetPageData = performance.now();
                    if (serverFeatureFlags && ((ref5 = serverFeatureFlags[constants/* SERVER_FEATURE_FLAGS.SEO_MFE_LOG_AKAMAI_HEADER */.VL.SEO_MFE_LOG_AKAMAI_HEADER]) === null || ref5 === void 0 ? void 0 : ref5.value)) {
                        req.log.info({
                            event: "x-akamai-edgescape header",
                            seoSegmentId: seoSegmentId,
                            userAgent: userAgent,
                            deviceChar: deviceChar,
                            ipAddress: ipAddress,
                            akamaiHeader: userGeoInfo
                        });
                    }
                    return [
                        4,
                        seoSegmentationListingPage_seoSegmentationListingPage(apolloClient, {
                            filters: null,
                            pageNumber: pageNumber,
                            seoSegmentId: seoSegmentId,
                            ipAddress: ipAddress,
                            botInfo: botInfo,
                            userGeoInfo: userGeoInfo,
                            userAgent: userAgent,
                            numberOfReviewsPerProfile: numberOfReviewsPerProfile,
                            local: local,
                            locationId: location,
                            isJobSegment: isJobSegment
                        })
                    ];
                case 1:
                    seoSegmentationListingPage = _state.sent();
                    stopGetPageData = performance.now();
                    // Server error (e.g. validation or syntax resulting in a 400)
                    // https://www.apollographql.com/docs/react/data/error-handling/#graphql-errors
                    if (seoSegmentationListingPage.error !== null) {
                        req.log.error({
                            event: "SeoListingPageLoadError",
                            seoSegmentId: seoSegmentId,
                            userAgent: userAgent,
                            deviceChar: deviceChar,
                            query: query,
                            res: res,
                            errors: seoSegmentationListingPage.error
                        });
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    seoSegmentationListingPageData = seoSegmentationListingPage.queryResponse.data;
                    // Resolver Errors returned as "errors"
                    if (seoSegmentationListingPage.queryResponse.errors) {
                        errors = getAllErrors(seoSegmentationListingPage.queryResponse);
                        req.log.error({
                            event: "SeoListingPageLoadError",
                            seoSegmentId: seoSegmentId,
                            userAgent: userAgent,
                            deviceChar: deviceChar,
                            query: query,
                            res: res,
                            errors: errors
                        });
                    }
                    // Resolver errors returned as data
                    // return 404 for resolvers containing essential data for UI rendering
                    // https://www.apollographql.com/docs/react/data/error-handling/#graphql-errors
                    if (seoSegmentationListingPageData.seoSegmentationDetails.__typename === "SEOSegmentationDetailsError" || seoSegmentationListingPageData.seoSegmentationSearchResults.__typename === "SEOSegmentationSearchResultsError") {
                        req.log.error({
                            event: "SeoListingPageLoadError",
                            seoSegmentId: seoSegmentId,
                            userAgent: userAgent,
                            deviceChar: deviceChar,
                            query: query,
                            res: res,
                            errors: getAllErrors(seoSegmentationListingPage.queryResponse)
                        });
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    if (seoSegmentationListingPageData.seoSegmentationDetails.segmentationDetails === null) {
                        req.log.error({
                            event: "SeoListingPageLoadError",
                            seoSegmentId: seoSegmentId,
                            userAgent: userAgent,
                            deviceChar: deviceChar,
                            query: query,
                            res: res,
                            errorMsg: "ERROR - seoSegmentationDetails is null"
                        });
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    startLD = performance.now();
                    ldClientFlags = {};
                    _segmentationDetails = seoSegmentationListingPageData.seoSegmentationDetails.segmentationDetails, pageType = _segmentationDetails.pageType, serviceIdForMember = _segmentationDetails.serviceIdForMember, serviceId = _segmentationDetails.serviceId, segmentationSubService = _segmentationDetails.segmentationSubService, searchingFor = _segmentationDetails.searchingFor;
                    pageTemplate = function() {
                        if (searchingFor === globalTypes/* SEOSegmentationSearchingFor.ALL_JOB */.yh.ALL_JOB || searchingFor === globalTypes/* SEOSegmentationSearchingFor.SEEKER_JOB */.yh.SEEKER_JOB || searchingFor === globalTypes/* SEOSegmentationSearchingFor.SMB_JOB */.yh.SMB_JOB) {
                            return common/* PageTemplate.JOB_DIRECTORY */.P.JOB_DIRECTORY;
                        }
                        return common/* PageTemplate.CAREGIVER_DIRECTORY */.P.CAREGIVER_DIRECTORY;
                    }();
                    ldTargetAttributes = {
                        pageType: pageType,
                        serviceIdForMember: serviceIdForMember,
                        serviceId: serviceId,
                        segmentationSubService: segmentationSubService,
                        seoSegmentId: seoSegmentId,
                        deviceChar: deviceChar,
                        searchingFor: searchingFor,
                        pageTemplate: pageTemplate
                    };
                    ref9 = req.careContext || {}, ldClient = ref9.ldClient, ldUser = ref9.ldUser;
                    if (!(ldClient && ldUser)) return [
                        3,
                        3
                    ];
                    ldUser.custom = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ldUser.custom), {
                        serviceIdForMember: serviceIdForMember,
                        seoSegmentId: seoSegmentId,
                        pageType: pageType,
                        subService: segmentationSubService || "",
                        serviceId: serviceId,
                        searchingFor: searchingFor,
                        pageTemplate: pageTemplate
                    });
                    clientFlagPromises = Object.values(constants/* UI_FEATURE_FLAGS */.WV).filter(function(flag) {
                        return flag.condition(ldTargetAttributes);
                    }).map(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(flag) {
                            var _;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _ = flag.id;
                                        return [
                                            4,
                                            ldClient.variationDetail(flag.id, ldUser, undefined)
                                        ];
                                    case 1:
                                        ldClientFlags[_] = _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(flag) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    return [
                        4,
                        Promise.all(clientFlagPromises)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    stopLD = performance.now();
                    additionalGAMRules = {
                        vertical: (0,getGAMVerticalShortName/* getGAMVerticalShortName */.W)(serviceId),
                        contType: (0,getGAMContentType/* getGAMContentType */.P)({
                            searchingFor: searchingFor
                        })
                    };
                    pageProps = {
                        props: {
                            seoSegmentId: seoSegmentId,
                            initialPageNumber: pageNumber,
                            ipAddress: ipAddress,
                            botInfo: botInfo,
                            userGeoInfo: userGeoInfo,
                            ldClientFlags: ldClientFlags,
                            pageData: {
                                seoSegmentationSearchResults: seoSegmentationListingPageData.seoSegmentationSearchResults,
                                seoSegmentationDetails: seoSegmentationListingPageData.seoSegmentationDetails.segmentationDetails,
                                seoSegmentationHeroImage: seoSegmentationListingPageData.seoSegmentationHeroImage,
                                seoSegmentationBreadcrumbs: seoSegmentationListingPageData.seoSegmentationBreadcrumbs,
                                getSEOSegmentationIntro: (_getSEOSegmentationIntro = seoSegmentationListingPageData.getSEOSegmentationIntro) !== null && _getSEOSegmentationIntro !== void 0 ? _getSEOSegmentationIntro : null,
                                seoSegmentationStats: (_seoSegmentationStats = seoSegmentationListingPageData.seoSegmentationStats) !== null && _seoSegmentationStats !== void 0 ? _seoSegmentationStats : null,
                                getSEOSegmentationFAQs: seoSegmentationListingPageData.getSEOSegmentationFAQs,
                                getSEOSegmentationLinkSections: seoSegmentationListingPageData.getSEOSegmentationLinkSections,
                                seoArticlesList: seoSegmentationListingPageData.seoArticlesList,
                                seoNavigationLinkSection: (_seoNavigationLinkSection = seoSegmentationListingPageData.seoNavigationLinkSection) !== null && _seoNavigationLinkSection !== void 0 ? _seoNavigationLinkSection : null
                            },
                            userAgent: userAgent,
                            deviceChar: deviceChar,
                            testName: testIDToFireTestExposureEvent,
                            numberOfReviewsPerProfile: numberOfReviewsPerProfile,
                            pageTemplate: pageTemplate,
                            additionalGAMRules: additionalGAMRules,
                            shuffleSeed: shuffleSeed
                        }
                    };
                    req.log.info({
                        event: "SeoListingPageLoadSuccess",
                        seoSegmentId: seoSegmentId,
                        userAgent: userAgent,
                        deviceChar: deviceChar,
                        query: query,
                        res: res
                    });
                    stopPageGSSP = performance.now();
                    req.careContext.serverTimings.pageGSSP = stopPageGSSP - startPageGSSP;
                    req.careContext.serverTimings.ldClientFlags = stopLD - startLD;
                    req.careContext.serverTimings.apolloClient = stopApolloClient - startApolloClient;
                    req.careContext.serverTimings.pageData = stopGetPageData - startGetPageData;
                    return [
                        2,
                        pageProps
                    ];
            }
        });
    });
    return function getListPageData(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var segmentationListingPageProps = (getListPageData);

// EXTERNAL MODULE: ./src/components/hooks/useFeatureFlag.ts
var useFeatureFlag = __webpack_require__(19500);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
// EXTERNAL MODULE: ./src/components/Breadcrumbs.tsx
var Breadcrumbs = __webpack_require__(22284);
// EXTERNAL MODULE: ./src/components/FAQs.tsx
var FAQs = __webpack_require__(70428);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Table.js + 1 modules
var Table = __webpack_require__(7906);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableBody/TableBody.js + 1 modules
var TableBody = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableRow/TableRow.js + 1 modules
var TableRow = __webpack_require__(53816);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableCell/TableCell.js + 1 modules
var TableCell = __webpack_require__(53252);
// EXTERNAL MODULE: ./src/utils/formatNumToString.ts
var formatNumToString = __webpack_require__(78542);
;// CONCATENATED MODULE: ./src/components/SeoStats.tsx




var classes = {
    careByNumContainer: function(theme) {
        return {
            margin: theme.spacing(4, 0)
        };
    },
    tableBody: function(theme) {
        return (0,_define_property/* default */.Z)({}, theme.breakpoints.up("sm"), {
            display: "flex",
            justifyContent: "center"
        });
    },
    careByNumText: function(theme) {
        return (0,_define_property/* default */.Z)({
            marginBottom: theme.spacing(3.25),
            lineHeight: "30px",
            fontWeight: 400,
            textAlign: "center"
        }, theme.breakpoints.up("sm"), {
            textAlign: "left"
        });
    },
    statRow: function(theme) {
        return (0,_define_property/* default */.Z)({
            width: "calc(50% - 1px)",
            display: "inline-block"
        }, theme.breakpoints.up("sm"), {
            width: "calc(25% - 1px)"
        });
    },
    statCell: function(theme) {
        return {
            width: "100%",
            height: "70px",
            display: "inline-block",
            textAlign: "center",
            padding: 0,
            borderBottom: "none",
            borderRight: "1px solid ".concat(theme.palette.care.grey[300])
        };
    },
    avgExpStat: function(theme) {
        return (0,_define_property/* default */.Z)({
            borderRight: "none",
            borderBottom: "1px solid ".concat(theme.palette.care.grey[300])
        }, theme.breakpoints.up("sm"), {
            borderRight: "1px solid ".concat(theme.palette.care.grey[300]),
            borderBottom: "none"
        });
    },
    statLabels: function(theme) {
        return (0,_define_property/* default */.Z)({}, theme.breakpoints.down("sm"), {
            marginBottom: theme.spacing(2.5)
        });
    },
    statValues: function(theme) {
        return (0,_define_property/* default */.Z)({}, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(3)
        });
    },
    noBorderRightDT: function(theme) {
        return (0,_define_property/* default */.Z)({}, theme.breakpoints.up("sm"), {
            borderRight: "none"
        });
    },
    noBorderRight: {
        borderRight: "none"
    },
    addBorderBottom: function(theme) {
        return (0,_define_property/* default */.Z)({
            borderBottom: "1px solid ".concat(theme.palette.care.grey[300])
        }, theme.breakpoints.up("sm"), {
            borderBottom: "none"
        });
    }
};
var numberFixTo = function(value) {
    return value === null || value === void 0 ? void 0 : value.toFixed(1);
};
var SeoStats = function(param) {
    var title = param.title, totalProviders = param.totalProviders, avgYearsOfExperience = param.avgYearsOfExperience, totalReviewCount = param.totalReviewCount, avgReviewRating = param.avgReviewRating;
    var showAvgYearsOfExp = avgYearsOfExperience !== null && avgYearsOfExperience > 0;
    var showTotalReviewCount = totalReviewCount !== null && totalReviewCount > 0;
    var showAvgReviewRating = avgReviewRating !== null && avgReviewRating > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: classes.careByNumContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h2",
                    color: "primary",
                    sx: classes.careByNumText,
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                    "aria-label": "care numbers",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableBody/* default */.Z, {
                        sx: classes.tableBody,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                                sx: classes.statRow,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                    sx: [
                                        classes.statCell,
                                        (showTotalReviewCount || showAvgReviewRating) && classes.addBorderBottom, 
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h2",
                                            color: "primary",
                                            children: (0,formatNumToString/* default */.Z)(totalProviders)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body3",
                                            color: "secondary",
                                            sx: classes.statLabels,
                                            children: "providers"
                                        })
                                    ]
                                })
                            }),
                            showAvgYearsOfExp && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                                sx: classes.statRow,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                    sx: [
                                        classes.statCell,
                                        (showTotalReviewCount || showAvgReviewRating) && classes.avgExpStat,
                                        !(showTotalReviewCount || showAvgReviewRating) && classes.noBorderRight, 
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "h2",
                                            color: "primary",
                                            children: [
                                                numberFixTo(avgYearsOfExperience),
                                                " yrs"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body3",
                                            color: "secondary",
                                            sx: classes.statLabels,
                                            children: "avg. experience"
                                        })
                                    ]
                                })
                            }),
                            showTotalReviewCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                                sx: classes.statRow,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                    sx: [
                                        classes.statCell,
                                        !showAvgReviewRating && classes.noBorderRight
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h2",
                                            color: "primary",
                                            sx: classes.statValues,
                                            children: (0,formatNumToString/* default */.Z)(totalReviewCount)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body3",
                                            color: "secondary",
                                            children: "member reviews"
                                        })
                                    ]
                                })
                            }),
                            showAvgReviewRating && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                                sx: classes.statRow,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                    sx: [
                                        classes.statCell,
                                        showTotalReviewCount && classes.noBorderRight,
                                        !showTotalReviewCount && classes.noBorderRightDT, 
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "h2",
                                            color: "primary",
                                            sx: classes.statValues,
                                            children: [
                                                numberFixTo(avgReviewRating),
                                                " / 5"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body3",
                                            color: "secondary",
                                            children: "avg. rating"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_SeoStats = (SeoStats);

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Drawer/Drawer.js
var Drawer = __webpack_require__(96040);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(86492);
var he_default = /*#__PURE__*/__webpack_require__.n(he);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ./src/utils/filtersStorage.ts
var filtersStorage = __webpack_require__(85627);
;// CONCATENATED MODULE: ./src/utils/filters.ts




var getMoreFilterValues = function(moreFilters) {
    var moreFiltersValues = {};
    moreFilters.forEach(function(element) {
        var item = constants/* MORE_FILTERS_LIST.find */.j4.find(function(x) {
            return x.value === element;
        });
        if (item && item.key) {
            var filter = {};
            filter[item.key] = true;
            moreFiltersValues = (0,_object_spread/* default */.Z)({}, moreFiltersValues, filter);
        }
    });
    return moreFiltersValues;
};
var filterMultiToggleValues = function(event, toggleValues) {
    var value = event.target.value;
    var existing = toggleValues.find(function(element) {
        return element === value;
    });
    var update = toggleValues.map(function(x) {
        return x;
    });
    if (existing === undefined) {
        update.push(value);
    } else {
        update.splice(update.findIndex(function(element) {
            return element === value;
        }), 1);
        var item = constants/* MORE_FILTERS_LIST.find */.j4.find(function(x) {
            return x.value === value;
        });
        if (item && item.key) {
            (0,filtersStorage/* removeFilter */.ku)(item.key);
        }
    }
    return update;
};
/*
 * Moving filter to top when its on bottom of screen in small screens
 */ var handleFilterAnimation = function(isMobile, ref, navID) {
    if (isMobile) {
        /**
     * Scroll filter to top of page accounting for the height of the sticky nav and some additional padding
     */ var element = ref.current;
        if (element) {
            var filteringOffSetY = (window.scrollY || window.pageYOffset) + element.getBoundingClientRect().top;
            var navMain = document.querySelector(navID);
            var navHeight = navMain ? navMain.scrollHeight : 0;
            window.scrollTo(0, filteringOffSetY - navHeight);
        }
    }
};
var getFilterData = function() {
    var data = {
        displayFilter: false,
        moreFilter: false,
        jobDetailsFilter: false
    };
    var filters = (0,filtersStorage/* loadFilters */.dm)();
    if (filters) {
        var filterKeys = Object.keys(filters).filter(function(x) {
            var returnVal = false;
            if (x !== "radius" && filters[x] !== null && !Number.isNaN(filters[x])) {
                returnVal = true;
            }
            if (typeof filters[x] === "string" && filters[x].length > 0) {
                returnVal = true;
            }
            return returnVal;
        });
        data.displayFilter = filterKeys.length > 0;
        data.moreFilter = filterKeys.includes("nonSmoker") || filterKeys.includes("hasCar");
        data.jobDetailsFilter = filterKeys.includes("newJobsOnly") || filterKeys.includes("jobStartingSoon");
    }
    return data;
};

;// CONCATENATED MODULE: ./src/utils/sortFilters.ts

/**
 * Sorts a filter Array to match the order of a "sorting" array
 * @param  {string} filtersArr filter to be sorted
 * @param  {string} argServiceIdForMember serviceIdForMember ID of current segment
 * @return {Array}  sorted array
 */ var sortFilters = function(filtersArr, argServiceIdForMember) {
    var sortArray = constants/* SEO_FILTERS_ORDER */.F0[argServiceIdForMember];
    try {
        return filtersArr.slice().sort(function(filter1, filter2) {
            return sortArray.indexOf(filter1) - sortArray.indexOf(filter2);
        });
    } catch (e) {
        return filtersArr;
    }
};
/* harmony default export */ var utils_sortFilters = (sortFilters);

// EXTERNAL MODULE: ./node_modules/@mui/material/FormGroup/FormGroup.js + 1 modules
var FormGroup = __webpack_require__(53457);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/FilterButton/FilterButton.js
var FilterButton = __webpack_require__(18181);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Checkbox/Checkbox.js + 9 modules
var Checkbox = __webpack_require__(23756);
;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/Age.tsx











var Age = function(props) {
    // Build initial schedule state based on PROVIDER_AGES
    var defaultAges = (0,react.useMemo)(function() {
        return constants/* PROVIDER_AGES.reduce */.hf.reduce(function(accum, age) {
            var ages = accum;
            // Add a new entry to the object and set its default value as false
            ages[age.value] = false;
            return ages;
        }, {});
    }, []);
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var ref = (0,react.useState)(defaultAges), state = ref[0], setState = ref[1];
    var ref1 = (0,react.useState)(false), isSelected = ref1[0], setIsSelected = ref1[1];
    var handleChange = function(event) {
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, event.target.name, event.target.checked)));
    };
    // create an array of checkbox names that are checked
    var getCheckedOptions = function(allCheckboxes) {
        return Object.entries(allCheckboxes).reduce(function(prevVal, curVal) {
            // if the item is checked, add it
            if (curVal[1]) {
                prevVal.push(curVal[0]);
            }
            return prevVal;
        }, []);
    };
    var handleApply = function() {
        var checkedOptions = getCheckedOptions(state);
        var ageData = {
            ages: checkedOptions
        };
        setIsSelected(checkedOptions.length > 0);
        (0,filtersStorage/* saveFilters */.HJ)(ageData, onChange);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, ageData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setState(defaultAges);
            setIsSelected(false);
        }
    }, [
        isClear,
        defaultAges
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        label: "Age",
        field: "interactive-component",
        selected: isSelected,
        onApply: handleApply,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
            children: constants/* PROVIDER_AGES.map */.hf.map(function(age) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        name: age.value,
                        onChange: handleChange,
                        checked: state[age.value]
                    }),
                    label: (0,he.decode)(age.label)
                }, age.value);
            })
        })
    });
};
/* harmony default export */ var LegacyFilters_Age = (Age);

// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/NativeSelect/NativeSelect.js
var NativeSelect = __webpack_require__(88566);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevron.js
var Icon24UtilityChevron = __webpack_require__(68720);
;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/Availability.tsx










var Availability = function(props) {
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var ref = (0,react.useState)({
        availability: ""
    }), available = ref[0], setAvailable = ref[1];
    var iconComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
            component: "select",
            height: "20px",
            width: "20px"
        });
    };
    var options = constants/* AVAILABILITIES.map */.km.map(function(availability) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
            value: availability.value,
            children: availability.label
        }, availability.label);
    });
    var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)({
            availability: available.availability === "" ? null : available.availability
        }, onChange);
        var amplitudeData = {
            availability: available.availability
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, amplitudeData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setAvailable({
                availability: ""
            });
        }
    }, [
        isClear
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        field: "Availability",
        label: "Availability",
        selected: available.availability !== "",
        onApply: handleApply,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
            variant: "standard",
            sx: {
                width: "325px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                fullWidth: true,
                onChange: function(e) {
                    return setAvailable((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, available), {
                        availability: e.target.value
                    }));
                },
                inputProps: {
                    name: "option",
                    id: "field-native-select"
                },
                value: available.availability,
                IconComponent: iconComponent,
                children: options
            })
        })
    });
};
/* harmony default export */ var LegacyFilters_Availability = (Availability);

// EXTERNAL MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js + 3 modules
var InputLabel = __webpack_require__(33841);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/TextField/TextField.js
var TextField = __webpack_require__(53340);
;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/Distance.tsx











var Distance = function(props) {
    var ref = (0,react.useState)({
        zipCode: "",
        milesFromZipCode: 5
    }), distance = ref[0], setDistance = ref[1];
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var iconComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
            component: "select",
            height: "20px",
            width: "20px"
        });
    };
    var options = constants/* MILES */.YK && constants/* MILES.map */.YK.map(function(mile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
            value: mile.value,
            children: mile.label
        }, mile.value);
    });
    /*
   * handle apply
   */ var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)({
            radius: {
                unit: globalTypes/* DistanceUnit.MILES */.Rb.MILES,
                value: distance.milesFromZipCode
            },
            zipcode: distance.zipCode
        }, onChange);
        var amplitudeData = {
            zipCode: distance.zipCode,
            milesFromZipCode: distance.milesFromZipCode
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, amplitudeData);
    };
    var handleMilesChange = function(e) {
        setDistance((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, distance), {
            milesFromZipCode: parseInt(e.target.value, 10)
        }));
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setDistance({
                zipCode: "",
                milesFromZipCode: 5
            });
        }
    }, [
        isClear
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        field: "Distance",
        label: "Distance",
        selected: Boolean(distance.zipCode && distance.milesFromZipCode),
        onApply: handleApply,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            spacing: 4,
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                        variant: "standard",
                        component: "fieldset",
                        fullWidth: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            id: "zip",
                            required: true,
                            InputLabelProps: {
                                shrink: false
                            },
                            name: "zip",
                            label: "Zip Code",
                            error: distance.zipCode.length < 5,
                            value: distance.zipCode,
                            onChange: function(e) {
                                return setDistance((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, distance), {
                                    zipCode: e.target.value
                                }));
                            },
                            sx: {
                                minWidth: 0
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                        variant: "standard",
                        component: "fieldset",
                        fullWidth: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                                htmlFor: "field-native-select",
                                children: "Within"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                                onChange: handleMilesChange,
                                inputProps: {
                                    name: "option",
                                    id: "field-native-select"
                                },
                                value: distance.milesFromZipCode,
                                IconComponent: iconComponent,
                                children: options
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var LegacyFilters_Distance = (Distance);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/PayRate.tsx










var PayRate = function(props) {
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange, isJobSearch = props.isJobSearch;
    var ref = (0,react.useState)({
        hourlyRate: ""
    }), payRate = ref[0], setPayRate = ref[1];
    var iconComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
            component: "select",
            height: "20px",
            width: "20px"
        });
    };
    var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)({
            hourlyRate: payRate.hourlyRate
        }, onChange);
        var amplitudeData = {
            hourlyRate: payRate.hourlyRate
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, amplitudeData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setPayRate({
                hourlyRate: ""
            });
        }
    }, [
        isClear
    ]);
    var renderPayRate = function() {
        if (isJobSearch) {
            return constants/* PAY_RATES_JOB */.$c;
        }
        return constants/* PAY_RATES */.N3;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        field: "Pay Rate",
        label: "Pay Rate",
        selected: Boolean(payRate.hourlyRate),
        onApply: handleApply,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
            variant: "standard",
            sx: {
                width: "325px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                    htmlFor: "demo-native-select",
                    children: isJobSearch ? "RATE PER HOUR" : "COST PER HOUR"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                    fullWidth: true,
                    onChange: function(e) {
                        return setPayRate((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payRate), {
                            hourlyRate: e.target.value
                        }));
                    },
                    inputProps: {
                        name: "option",
                        id: "field-native-select"
                    },
                    value: payRate.hourlyRate,
                    IconComponent: iconComponent,
                    children: renderPayRate().map(function(rate) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: rate.value,
                            children: rate.label
                        }, rate.label);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var LegacyFilters_PayRate = (PayRate);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/Services.tsx








var Services = function(props) {
    var ref = (0,react.useState)([]), filterState = ref[0], setFilterState = ref[1];
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange, serviceId = props.serviceId;
    var isSelected = function(value) {
        var existing = filterState.find(function(element) {
            return element === value;
        });
        return existing !== undefined;
    };
    var servicesList;
    var filterLabel = "Services";
    switch(serviceId){
        case constants/* ServiceId.SENIRCARE */.Xs.SENIRCARE:
            servicesList = constants/* SERVICES_LIST_SENIOR_CARE */.wv;
            break;
        case constants/* ServiceId.HOUSEKEEP */.Xs.HOUSEKEEP:
            servicesList = constants/* SERVICES_LIST_HOUSEKEEPING */.qk;
            break;
        case constants/* ServiceId.TUTORINGX */.Xs.TUTORINGX:
            servicesList = constants/* SERVICES_LIST_TUTORING */.Uw;
            filterLabel = "Subject Area";
            break;
        case constants/* ServiceId.PETCAREXX */.Xs.PETCAREXX:
            servicesList = constants/* SERVICES_LIST_PET_CARE */.$f;
            break;
        case constants/* ServiceId.CAREGIGSX */.Xs.CAREGIGSX:
            servicesList = constants/* SERVICES_LIST_CARE_GIGS */.rR;
            break;
        case constants/* ServiceId.SPCLNEEDS */.Xs.SPCLNEEDS:
            servicesList = constants/* SERVICES_LIST_SPECIAL_NEEDS */.de;
            break;
        default:
            break;
    }
    var handleFilterMultiToggle = function(event) {
        setFilterState(filterMultiToggleValues(event, filterState));
    };
    var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)({
            services: filterState
        }, onChange);
        var amplitudeData = {
            services: filterState
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, amplitudeData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setFilterState([]);
        }
    }, [
        isClear
    ]);
    var renderCheckbox = function(value, label) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                name: "options",
                checked: isSelected(value)
            }),
            label: label,
            onChange: handleFilterMultiToggle,
            value: value,
            sx: function(theme) {
                return {
                    padding: theme.spacing(0, 2.25)
                };
            }
        }, value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        field: "Services",
        label: filterLabel,
        selected: filterState.length > 0,
        onApply: handleApply,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
            variant: "standard",
            component: "fieldset",
            sx: {
                width: "325px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                children: servicesList && servicesList.map(function(service) {
                    return renderCheckbox(service.value, service.label);
                })
            })
        })
    });
};
/* harmony default export */ var LegacyFilters_Services = (Services);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/Schedule.tsx










var Schedule = function(props) {
    // Build initial schedule state based on PROVIDER_SCHEDULES
    var defaultSchedule = (0,react.useMemo)(function() {
        return constants/* PROVIDER_SCHEDULES.reduce */.Jd.reduce(function(accum, schedule) {
            var schedules = accum;
            // Add a new entry to the object and set its default value as false
            schedules[schedule.value] = false;
            return schedules;
        }, {});
    }, []);
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var ref = (0,react.useState)(defaultSchedule), state = ref[0], setState = ref[1];
    var ref1 = (0,react.useState)(false), isSelected = ref1[0], setIsSelected = ref1[1];
    var handleChange = function(event) {
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, event.target.name, event.target.checked)));
    };
    // create an array of checkbox names that are checked
    var getCheckedOptions = function(allCheckboxes) {
        return Object.entries(allCheckboxes).reduce(function(prevVal, curVal) {
            // if the item is checked, add it
            if (curVal[1]) {
                prevVal.push(curVal[0]);
            }
            return prevVal;
        }, []);
    };
    var handleApply = function() {
        var checkedOptions = getCheckedOptions(state);
        var ScheduleData = {
            schedule: checkedOptions
        };
        setIsSelected(checkedOptions.length > 0);
        (0,filtersStorage/* saveFilters */.HJ)(ScheduleData, onChange);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, ScheduleData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setState(defaultSchedule);
            setIsSelected(false);
        }
    }, [
        isClear,
        defaultSchedule
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        label: "Schedule",
        field: "interactive-component",
        selected: isSelected,
        onApply: handleApply,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
            children: constants/* PROVIDER_SCHEDULES.map */.Jd.map(function(schedule) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        name: schedule.value,
                        onChange: handleChange,
                        checked: state[schedule.value]
                    }),
                    label: schedule.label
                }, schedule.value);
            })
        })
    });
};
/* harmony default export */ var LegacyFilters_Schedule = (Schedule);

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Slider/Slider.js + 6 modules
var Slider = __webpack_require__(50734);
;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/Hours.tsx






var Hours = function(props) {
    var defaultHours = (0,react.useMemo)(function() {
        return [
            5,
            21
        ];
    }, []);
    var defaultIsOvernight = false;
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var ref = (0,react.useState)(defaultHours), hours = ref[0], setHours = ref[1];
    var ref1 = (0,react.useState)(defaultIsOvernight), isOvernight = ref1[0], setIsOvernight = ref1[1];
    var ref2 = (0,react.useState)(false), isSelected = ref2[0], setIsSelected = ref2[1];
    var onChangeTr = function(val) {
        /* istanbul ignore else (unreachable) */ if (Array.isArray(val)) {
            setHours(val);
        } else {
            setHours([
                val,
                val
            ]);
        }
    };
    var onChangeOvernight = function(e) {
        setIsOvernight(e.target.checked);
    };
    var formatTime = function(time) {
        return time < 10 ? "0".concat(time, ":00") : "".concat(time, ":00");
    };
    var handleApply = function() {
        var hoursData = {
            hours: {
                startTime: formatTime(hours[0]),
                endTime: formatTime(hours[1]),
                isOvernight: isOvernight
            }
        };
        setIsSelected(hours[0] !== defaultHours[0] || hours[1] !== defaultHours[1] || isOvernight !== defaultIsOvernight);
        (0,filtersStorage/* saveFilters */.HJ)(hoursData, onChange);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, hoursData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setHours(defaultHours);
            setIsOvernight(defaultIsOvernight);
            setIsSelected(false);
        }
    }, [
        isClear,
        defaultHours,
        defaultIsOvernight
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterButton/* default */.Z, {
        label: "Hours",
        field: "field",
        selected: isSelected,
        onApply: handleApply,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h3",
                component: "p",
                gutterBottom: true,
                children: "Daytime Hours:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                timeIncrements: 60,
                min: 5,
                max: 21,
                value: [
                    hours[0],
                    hours[1]
                ],
                marks: true,
                timeMode: true,
                unit: "",
                onChange: onChangeTr,
                sx: {
                    "& .MuiSlider-root": {
                        padding: "13px 0"
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: 0.5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        name: "isOvernight",
                        onChange: onChangeOvernight,
                        checked: isOvernight
                    }),
                    label: "Overnight hours"
                })
            })
        ]
    });
};
/* harmony default export */ var LegacyFilters_Hours = (Hours);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/YearsOfExp.tsx










var YearsOfExp = function(props) {
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var initialData = (0,react.useMemo)(function() {
        return {
            yearsOfExperience: ""
        };
    }, []);
    var ref = (0,react.useState)(initialData), experience = ref[0], setExperience = ref[1];
    var iconComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
            component: "select",
            height: "20px",
            width: "20px"
        });
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setExperience(initialData);
        }
    }, [
        isClear,
        initialData
    ]);
    var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)({
            yearsOfExperience: experience.yearsOfExperience === "" ? null : Number(experience.yearsOfExperience)
        }, onChange);
        var amplitudeData = {
            yearsOfExperience: experience.yearsOfExperience
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        field: "YearsOfExp",
        label: "Years Of Exp",
        selected: Boolean(experience.yearsOfExperience),
        onApply: handleApply,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
            variant: "standard",
            sx: {
                width: "325px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                fullWidth: true,
                onChange: function(e) {
                    return setExperience((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, experience), {
                        yearsOfExperience: e.target.value
                    }));
                },
                inputProps: {
                    name: "option",
                    id: "field-native-select"
                },
                value: experience.yearsOfExperience,
                IconComponent: iconComponent,
                children: constants/* EXPERIENCES.map */.UO.map(function(exp) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: exp.value,
                        children: exp.label
                    }, exp.label);
                })
            })
        })
    });
};
/* harmony default export */ var LegacyFilters_YearsOfExp = (YearsOfExp);

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Card/Card.js
var Card = __webpack_require__(37088);
// EXTERNAL MODULE: ./node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/MoreFilters.tsx










var ref = config_default()(), NEXT_ASSET_URL = ref.publicRuntimeConfig.NEXT_ASSET_URL;
var MoreFilters = function(props) {
    var ref = (0,react.useState)([]), moreFilters = ref[0], setMoreFilters = ref[1];
    var isClear = props.isClear, onChange = props.onChange, enrollmentURL = props.enrollmentURL, onClose = props.onClose;
    var isSelected = function(value, key) {
        var filters = (0,filtersStorage/* loadFilters */.dm)();
        var existing;
        existing = moreFilters.find(function(element) {
            return element === value;
        });
        if (existing === undefined && filters !== null) {
            existing = Object.keys(filters).find(function(element) {
                return element === key;
            });
        }
        return existing !== undefined;
    };
    var ref1 = (0,react.useState)(false), isUpdated = ref1[0], setIsUpdated = ref1[1];
    var handleFilterMultiToggle = function(event) {
        setMoreFilters(filterMultiToggleValues(event, moreFilters));
        setIsUpdated(true);
    };
    var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)(getMoreFilterValues(moreFilters), onChange);
        onClose();
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setMoreFilters([]);
        }
    }, [
        isClear
    ]);
    var renderCheckbox = function(value, label, disabled, key) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                disabled: disabled,
                name: "options",
                checked: isSelected(value, key)
            }),
            label: label,
            value: value,
            sx: function(theme) {
                return (0,_define_property/* default */.Z)({
                    display: "flex",
                    flexDirection: "row-reverse",
                    justifyContent: "space-between"
                }, theme.breakpoints.up("md"), {
                    display: "inline-flex",
                    flexDirection: "row"
                });
            },
            labelPlacement: "end",
            onChange: handleFilterMultiToggle
        }, value);
    };
    var handleJoinNowButton = function() {
        var amplitudeData = {
            cta_text: 'Join now (CTA within "more filters")'
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        p: 4,
        width: {
            md: "767px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h3",
                color: "primary",
                py: 1.25,
                px: 0.5,
                children: "More Filters"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                children: [
                    constants/* MORE_FILTERS_LIST.map */.j4.map(function(moreFilter) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 6,
                            py: 0.5,
                            px: {
                                xs: 0.5,
                                md: 2
                            },
                            children: renderCheckbox(moreFilter.value, moreFilter.label, moreFilter.disabled, moreFilter.key)
                        }, moreFilter.label);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden/* default */.Z, {
                        implementation: "css",
                        mdDown: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sx: {
                                    "& > img": {
                                        opacity: 0.2
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(NEXT_ASSET_URL, "/images/disabled-filters.png"),
                                    alt: "Caregiver Details",
                                    width: "100%",
                                    height: "90%"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                careVariant: "subtle",
                sx: function(theme) {
                    return (0,_define_property/* default */.Z)({
                        width: "300px",
                        top: "258px",
                        position: "fixed",
                        left: "37px",
                        zIndex: 1
                    }, theme.breakpoints.up("sm"), {
                        left: "230px"
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                    sx: function(theme) {
                        return {
                            padding: theme.spacing(4),
                            textAlign: "center"
                        };
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            children: "Create a free account to access all filters!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            href: enrollmentURL,
                            color: "primary",
                            variant: "contained",
                            sx: function(theme) {
                                return {
                                    marginTop: theme.spacing(4)
                                };
                            },
                            onClick: handleJoinNowButton,
                            children: "Join now"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mt: 2,
                textAlign: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "secondary",
                        variant: "outlined",
                        size: "small",
                        onClick: function() {
                            return onClose();
                        },
                        sx: function(theme) {
                            return {
                                marginRight: theme.spacing(2)
                            };
                        },
                        children: "Close"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "secondary",
                        variant: "contained",
                        disabled: !isUpdated,
                        onClick: handleApply,
                        size: "small",
                        children: "Apply"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LegacyFilters_MoreFilters = (MoreFilters);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/ExperienceWithAges.tsx








var ExperienceWithAges = function(props) {
    var ref = (0,react.useState)([]), filterState = ref[0], setFilterState = ref[1];
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var isSelected = function(value) {
        var existing = filterState.find(function(element) {
            return element === value;
        });
        return existing !== undefined;
    };
    var handleFilterMultiToggle = function(event) {
        setFilterState(filterMultiToggleValues(event, filterState));
    };
    var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)({
            experienceWithAges: filterState
        }, onChange);
        var amplitudeData = {
            services: filterState
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, amplitudeData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setFilterState([]);
        }
    }, [
        isClear
    ]);
    var renderCheckbox = function(value, label) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                name: "options",
                checked: isSelected(value)
            }),
            label: label,
            onChange: handleFilterMultiToggle,
            value: value,
            sx: function(theme) {
                return {
                    padding: theme.spacing(0, 2.25)
                };
            }
        }, value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        field: "Experience with Ages",
        label: "Experience with Ages",
        selected: filterState.length > 0,
        onApply: handleApply,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
            variant: "standard",
            component: "fieldset",
            sx: {
                width: "325px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                children: constants/* EXPERIENCE_WITH_AGES_LIST */.js && constants/* EXPERIENCE_WITH_AGES_LIST.map */.js.map(function(service) {
                    return renderCheckbox(service.value, service.label);
                })
            })
        })
    });
};
/* harmony default export */ var LegacyFilters_ExperienceWithAges = (ExperienceWithAges);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/JobDetails.tsx










var JobDetails_ref = config_default()(), JobDetails_NEXT_ASSET_URL = JobDetails_ref.publicRuntimeConfig.NEXT_ASSET_URL;
var JobDetails = function(props) {
    // Build initial schedule filterState
    var defaultFilterState = function() {
        var filters = (0,filtersStorage/* loadFilters */.dm)();
        return (0,_object_spread/* default */.Z)({
            jobsStartingSoon: false,
            newJobsOnly: false
        }, filters);
    };
    var ref = (0,react.useState)(defaultFilterState()), filterState = ref[0], setFilterState = ref[1];
    var isClear = props.isClear, onChange = props.onChange, enrollmentURL = props.enrollmentURL, onClose = props.onClose;
    var handleChange = function(event) {
        setFilterState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterState), (0,_define_property/* default */.Z)({}, event.target.name, event.target.checked)));
    };
    var handleApply = function() {
        (0,filtersStorage/* saveFilters */.HJ)(filterState, onChange);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, filterState);
        onClose();
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setFilterState({
                jobsStartingSoon: false,
                newJobsOnly: false
            });
        }
    }, [
        isClear
    ]);
    var handleJoinNowButton = function() {
        var amplitudeData = {
            cta_text: 'Join now (CTA within "job details")'
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        p: 4,
        width: {
            md: "767px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h3",
                color: "primary",
                py: 1.25,
                px: 0.5,
                children: "Job Details"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        md: 6,
                        py: 1.25,
                        px: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGroup/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        name: "jobsStartingSoon",
                                        onChange: handleChange,
                                        checked: filterState.jobsStartingSoon
                                    }),
                                    label: "Jobs starting soon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        name: "newJobsOnly",
                                        onChange: handleChange,
                                        checked: filterState.newJobsOnly
                                    }),
                                    label: "New jobs only"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden/* default */.Z, {
                        implementation: "css",
                        mdDown: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sx: {
                                    "& > img": {
                                        opacity: 0.2
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(JobDetails_NEXT_ASSET_URL, "/images/disabled-filters.png"),
                                    alt: "Job Details",
                                    width: "100%",
                                    height: "90%"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                careVariant: "subtle",
                sx: function(theme) {
                    return (0,_define_property/* default */.Z)({
                        width: "300px",
                        top: "258px",
                        position: "fixed",
                        left: "37px",
                        zIndex: 1
                    }, theme.breakpoints.up("sm"), {
                        left: "230px"
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                    sx: function(theme) {
                        return {
                            padding: theme.spacing(4),
                            textAlign: "center"
                        };
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            children: "Create a free account to access all filters!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            href: enrollmentURL,
                            rel: "nofollow",
                            color: "primary",
                            variant: "contained",
                            sx: function(theme) {
                                return {
                                    marginTop: theme.spacing(4)
                                };
                            },
                            onClick: handleJoinNowButton,
                            children: "Join now"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mt: 2,
                textAlign: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "secondary",
                        variant: "outlined",
                        size: "small",
                        onClick: function() {
                            return onClose();
                        },
                        sx: function(theme) {
                            return {
                                marginRight: theme.spacing(2)
                            };
                        },
                        children: "Close"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "secondary",
                        variant: "contained",
                        // disabled={!isUpdated}
                        onClick: handleApply,
                        size: "small",
                        children: "Apply"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LegacyFilters_JobDetails = (JobDetails);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/JobType.tsx










var JobTypeFilter = function(props) {
    var defaultState = (0,react.useMemo)(function() {
        return {
            jobType: constants/* JOB_TYPE_FILTER_OPTIONS.ANY */.G5.ANY
        };
    }, []);
    var handleClick = props.handleClick, isClear = props.isClear, onChange = props.onChange;
    var ref = (0,react.useState)(defaultState), state = ref[0], setState = ref[1];
    var ref1 = (0,react.useState)(false), isSelected = ref1[0], setIsSelected = ref1[1];
    var handleChange = function(event) {
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            jobType: event.target.value
        }));
    };
    var iconUtilityChevron = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
            component: "select",
            height: "20px",
            width: "20px"
        });
    };
    var handleApply = function() {
        var jobTypeData = {
            jobType: state.jobType
        };
        setIsSelected(true);
        (0,filtersStorage/* saveFilters */.HJ)(jobTypeData, onChange);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, jobTypeData);
    };
    (0,react.useEffect)(function() {
        if (isClear) {
            setState(defaultState);
            setIsSelected(false);
        }
    }, [
        isClear,
        defaultState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* default */.Z, {
        label: "Job Type",
        field: "Job Type",
        selected: isSelected,
        onApply: handleApply,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
            variant: "standard",
            sx: {
                width: "325px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                fullWidth: true,
                IconComponent: iconUtilityChevron,
                onChange: handleChange,
                value: state.jobType,
                inputProps: {
                    name: "jobType"
                },
                children: Object.entries(constants/* JOB_TYPE_FILTER_OPTIONS */.G5).map(function(jobType) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: jobType[0],
                        children: jobType[1]
                    }, jobType[0]);
                })
            })
        })
    });
};
/* harmony default export */ var JobType = (JobTypeFilter);

;// CONCATENATED MODULE: ./src/components/Filters/LegacyFilters/Filters.tsx
























var Filters_classes = {
    btnFilter: function(theme) {
        return {
            paddingLeft: theme.spacing(1.5),
            paddingRight: theme.spacing(1.5),
            width: "auto",
            height: theme.spacing(4),
            minWidth: theme.spacing(10),
            borderRadius: theme.spacing(1),
            borderColor: theme.palette.care.grey[300]
        };
    },
    clearAll: function(theme) {
        return (0,_define_property/* default */.Z)({
            marginLeft: theme.spacing(2.5),
            display: "inline",
            cursor: "pointer",
            color: "#015AC8"
        }, theme.breakpoints.down("md"), {
            marginLeft: theme.spacing(-1.5)
        });
    }
};
var Filters = function(param) {
    var searchFilters = param.searchFilters, searchResultsHeader = param.searchResultsHeader, onChange = param.onChange, searchFiltersRef = param.searchFiltersRef, enrollmentURL = param.enrollmentURL, serviceIdForMember = param.serviceIdForMember, serviceId = param.serviceId, showMoreFilters = param.showMoreFilters, showJobDetails = param.showJobDetails, searchingFor = param.searchingFor;
    var ref = (0,react.useState)(false), isSideDrawerOpen = ref[0], setIsSideDrawerOpen = ref[1];
    var ref1 = (0,react.useState)(false), isClear = ref1[0], setIsClear = ref1[1];
    var ref2 = (0,react.useState)(false), displayFilter = ref2[0], setDisplayFilter = ref2[1];
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var ref3 = (0,react.useState)(false), hasMoreFilters = ref3[0], setHasMoreFilters = ref3[1];
    var ref4 = (0,react.useState)(false), hasJobDetails = ref4[0], setHasJobDetails = ref4[1];
    // All job segmentation pages have the same filters
    var allJobFilters = [
        globalTypes/* SEOSegmentationSearchFilters.DISTANCE */.Iy.DISTANCE,
        globalTypes/* SEOSegmentationSearchFilters.JOB_TYPE */.Iy.JOB_TYPE,
        globalTypes/* SEOSegmentationSearchFilters.PAY_RATE */.Iy.PAY_RATE
    ];
    var handleApplyChanges = function() {
        var filterData = getFilterData();
        setDisplayFilter(filterData.displayFilter);
        setHasMoreFilters(filterData.moreFilter);
        setHasJobDetails(filterData.jobDetailsFilter);
        if (filterData.displayFilter && !isClear) {
            onChange();
        }
    };
    var trackEvent = function(filter) {
        return function() {
            var amplitudeData = {
                filter: filter
            };
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.clickOnSegmentationFilter */.Sj.clickOnSegmentationFilter, amplitudeData);
        };
    };
    var clearFiltersData = function() {
        (0,filtersStorage/* clearFilters */.K5)();
        setIsClear(true);
        handleApplyChanges();
    };
    // Call clearFilters function on page load to remove localStorage data from filters
    (0,react.useEffect)(function() {
        (0,filtersStorage/* clearFilters */.K5)();
    }, []);
    (0,react.useEffect)(function() {
        if (isClear) {
            setIsClear(false);
            onChange();
        }
    }, [
        isClear,
        onChange
    ]);
    var sideDrawerClose = function() {
        return setIsSideDrawerOpen(false);
    };
    var handleMobileAnimation = function() {
        return handleFilterAnimation(isMobile, searchFiltersRef, "#navMain");
    };
    var flipSideDrawer = function() {
        trackEvent("More Filters")();
        setIsSideDrawerOpen(!isSideDrawerOpen);
    };
    var renderFilterOptions = function(name) {
        switch(name){
            case globalTypes/* SEOSegmentationSearchFilters.AGE */.Iy.AGE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_Age, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            case globalTypes/* SEOSegmentationSearchFilters.AVAILABILITY */.Iy.AVAILABILITY:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_Availability, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            case globalTypes/* SEOSegmentationSearchFilters.DISTANCE */.Iy.DISTANCE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_Distance, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            case globalTypes/* SEOSegmentationSearchFilters.EXPERIENCE_WITH_AGES */.Iy.EXPERIENCE_WITH_AGES:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_ExperienceWithAges, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            case globalTypes/* SEOSegmentationSearchFilters.HOURS */.Iy.HOURS:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_Hours, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            case globalTypes/* SEOSegmentationSearchFilters.JOB_TYPE */.Iy.JOB_TYPE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobType, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            case globalTypes/* SEOSegmentationSearchFilters.PAY_RATE */.Iy.PAY_RATE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_PayRate, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges,
                    isJobSearch: showJobDetails
                });
            case globalTypes/* SEOSegmentationSearchFilters.SCHEDULE */.Iy.SCHEDULE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_Schedule, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            case globalTypes/* SEOSegmentationSearchFilters.SERVICES */.Iy.SERVICES:
            case globalTypes/* SEOSegmentationSearchFilters.SUBJECT_AREA */.Iy.SUBJECT_AREA:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_Services, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges,
                    serviceId: serviceId
                });
            case globalTypes/* SEOSegmentationSearchFilters.YEARS_OF_EXPERIENCE */.Iy.YEARS_OF_EXPERIENCE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_YearsOfExp, {
                    handleClick: trackEvent(name),
                    isClear: isClear,
                    onChange: handleApplyChanges
                });
            default:
                return null;
        }
    };
    var getFilters = function() {
        if (searchingFor === globalTypes/* SEOSegmentationSearchingFor.ALL_JOB */.yh.ALL_JOB || searchingFor === globalTypes/* SEOSegmentationSearchingFor.SEEKER_JOB */.yh.SEEKER_JOB) {
            return allJobFilters;
        }
        if (!searchFilters) return [];
        return utils_sortFilters(searchFilters, serviceIdForMember);
    };
    var filtersList = getFilters();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        pt: 3,
        ref: searchFiltersRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h2",
                fontWeight: "400",
                lineHeight: "24px",
                mb: 3,
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: sanitize_html_default()(he_default().decode(searchResultsHeader))
                },
                sx: function(theme) {
                    return {
                        color: theme.palette.care.grey[900]
                    };
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                children: [
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 10,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h4",
                                    color: "primary",
                                    mb: 1,
                                    children: "Filter by:"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 2,
                                children: displayFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    onClick: clearFiltersData,
                                    sx: Filters_classes.clearAll,
                                    children: "Clear All"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            overflowX: "scroll",
                            overflowY: "hidden",
                            whiteSpace: "nowrap",
                            "&::-ms-overflow-style": "none",
                            "&::-webkit-scrollbar": {
                                display: "none"
                            }
                        },
                        children: [
                            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                color: "primary",
                                display: "inline-block",
                                mr: 2,
                                children: "Filter by:"
                            }),
                            filtersList.map(function(filterOption) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    md: 11,
                                    display: "inline-block",
                                    mr: 2,
                                    onClick: handleMobileAnimation,
                                    children: renderFilterOptions(filterOption)
                                }, filterOption);
                            }),
                            showMoreFilters && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: hasMoreFilters ? "contained" : "outlined",
                                        sx: Filters_classes.btnFilter,
                                        color: hasMoreFilters ? "secondary" : "inherit",
                                        onClick: flipSideDrawer,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body3",
                                            children: "More Filters"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* SideDrawer */.jC, {
                                        open: isSideDrawerOpen,
                                        onClose: sideDrawerClose,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_MoreFilters, {
                                            onClose: sideDrawerClose,
                                            isClear: isClear,
                                            onChange: handleApplyChanges,
                                            enrollmentURL: enrollmentURL
                                        })
                                    })
                                ]
                            }),
                            showJobDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: hasJobDetails ? "contained" : "outlined",
                                        sx: Filters_classes.btnFilter,
                                        color: hasJobDetails ? "secondary" : "inherit",
                                        onClick: flipSideDrawer,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body3",
                                            children: "Job Details"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* SideDrawer */.jC, {
                                        open: isSideDrawerOpen,
                                        onClose: sideDrawerClose,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_JobDetails, {
                                            onClose: sideDrawerClose,
                                            isClear: isClear,
                                            onChange: handleApplyChanges,
                                            enrollmentURL: enrollmentURL
                                        })
                                    })
                                ]
                            }),
                            displayFilter && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                onClick: clearFiltersData,
                                sx: Filters_classes.clearAll,
                                children: "Clear All"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LegacyFilters_Filters = (Filters);

// EXTERNAL MODULE: ./src/components/SeoGlobalNavbar.tsx
var SeoGlobalNavbar = __webpack_require__(8410);
// EXTERNAL MODULE: ./src/components/SearchResults/Pagination.tsx
var Pagination = __webpack_require__(6551);
// EXTERNAL MODULE: ./src/components/ReadMore.tsx
var ReadMore = __webpack_require__(35492);
;// CONCATENATED MODULE: ./src/components/PageInfo.tsx



var PageInfo = function(param) {
    var segmentationIntro = param.segmentationIntro;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        my: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h2",
                color: "primary",
                mb: 3,
                lineHeight: "28px",
                fontWeight: "400",
                textAlign: {
                    xs: "center",
                    sm: "left"
                },
                children: segmentationIntro.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                implementation: "css",
                smUp: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* default */.Z, {
                    gutterBottom: true,
                    color: "textPrimary",
                    component: "div",
                    variant: "body2",
                    charLimit: 155,
                    value: segmentationIntro.description,
                    showMoreLabel: "more"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                implementation: "css",
                smDown: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    color: "textPrimary",
                    children: segmentationIntro.description
                })
            })
        ]
    });
};
/* harmony default export */ var components_PageInfo = (PageInfo);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@care/caregiver-profile-components/dist/components/HiredBy/HiredBy.js + 2 modules
var HiredBy = __webpack_require__(88008);
// EXTERNAL MODULE: ./src/components/AssistedBioIndicator.tsx
var AssistedBioIndicator = __webpack_require__(93282);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Rating/Rating.js + 7 modules
var Rating = __webpack_require__(37918);
;// CONCATENATED MODULE: ./src/components/SearchResults/ProfileReview.tsx






var ProfileReview = function(param) {
    var reviews = param.reviews;
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var amplitudeTrackingForShowMoreReview = function() {
        var amplitudeData = {
            feature_name: "Show More Review Content"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, amplitudeData);
    };
    var handleShowMoreReviewClick = function(e) {
        var target = e.target;
        if (target.tagName.toLowerCase() === "button") {
            setIsExpanded(!isExpanded);
            if (!isExpanded) {
                amplitudeTrackingForShowMoreReview();
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: reviews.map(function(review, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mr: {
                    xs: 2,
                    md: 0
                },
                minWidth: {
                    xs: "250px",
                    sm: "450px"
                },
                width: {
                    md: "100%"
                },
                children: !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    mt: 3,
                    p: {
                        xs: 1,
                        sm: 2
                    },
                    component: "div",
                    sx: function(theme) {
                        return {
                            borderRadius: "16px",
                            border: "1px solid ".concat(theme.palette.care.grey[400]),
                            display: {
                                xs: "block",
                                sm: "flex"
                            }
                        };
                    },
                    children: [
                        review.rating && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            flexShrink: "0",
                            display: {
                                xs: "flex",
                                sm: "block"
                            },
                            flexDirection: {
                                xs: "row-reverse",
                                sm: "row"
                            },
                            justifyContent: {
                                xs: "flex-end",
                                sm: "flex-start"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h1",
                                    component: "span",
                                    children: review.rating.toFixed(1)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    display: "block",
                                    whiteSpace: "nowrap",
                                    mt: 0.5,
                                    pr: {
                                        xs: "4px",
                                        sm: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                        name: "size-medium",
                                        size: "small",
                                        defaultValue: review.rating,
                                        readOnly: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            pl: {
                                sm: 2
                            },
                            component: "div",
                            flexDirection: {
                                xs: "column-reverse",
                                sm: "column"
                            },
                            display: "flex",
                            children: [
                                review.comment && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    display: "flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* default */.Z, {
                                        gutterBottom: true,
                                        color: "textPrimary",
                                        component: "div",
                                        variant: "body2",
                                        charLimit: 265,
                                        value: review.comment || "",
                                        showMoreLabel: "show more",
                                        showDoubleQuotes: true,
                                        onClick: function(e) {
                                            return handleShowMoreReviewClick(e);
                                        },
                                        sx: {
                                            ml: {
                                                sm: 3
                                            }
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    pl: {
                                        sm: 3
                                    },
                                    mb: {
                                        xs: 0.5
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                fontWeight: 700
                                            },
                                            children: review.reviewer.displayName || "Care member"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    mt: 3,
                    p: 2,
                    component: "div",
                    sx: function(theme) {
                        return {
                            borderRadius: "16px",
                            border: "1px solid ".concat(theme.palette.care.grey[400]),
                            display: "block"
                        };
                    },
                    children: [
                        review.rating && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            flexShrink: "0",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "block",
                                    whiteSpace: "nowrap",
                                    mt: 0.5,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                            name: "size-medium",
                                            size: "small",
                                            defaultValue: review.rating,
                                            readOnly: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h2",
                                            component: "span",
                                            children: review.rating.toFixed(1)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    display: "flex",
                                    alignItems: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "info1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                fontWeight: 700
                                            },
                                            children: review.reviewer.displayName || "Care member"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            flexDirection: "column",
                            display: "flex",
                            mt: 1,
                            children: review.comment && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                display: "flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* default */.Z, {
                                    gutterBottom: true,
                                    color: "textPrimary",
                                    component: "div",
                                    variant: "body2",
                                    charLimit: 210,
                                    value: review.comment || "",
                                    showMoreLabel: "show more",
                                    showDoubleQuotes: true,
                                    onClick: function(e) {
                                        return handleShowMoreReviewClick(e);
                                    },
                                    sx: {
                                        ml: {
                                            sm: 3
                                        }
                                    }
                                })
                            })
                        })
                    ]
                })
            }, "".concat(review.reviewer.displayName, "-").concat(index + 1));
        })
    });
};
/* harmony default export */ var SearchResults_ProfileReview = (ProfileReview);

// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Badge/Badge.js
var Badge = __webpack_require__(23887);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoBgcFilled.js
var Icon24InfoBgcFilled = __webpack_require__(66871);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoPremiumFilled.js
var Icon24InfoPremiumFilled = __webpack_require__(1743);
;// CONCATENATED MODULE: ./src/components/SearchResults/components/RobustCaregiverInfo.tsx








var RobustCaregiverInfo = function(param) {
    var caregiver = param.caregiver, url = param.url;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var targetValue = isMobileOrSmaller ? "" : "_blank";
    var _member = caregiver.member, displayName = _member.displayName, address = _member.address, isPremium = _member.isPremium, hasCareCheck = caregiver.hasCareCheck;
    var ref = (0,react.useState)({
        PREMIUM: false,
        BACKGROUND_CHECK: false
    }), tooltipsOpen = ref[0], setTooltipsOpen = ref[1];
    var handleTooltipOpen = function(badgeType) {
        setTooltipsOpen((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tooltipsOpen), (0,_define_property/* default */.Z)({}, badgeType, !tooltipsOpen[badgeType])));
    };
    var generateTooltip = function(title, icon, badgeType, tooltipHandler) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
            PopperProps: {
                disablePortal: true
            },
            title: title,
            placement: "bottom",
            arrow: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                "data-testid": "".concat(badgeType.toLowerCase(), "-badge"),
                onMouseOver: function() {
                    return tooltipHandler(badgeType);
                },
                icon: icon,
                sx: {
                    ml: 0.5,
                    mr: -1,
                    cursor: "pointer",
                    height: "100%",
                    position: "relative",
                    top: "3px"
                }
            })
        });
    };
    if (url === null) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
        variant: "link1",
        underline: "none",
        href: url,
        target: targetValue,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h2",
                children: displayName
            }),
            hasCareCheck && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    display: "inline-flex",
                    alignItems: "center",
                    children: generateTooltip("Background check - all caregivers must complete an initial screening in order to interact with families.", /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoBgcFilled/* default */.Z, {}), "BACKGROUND_CHECK", handleTooltipOpen)
                })
            }),
            isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    display: "inline-flex",
                    alignItems: "center",
                    children: generateTooltip("Premium Care.com member", /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoPremiumFilled/* default */.Z, {}), "PREMIUM", handleTooltipOpen)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            (address === null || address === void 0 ? void 0 : address.city) && (address === null || address === void 0 ? void 0 : address.state) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                component: "span",
                variant: "body1",
                children: [
                    address.city,
                    ", ",
                    address.state
                ]
            })
        ]
    });
};
/* harmony default export */ var components_RobustCaregiverInfo = (RobustCaregiverInfo);

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/ProfileAvatar/ProfileAvatar.js + 3 modules
var ProfileAvatar = __webpack_require__(90346);
// EXTERNAL MODULE: ./src/utils/getUserInitials.ts
var getUserInitials = __webpack_require__(7772);
;// CONCATENATED MODULE: ./src/components/SearchResults/components/CaregiverProfileAvatar.tsx






var CaregiverProfileAvatar = function(param) {
    var caregiver = param.caregiver, isClientSearchResultsQuery = param.isClientSearchResultsQuery;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var displayName = caregiver.member.displayName;
    var imgSize = function() {
        return isMobileOrSmaller ? "xLarge" : "squareSmall";
    };
    var _imageURL;
    var profileAvatarProps = {
        alt: "".concat(displayName, "'s Photo"),
        size: imgSize(),
        src: (_imageURL = caregiver.member.imageURL) !== null && _imageURL !== void 0 ? _imageURL : undefined,
        slotProps: {
            avatar: {
                imgProps: isClientSearchResultsQuery ? {
                    loading: "eager"
                } : {
                    loading: "lazy"
                }
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, profileAvatarProps), {
        children: (0,getUserInitials/* default */.Z)(displayName)
    }));
};
/* harmony default export */ var components_CaregiverProfileAvatar = (CaregiverProfileAvatar);

// EXTERNAL MODULE: ./src/utils/payRangeHelper.ts
var payRangeHelper = __webpack_require__(32150);
;// CONCATENATED MODULE: ./src/components/SearchResults/components/CaregiverPayRange.tsx



var CaregiverPayRange = function(param) {
    var caregiver = param.caregiver;
    var ref, ref1, ref2;
    var yearsOfExperience = caregiver.yearsOfExperience;
    var caregiverProfile = (ref = caregiver.profiles) === null || ref === void 0 ? void 0 : ref.commonCaregiverProfile;
    var payRangeText = (0,payRangeHelper/* default */.Z)((caregiverProfile === null || caregiverProfile === void 0 ? void 0 : (ref1 = caregiverProfile.payRange) === null || ref1 === void 0 ? void 0 : ref1.hourlyRateTo.amount) || "", (caregiverProfile === null || caregiverProfile === void 0 ? void 0 : (ref2 = caregiverProfile.payRange) === null || ref2 === void 0 ? void 0 : ref2.hourlyRateFrom.amount) || "", true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        variant: "h4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: payRangeText
            }),
            yearsOfExperience > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    " • ",
                    yearsOfExperience,
                    " yrs exp"
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CaregiverPayRange = (CaregiverPayRange);

;// CONCATENATED MODULE: ./src/components/SearchResults/components/CaregiverBioTitle.tsx


var CaregiverBioTitle = function(param) {
    var caregiver = param.caregiver;
    var ref;
    var caregiverProfile = (ref = caregiver.profiles) === null || ref === void 0 ? void 0 : ref.commonCaregiverProfile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "h4",
        children: caregiverProfile === null || caregiverProfile === void 0 ? void 0 : caregiverProfile.bio.title
    });
};
/* harmony default export */ var components_CaregiverBioTitle = (CaregiverBioTitle);

;// CONCATENATED MODULE: ./src/components/SearchResults/components/CaregiverRating.tsx



var CaregiverRating = function(param) {
    var caregiver = param.caregiver;
    var avgReviewRating = caregiver.avgReviewRating, numberOfReviews = caregiver.numberOfReviews;
    var ratingFixTo = function(rating) {
        return rating === null || rating === void 0 ? void 0 : rating.toFixed(1);
    };
    if (numberOfReviews <= 0 || avgReviewRating === null || avgReviewRating <= 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h1",
                component: "span",
                fontSize: {
                    md: "display3.fontSize"
                },
                children: ratingFixTo(avgReviewRating)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                        name: "size-medium",
                        size: "small",
                        defaultValue: avgReviewRating,
                        readOnly: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "body2",
                        children: [
                            "(",
                            numberOfReviews,
                            ")"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CaregiverRating = (CaregiverRating);

// EXTERNAL MODULE: ./node_modules/lodash-es/upperFirst.js + 7 modules
var upperFirst = __webpack_require__(58939);
;// CONCATENATED MODULE: ./src/utils/seededRandom.ts
/**
 * Generates a seeded random number generator function.
 *
 * This function uses a linear congruential generator (LCG) algorithm with a
 * modulus of 2147483647 (a prime number) and a multiplier of 16807.
 *
 * @param seed - The initial seed value to start the random number generation.
 * @returns A function that, when called, returns a pseudo-random number between 0 (inclusive) and 1 (exclusive).
 */ function seededRandom(seed) {
    // Ensure seed is positive by adding modulus if negative
    var initialValue = seed % 2147483647;
    if (initialValue <= 0) {
        initialValue += 2147483647;
    }
    var value = initialValue;
    return function() {
        value = value * 16807 % 2147483647;
        return value / 2147483647;
    };
}

;// CONCATENATED MODULE: ./src/utils/shuffleWithSeed.ts


/**
 * Shuffles an array using a seeded random number generator.
 *
 * @template T - The type of elements in the array.
 * @param {T[]} array - The array to shuffle.
 * @param {number} seed - The seed for the random number generator.
 * @returns {T[]} - The shuffled array.
 */ var shuffleWithSeed = function(array, seed) {
    var rng = seededRandom(seed);
    return (0,_to_consumable_array/* default */.Z)(array).sort(function() {
        return rng() - 0.5;
    });
};

;// CONCATENATED MODULE: ./src/utils/shuffleCaregiverServices.ts



var shuffleCaregiverServices = function(supportedServices, seed) {
    if (!supportedServices) return [];
    var services = Object.entries(supportedServices).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), service = _param[0], value = _param[1];
        return value && constants/* CAREGIVER_SERVICES */.tY[service] && constants/* CAREGIVER_SERVICES */.tY[service] !== "laundry";
    }).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), service = _param[0];
        return constants/* CAREGIVER_SERVICES */.tY[service];
    });
    return shuffleWithSeed(services.slice(0, 6), seed);
};
/* harmony default export */ var utils_shuffleCaregiverServices = (shuffleCaregiverServices);

// EXTERNAL MODULE: ./src/components/contexts/PageAttributesContext.tsx
var PageAttributesContext = __webpack_require__(73739);
;// CONCATENATED MODULE: ./src/components/SearchResults/components/CaregiverServices.tsx






var CaregiverServices = function(param) {
    var caregiver = param.caregiver;
    var ref;
    var displayName = caregiver.member.displayName, profiles = caregiver.profiles;
    var ref1 = (0,PageAttributesContext/* usePageAttributes */.l)(), _shuffleSeed = ref1.shuffleSeed, shuffleSeed = _shuffleSeed === void 0 ? 1 : _shuffleSeed;
    var ref2;
    var supportedServices = (ref2 = profiles === null || profiles === void 0 ? void 0 : (ref = profiles.commonCaregiverProfile) === null || ref === void 0 ? void 0 : ref.supportedServices) !== null && ref2 !== void 0 ? ref2 : null;
    var services = (0,react.useMemo)(function() {
        var servicesList = utils_shuffleCaregiverServices(supportedServices, shuffleSeed).map(function(service, idx) {
            return idx === 0 ? (0,upperFirst/* default */.Z)(service) : service;
        });
        if (servicesList.length >= 6) {
            return "".concat(servicesList.join(", "), " & more");
        }
        return servicesList.join(", ");
    }, [
        supportedServices,
        shuffleSeed
    ]);
    var displayServicesLabel = "".concat(displayName.slice(0, displayName.length - 3), " can also help with:", " ");
    if (services.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        alignItems: "center",
        mt: 1.5,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "span",
                variant: "body2",
                fontWeight: "700",
                children: displayServicesLabel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "span",
                variant: "body2",
                fontStyle: "italic",
                children: services
            })
        ]
    });
};
/* harmony default export */ var components_CaregiverServices = (CaregiverServices);

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Tag/Tag.js
var Tag = __webpack_require__(96670);
;// CONCATENATED MODULE: ./src/utils/shuffleCaregiverSkills.ts


// These are the only skills we want to show on the robust caregiver card
var CAREGIVER_SKILLS = {
    cprTrained: "CPR",
    earlyChildhoodEducation: "Early Education",
    firstAidTraining: "First Aid",
    specialNeedsCare: "Special Needs Care",
    trustlineCertifiedCalifornia: "Trustline Certified",
    certifiedNursingAssistant: "CNA",
    alzheimersOrDementiaExperience: "Alzheimers or Dementia Experience",
    homeHealthAideExperience: "Home Health Aide",
    licensedNurse: "Licensed Nurse",
    medicalEquipmentExperience: "Medical Equipment Experience",
    woundCare: "Wound Care",
    isBondedAndInsured: "Bonded and insured",
    isNappsCertified: "NAPPS Certified",
    isPSAMemberAndisInsured: "PSA member and insured",
    isRedCrossPetFirstAidCertified: "Red Cross Pet First Aid Certified"
};
var convertSkillsToStrings = function(qualities) {
    return Object.entries(qualities).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), skill = _param[0], value = _param[1];
        return value === true && CAREGIVER_SKILLS[skill];
    }).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), key = _param[0];
        return CAREGIVER_SKILLS[key];
    });
};
var shuffleCaregiverSkills = function(qualities, seed) {
    if (!qualities) return [];
    var mapQualities = convertSkillsToStrings(qualities);
    // return 0 - 2 caregiver services.
    return shuffleWithSeed(mapQualities.slice(0, 3), seed);
};
/* harmony default export */ var utils_shuffleCaregiverSkills = (shuffleCaregiverSkills);

;// CONCATENATED MODULE: ./src/components/SearchResults/components/CaregiverSkills.tsx






var CaregiverSkills = function(param) {
    var caregiver = param.caregiver;
    var ref;
    var caregiverProfile = (ref = caregiver.profiles) === null || ref === void 0 ? void 0 : ref.commonCaregiverProfile;
    var qualities = (caregiverProfile === null || caregiverProfile === void 0 ? void 0 : caregiverProfile.qualities) || null;
    var ref1 = (0,PageAttributesContext/* usePageAttributes */.l)(), _shuffleSeed = ref1.shuffleSeed, shuffleSeed = _shuffleSeed === void 0 ? 1 : _shuffleSeed;
    var shuffledSkills = (0,react.useMemo)(function() {
        return utils_shuffleCaregiverSkills(qualities, shuffleSeed);
    }, [
        qualities,
        shuffleSeed
    ]);
    if (shuffledSkills.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        alignItems: "center",
        mt: 1.5,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                component: "span",
                variant: "body2",
                fontWeight: "700",
                children: [
                    "Skills:",
                    " "
                ]
            }),
            shuffledSkills.map(function(value) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "span",
                    mr: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                        type: "green",
                        children: value
                    })
                }, "skill-tag-".concat(value));
            })
        ]
    });
};
/* harmony default export */ var components_CaregiverSkills = (CaregiverSkills);

;// CONCATENATED MODULE: ./src/components/SearchResults/components/CaregiverBio.tsx





var CaregiverBio = function(param) {
    var caregiver = param.caregiver;
    var ref;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var caregiverProfile = (ref = caregiver.profiles) === null || ref === void 0 ? void 0 : ref.commonCaregiverProfile;
    var ref1 = (0,react.useState)(false), isExpanded = ref1[0], setIsExpanded = ref1[1];
    var amplitudeTrackingForShowMoreBio = function() {
        var amplitudeData = {
            feature_name: "Show More Bio"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, amplitudeData);
    };
    var handleShowMoreBio = function(e) {
        var target = e.target;
        if (target.tagName.toLowerCase() === "button") {
            setIsExpanded(!isExpanded);
            if (!isExpanded) {
                amplitudeTrackingForShowMoreBio();
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* default */.Z, {
        gutterBottom: true,
        color: "textPrimary",
        component: "div",
        variant: "body2",
        charLimit: isMobileOrSmaller ? 210 : 330,
        value: (caregiverProfile === null || caregiverProfile === void 0 ? void 0 : caregiverProfile.bio.experienceSummary) || "",
        showMoreLabel: isExpanded ? "Less" : "show more",
        onClick: function(e) {
            return handleShowMoreBio(e);
        }
    });
};
/* harmony default export */ var components_CaregiverBio = (CaregiverBio);

;// CONCATENATED MODULE: ./src/components/SearchResults/components/RobustCaregiverCard.tsx















// eslint-disable-next-line complexity
var RobustCaregiverCard = function(param) {
    var caregiver = param.caregiver, caregiverReviews = param.caregiverReviews, isClientSearchResultsQuery = param.isClientSearchResultsQuery, url = param.url;
    var ref, ref1, ref2, ref3;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var isMediumOrLarger = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var hiredTimes = caregiver.hiredTimes;
    var caregiverProfile = (ref = caregiver.profiles) === null || ref === void 0 ? void 0 : ref.commonCaregiverProfile;
    var targetValue = isMobileOrSmaller ? "" : "_blank";
    var firstName = (ref1 = caregiver.member) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.displayName) === null || ref2 === void 0 ? void 0 : ref2.split(" ")[0];
    var ctaText = "See ".concat(firstName, "'s profile");
    var ref4;
    var isAiAssistedBio = (ref4 = caregiverProfile === null || caregiverProfile === void 0 ? void 0 : (ref3 = caregiverProfile.bio) === null || ref3 === void 0 ? void 0 : ref3.aiAssistedBio) !== null && ref4 !== void 0 ? ref4 : false;
    var handleCtaBtn = function(btnText) {
        var amplitudeData = {
            cta_text: btnText,
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, amplitudeData);
    };
    if (url === null) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mb: {
                    xs: 2
                },
                pb: {
                    xs: 0,
                    sm: 2
                },
                component: "div",
                "data-testid": "robust-caregiver-card",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        display: "flex",
                        pb: {
                            xs: 1,
                            md: 0.5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                pr: {
                                    xs: 1.5,
                                    md: 3
                                },
                                pt: {
                                    xs: 0.5,
                                    md: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: url,
                                    target: targetValue,
                                    "data-testid": "caregiver-avatar",
                                    underline: "none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CaregiverProfileAvatar, {
                                        caregiver: caregiver,
                                        isClientSearchResultsQuery: isClientSearchResultsQuery
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        display: "flex",
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RobustCaregiverInfo, {
                                                caregiver: caregiver,
                                                url: url
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CaregiverPayRange, {
                                                    caregiver: caregiver
                                                })
                                            }),
                                            (caregiverProfile === null || caregiverProfile === void 0 ? void 0 : caregiverProfile.bio.title) && isMediumOrLarger && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CaregiverBioTitle, {
                                                    caregiver: caregiver
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        display: "flex",
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CaregiverRating, {
                                                caregiver: caregiver
                                            }),
                                            isMediumOrLarger && url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                mt: 1,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    style: {
                                                        minWidth: "144px"
                                                    },
                                                    fullWidth: true,
                                                    role: "button",
                                                    color: "secondary",
                                                    component: "a",
                                                    href: url,
                                                    onClick: function() {
                                                        return handleCtaBtn("See profile");
                                                    },
                                                    size: "small",
                                                    variant: "contained",
                                                    children: "See profile"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    hiredTimes > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: {
                            xs: 0,
                            sm: 2
                        },
                        mb: {
                            xs: 2,
                            sm: 1
                        },
                        "data-testid": "desktop-hiredby",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HiredBy/* default */.Z, {
                            count: hiredTimes
                        })
                    }),
                    (caregiverProfile === null || caregiverProfile === void 0 ? void 0 : caregiverProfile.bio.title) && isMobileOrSmaller && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CaregiverBioTitle, {
                        caregiver: caregiver
                    }),
                    (caregiverProfile === null || caregiverProfile === void 0 ? void 0 : caregiverProfile.bio.experienceSummary) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CaregiverBio, {
                                    caregiver: caregiver
                                })
                            }),
                            isAiAssistedBio && /*#__PURE__*/ (0,jsx_runtime.jsx)(AssistedBioIndicator/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CaregiverServices, {
                        caregiver: caregiver
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CaregiverSkills, {
                        caregiver: caregiver
                    }),
                    caregiverReviews.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_ProfileReview, {
                                    reviews: caregiverReviews
                                })
                            })
                        })
                    })
                ]
            }),
            isMobileOrSmaller && url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: {
                    xs: 2,
                    sm: 3
                },
                pb: {
                    xs: 0,
                    sm: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    fullWidth: true,
                    role: "button",
                    color: "secondary",
                    component: "a",
                    href: url,
                    onClick: function() {
                        return handleCtaBtn(ctaText);
                    },
                    size: "medium",
                    variant: "contained",
                    children: ctaText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                ml: -2,
                mr: -2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var components_RobustCaregiverCard = (RobustCaregiverCard);

// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider_Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandDaycareCenters.js
var Icon48BrandDaycareCenters = __webpack_require__(56348);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandSmb.js
var Icon48BrandSmb = __webpack_require__(69606);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/config/theme/theme.js + 64 modules
var theme = __webpack_require__(33266);
;// CONCATENATED MODULE: ./src/components/SearchResults/components/ProviderAddress.tsx



var ProviderAddress = function(param) {
    var address = param.address;
    var addressLine1 = address.addressLine1, city = address.city, state = address.state;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(theme/* theme.breakpoints.down */.rS.breakpoints.down("sm"));
    if (isMobileOrSmaller) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        variant: "body2",
        children: [
            addressLine1,
            ", ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("wbr", {}),
            " ",
            city,
            ",\xa0",
            state
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        variant: "body2",
        children: [
            addressLine1,
            ", ",
            city,
            ", ",
            state
        ]
    });
};
/* harmony default export */ var components_ProviderAddress = (ProviderAddress);

;// CONCATENATED MODULE: ./src/components/SearchResults/components/ProviderRate.tsx




var RATE_TYPE = {
    PROVIDER_RATE: "PROVIDER_RATE",
    COSTIMATE: "COSTIMATE"
};
var ProviderRate = function(param) {
    var rateType = param.rateType, providerRate = param.providerRate;
    var serviceIdForMember = (0,PageAttributesContext/* usePageAttributes */.l)().serviceIdForMember;
    if (serviceIdForMember === constants/* ServiceIdForMember.HOUSING_LOCATION */.u2.HOUSING_LOCATION) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "h4",
        children: rateType === "PROVIDER_RATE" ? "Starting at $".concat(providerRate.rate.amount, "/").concat(constants/* RATE_DURATION_ABBREVIATIONS */.r7[providerRate.rateDuration]) : "Costimate: $".concat(providerRate.rate.amount, "/").concat(constants/* RATE_DURATION_ABBREVIATIONS */.r7[providerRate.rateDuration])
    });
};

;// CONCATENATED MODULE: ./src/components/SearchResults/components/ProviderRating.tsx



var ProviderRating = function(param) {
    var avgReviewRating = param.avgReviewRating, numberOfReviews = param.numberOfReviews;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        container: true,
        alignItems: isMobileOrSmaller ? "center" : "flex-end",
        alignContent: "center",
        justifyContent: "flex-end",
        spacing: isMobileOrSmaller ? 2 : 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: isMobileOrSmaller ? "h1" : "display3",
                    component: "span",
                    children: avgReviewRating.toFixed(1)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                item: true,
                xs: true,
                sm: 12,
                spacing: 1,
                justifyContent: isMobileOrSmaller ? "flex-start" : "flex-end",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                            name: "size-medium",
                            size: "medium",
                            defaultValue: avgReviewRating,
                            readOnly: true,
                            sx: {
                                display: "flex"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body2",
                            children: [
                                "(",
                                numberOfReviews,
                                ")"
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/SearchResults/ProviderSearchResult.tsx













var ProviderSearchResult_classes = {
    dayCareIcon: function(theme) {
        return {
            color: theme.palette.care.white,
            "& circle": {
                fill: theme.palette.care.white
            }
        };
    },
    images: function(theme) {
        return {
            "& img": {
                objectFit: "contain",
                backgroundColor: theme.palette.care.white
            }
        };
    }
};
var ProviderSearchResult = function(param) {
    var seoSegmentationProvider = param.seoSegmentationProvider, isClientSearchResultsQuery = param.isClientSearchResultsQuery, providerReviews = param.providerReviews, serviceId = param.serviceId, url = param.url;
    var ref;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var _provider = seoSegmentationProvider.provider, address = _provider.address, name = _provider.name, description = _provider.description, avgReviewRating = _provider.avgReviewRating, numberOfReviews = seoSegmentationProvider.numberOfReviews, costimate = seoSegmentationProvider.costimate, providerRate = seoSegmentationProvider.providerRate;
    var providerRateOrCostimate = providerRate !== null && providerRate !== void 0 ? providerRate : costimate;
    var rateType = providerRateOrCostimate && providerRate ? "PROVIDER_RATE" : "COSTIMATE";
    var urlThumbnail = (ref = seoSegmentationProvider.provider.logo) === null || ref === void 0 ? void 0 : ref.urlThumbnail;
    var profileAvatarProps = {
        alt: name !== null && name !== void 0 ? name : undefined,
        size: isMobileOrSmaller ? "xLarge" : "squareSmall",
        src: urlThumbnail !== null && urlThumbnail !== void 0 ? urlThumbnail : undefined,
        slotProps: {
            avatar: {
                imgProps: isClientSearchResultsQuery ? {
                    loading: "eager"
                } : {
                    loading: "lazy"
                }
            }
        },
        "data-testid": "dayCareIcon"
    };
    var smbPlaceholderIcon = serviceId === constants/* ServiceId.CHILDCARE */.Xs.CHILDCARE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandDaycareCenters/* default */.Z, {
        sx: ProviderSearchResult_classes.dayCareIcon
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandSmb/* default */.Z, {
        sx: ProviderSearchResult_classes.dayCareIcon
    });
    var targetValue = isMobileOrSmaller ? "" : "_blank";
    if (url === null) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        "data-testid": "providerSearchResult",
        mb: {
            xs: 3,
            sm: 3
        },
        px: {
            xs: 0,
            sm: 0
        },
        component: "div",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                justifyContent: "space-between",
                spacing: isMobileOrSmaller ? 2 : 4,
                mb: {
                    xs: 1,
                    sm: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        item: true,
                        sm: 9,
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    variant: "h3",
                                    underline: "none",
                                    href: url,
                                    target: targetValue,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, profileAvatarProps), {
                                        sx: ProviderSearchResult_classes.images,
                                        children: smbPlaceholderIcon
                                    }))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                item: true,
                                xs: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            underline: "none",
                                            href: url,
                                            target: targetValue,
                                            fontSize: "1.125em",
                                            children: name
                                        })
                                    }),
                                    address && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProviderAddress, {
                                        address: address
                                    }),
                                    providerRateOrCostimate && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderRate, {
                                        providerRate: providerRateOrCostimate,
                                        rateType: rateType
                                    })
                                ]
                            })
                        ]
                    }),
                    numberOfReviews > 0 && avgReviewRating !== null && avgReviewRating > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        container: true,
                        xs: 12,
                        sm: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderRating, {
                            avgReviewRating: avgReviewRating,
                            numberOfReviews: numberOfReviews
                        })
                    })
                ]
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                spacing: isMobileOrSmaller ? 2 : 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* default */.Z, {
                        gutterBottom: true,
                        color: "textPrimary",
                        component: "div",
                        variant: "body2",
                        charLimit: isMobileOrSmaller ? 210 : 300,
                        value: (0,he.decode)(description.replace(/<br\s*[/]?>/gi, "\n")) || "",
                        showMoreLabel: "show more",
                        onClick: function(e) {
                            return e.preventDefault();
                        }
                    })
                })
            }),
            providerReviews.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_ProfileReview, {
                reviews: providerReviews
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: {
                    xs: 3,
                    sm: 4
                },
                mx: -2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var SearchResults_ProviderSearchResult = (ProviderSearchResult);

;// CONCATENATED MODULE: ./src/components/SearchResults/components/RobustProfileReview.tsx






var RobustProfileReview = function(param) {
    var reviews = param.reviews;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var amplitudeTrackingForShowMoreReview = function() {
        var amplitudeData = {
            feature_name: "Show More Review Content"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, amplitudeData);
    };
    var handleShowMoreReviewClick = function(e) {
        var target = e.target;
        if (target.tagName.toLowerCase() === "button") {
            setIsExpanded(!isExpanded);
            if (!isExpanded) {
                amplitudeTrackingForShowMoreReview();
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: reviews.map(function(review, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    mt: 3,
                    p: 2,
                    component: "div",
                    sx: function(theme) {
                        return {
                            borderRadius: "16px",
                            border: "1px solid ".concat(theme.palette.care.grey[400])
                        };
                    },
                    children: [
                        !!review.rating && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                display: "block",
                                whiteSpace: "nowrap",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                    name: "size-medium",
                                    size: "small",
                                    defaultValue: review.rating,
                                    readOnly: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            mt: 1,
                            component: "div",
                            children: [
                                review.comment && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* default */.Z, {
                                        gutterBottom: true,
                                        color: "textPrimary",
                                        component: "div",
                                        variant: "body2",
                                        charLimit: 265,
                                        value: review.comment || "",
                                        showMoreLabel: "show more",
                                        showDoubleQuotes: true,
                                        onClick: function(e) {
                                            return handleShowMoreReviewClick(e);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    mt: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                fontWeight: 700
                                            },
                                            children: review.reviewer.displayName || "Care member"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }, "".concat(review.reviewer.displayName, "-").concat(index + 1));
        })
    });
};
/* harmony default export */ var components_RobustProfileReview = (RobustProfileReview);

// EXTERNAL MODULE: ./node_modules/lodash-es/shuffle.js + 6 modules
var shuffle = __webpack_require__(15607);
;// CONCATENATED MODULE: ./src/utils/shufflePhilosophies.ts


var PHILOSOPHIES = {
    outdoorNature: "Outdoor/nature",
    developmental: "Developmental (play-based)",
    montessori: "Montessori",
    faithBased: "Faith based",
    academic: "Academic",
    reggioeEmilia: "Reggio emilia",
    international: "International",
    cooperative: "Cooperative",
    waldorf: "Day Care",
    specialNeeds: "Special needs"
};
var shufflePhilosophies = function(philosophy) {
    if (!philosophy) return [];
    var philosophies = Object.entries(philosophy).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), item = _param[0], value = _param[1];
        return value && PHILOSOPHIES[item];
    }).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), item = _param[0];
        return PHILOSOPHIES[item];
    });
    return (0,shuffle/* default */.Z)(philosophies.slice(0, 6));
};
/* harmony default export */ var utils_shufflePhilosophies = (shufflePhilosophies);

;// CONCATENATED MODULE: ./src/components/SearchResults/components/Philosophies.tsx



var Philosophies = function(param) {
    var philosophies = param.philosophies;
    var philosophyList = utils_shufflePhilosophies(philosophies);
    var philosophy = philosophyList.length >= 6 ? "".concat(philosophyList.join(", "), " & more") : philosophyList.join(", ");
    if (!philosophy) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        alignItems: "center",
        mt: 1.5,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                component: "span",
                variant: "body2",
                fontWeight: "700",
                children: [
                    "Philosophy:",
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "span",
                variant: "body2",
                fontStyle: "italic",
                children: philosophy
            })
        ]
    });
};
/* harmony default export */ var components_Philosophies = (Philosophies);

;// CONCATENATED MODULE: ./src/utils/shuffleSchoolTypes.ts


var SCHOOL_TYPE = {
    preschool: "Preschool",
    kindergarten: "Kindergarten",
    inHomeFamily: "In-Home daycare",
    dayCare: "Day Care",
    childCareDayCare: "Child care"
};
var convertSchoolTypesToStrings = function(types) {
    return Object.entries(types).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), type = _param[0], value = _param[1];
        return value === true && SCHOOL_TYPE[type];
    }).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), key = _param[0];
        return SCHOOL_TYPE[key];
    });
};
var shuffleSchoolTypes = function(types) {
    if (!types) return [];
    var mapTypes = convertSchoolTypesToStrings(types);
    return (0,shuffle/* default */.Z)(mapTypes).slice(0, 3);
};
/* harmony default export */ var utils_shuffleSchoolTypes = (shuffleSchoolTypes);

;// CONCATENATED MODULE: ./src/components/SearchResults/components/SchoolTypes.tsx




var SchoolTypes = function(param) {
    var schoolTypes = param.schoolTypes;
    var shuffledSchoolTypes = utils_shuffleSchoolTypes(schoolTypes);
    if (!shuffledSchoolTypes.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        alignItems: "center",
        mt: 1.5,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                component: "span",
                variant: "body2",
                fontWeight: "700",
                children: [
                    "School type:",
                    " "
                ]
            }),
            shuffledSchoolTypes.map(function(value) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "span",
                    mr: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                        type: "green",
                        children: value
                    })
                }, "type-tag-".concat(value));
            })
        ]
    });
};
/* harmony default export */ var components_SchoolTypes = (SchoolTypes);

// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoStateLicense.js
var Icon24InfoStateLicense = __webpack_require__(91327);
;// CONCATENATED MODULE: ./src/components/SearchResults/components/ProviderLicenseVerified.tsx



var ProviderLicenseVerified = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoStateLicense/* default */.Z, {
                "data-testid": "providerLicenseVerified",
                sx: {
                    mr: 0.5
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h4",
                children: "State license verified"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/SearchResults/components/ProviderSeeProfile.tsx


var ProviderSeeProfile = function(param) {
    var url = param.url, onClick = param.onClick, isMobileOrSmaller = param.isMobileOrSmaller;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        fullWidth: isMobileOrSmaller,
        color: "secondary",
        component: "a",
        href: url,
        onClick: onClick,
        size: isMobileOrSmaller ? "medium" : "small",
        sx: {
            minWidth: isMobileOrSmaller ? "auto" : "144px"
        },
        variant: "contained",
        children: "See profile"
    });
};
/* harmony default export */ var components_ProviderSeeProfile = (ProviderSeeProfile);

;// CONCATENATED MODULE: ./src/components/SearchResults/components/RobustProviderCard.tsx


















var RobustProviderCard_classes = {
    dayCareIcon: function(theme) {
        return {
            color: theme.palette.care.white,
            "& circle": {
                fill: theme.palette.care.white
            }
        };
    },
    images: function(theme) {
        return {
            "& img": {
                objectFit: "contain",
                backgroundColor: theme.palette.care.white
            }
        };
    }
};
var RobustProviderCard = function(param) {
    var seoSegmentationProvider = param.seoSegmentationProvider, isClientSearchResultsQuery = param.isClientSearchResultsQuery, providerReviews = param.providerReviews, serviceId = param.serviceId, url = param.url, philosophies = param.philosophies, schoolTypes = param.schoolTypes, licenseVerified = param.licenseVerified;
    var ref;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var isMediumOrLarger = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var targetValue = isMobileOrSmaller ? "" : "_blank";
    var handleCtaBtn = function() {
        var amplitudeData = {
            cta_text: "See profile",
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, amplitudeData);
    };
    var _provider = seoSegmentationProvider.provider, address = _provider.address, name = _provider.name, description = _provider.description, avgReviewRating = _provider.avgReviewRating, numberOfReviews = seoSegmentationProvider.numberOfReviews, costimate = seoSegmentationProvider.costimate, providerRate = seoSegmentationProvider.providerRate;
    var providerRateOrCostimate = providerRate !== null && providerRate !== void 0 ? providerRate : costimate;
    var rateType = providerRateOrCostimate && providerRate ? "PROVIDER_RATE" : "COSTIMATE";
    var urlThumbnail = (ref = seoSegmentationProvider.provider.logo) === null || ref === void 0 ? void 0 : ref.urlThumbnail;
    var profileAvatarProps = {
        alt: name !== null && name !== void 0 ? name : undefined,
        size: isMobileOrSmaller ? "xLarge" : "squareSmall",
        src: urlThumbnail !== null && urlThumbnail !== void 0 ? urlThumbnail : undefined,
        slotProps: {
            avatar: {
                imgProps: isClientSearchResultsQuery ? {
                    loading: "eager"
                } : {
                    loading: "lazy"
                }
            }
        },
        "data-testid": "dayCareIcon"
    };
    var smbPlaceholderIcon = serviceId === constants/* ServiceId.CHILDCARE */.Xs.CHILDCARE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandDaycareCenters/* default */.Z, {
        sx: RobustProviderCard_classes.dayCareIcon
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandSmb/* default */.Z, {
        sx: RobustProviderCard_classes.dayCareIcon
    });
    if (url === null) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mb: {
                    xs: 2
                },
                pb: {
                    xs: 0,
                    sm: 2
                },
                component: "div",
                "data-testid": "robust-provider-card",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        justifyContent: "space-between",
                        spacing: isMobileOrSmaller ? 2 : 4,
                        mb: {
                            xs: 1,
                            sm: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                item: true,
                                sm: 9,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            variant: "h3",
                                            underline: "none",
                                            href: url,
                                            target: targetValue,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, profileAvatarProps), {
                                                sx: RobustProviderCard_classes.images,
                                                children: smbPlaceholderIcon
                                            }))
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                underline: "none",
                                                href: url,
                                                target: targetValue,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h2",
                                                    children: name
                                                })
                                            }),
                                            address && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProviderAddress, {
                                                address: address
                                            }),
                                            providerRateOrCostimate && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderRate, {
                                                providerRate: providerRateOrCostimate,
                                                rateType: rateType
                                            }),
                                            isMediumOrLarger && licenseVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderLicenseVerified, {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                item: true,
                                container: true,
                                xs: 12,
                                sm: 3,
                                children: [
                                    numberOfReviews > 0 && avgReviewRating !== null && avgReviewRating > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderRating, {
                                        avgReviewRating: avgReviewRating,
                                        numberOfReviews: numberOfReviews
                                    }),
                                    isMediumOrLarger && url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        mt: 1,
                                        sx: {
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            width: "100%"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProviderSeeProfile, {
                                            url: url,
                                            onClick: handleCtaBtn,
                                            isMobileOrSmaller: isMobileOrSmaller
                                        })
                                    })
                                ]
                            }),
                            isMobileOrSmaller && licenseVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: 2,
                                pl: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderLicenseVerified, {})
                            })
                        ]
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* default */.Z, {
                            gutterBottom: true,
                            color: "textPrimary",
                            component: "div",
                            variant: "body2",
                            charLimit: isMobileOrSmaller ? 210 : 300,
                            value: (0,he.decode)(description.replace(/<br\s*\/?>/gi, "\n")) || "",
                            showMoreLabel: "show more",
                            onClick: function(e) {
                                return e.preventDefault();
                            }
                        })
                    }),
                    philosophies && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Philosophies, {
                            philosophies: philosophies
                        })
                    }),
                    schoolTypes && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SchoolTypes, {
                            schoolTypes: schoolTypes
                        })
                    }),
                    providerReviews.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RobustProfileReview, {
                                    reviews: providerReviews
                                })
                            })
                        })
                    })
                ]
            }),
            isMobileOrSmaller && url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: {
                    xs: 2,
                    sm: 3
                },
                pb: {
                    xs: 0,
                    sm: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProviderSeeProfile, {
                    url: url,
                    onClick: handleCtaBtn,
                    isMobileOrSmaller: isMobileOrSmaller
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                ml: -2,
                mr: -2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var components_RobustProviderCard = (RobustProviderCard);

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/ReadMore/ReadMore.js
var ReadMore_ReadMore = __webpack_require__(8781);
;// CONCATENATED MODULE: ./src/components/SearchResults/components/ProviderReview.tsx






var ProviderReview = function(param) {
    var reviews = param.reviews;
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var amplitudeTrackingForShowMoreReview = function() {
        var amplitudeData = {
            feature_name: "Show More Review Content"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, amplitudeData);
    };
    var handleShowMoreReviewClick = function(e) {
        var target = e.target;
        if (target.tagName.toLowerCase() === "button") {
            setIsExpanded(!isExpanded);
            if (!isExpanded) {
                amplitudeTrackingForShowMoreReview();
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: reviews.map(function(review, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mr: {
                    xs: 2,
                    md: 0
                },
                minWidth: {
                    xs: "250px",
                    sm: "450px"
                },
                width: {
                    md: "100%"
                },
                children: !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mt: 3,
                    p: {
                        xs: 1,
                        sm: 2
                    },
                    component: "div",
                    sx: function(theme) {
                        return {
                            borderRadius: "16px",
                            border: "1px solid ".concat(theme.palette.care.grey[400]),
                            display: {
                                xs: "block",
                                sm: "flex"
                            }
                        };
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        component: "div",
                        flexDirection: {
                            xs: "column-reverse",
                            sm: "column"
                        },
                        display: "flex",
                        children: [
                            !!review.rating && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                display: "block",
                                whiteSpace: "nowrap",
                                pr: {
                                    xs: "4px",
                                    sm: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                    name: "size-medium",
                                    size: "small",
                                    defaultValue: review.rating,
                                    readOnly: true
                                })
                            }),
                            review.comment && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                display: "flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* default */.Z, {
                                    gutterBottom: true,
                                    color: "textPrimary",
                                    component: "div",
                                    variant: "body2",
                                    charLimit: 265,
                                    value: review.comment || "",
                                    showMoreLabel: "show more",
                                    showDoubleQuotes: true,
                                    onClick: function(e) {
                                        return handleShowMoreReviewClick(e);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mb: {
                                    xs: 0.5
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            fontWeight: 700
                                        },
                                        children: review.reviewer.displayName || "Care member"
                                    })
                                })
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    mt: 3,
                    p: 2,
                    component: "div",
                    sx: function(theme) {
                        return {
                            borderRadius: "16px",
                            border: "1px solid ".concat(theme.palette.care.grey[400]),
                            display: "block"
                        };
                    },
                    children: [
                        !!review.rating && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            flexShrink: "0",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                display: "block",
                                whiteSpace: "nowrap",
                                mt: 0.5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                    name: "size-medium",
                                    size: "small",
                                    defaultValue: review.rating,
                                    readOnly: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            flexDirection: "column",
                            display: "flex",
                            mt: 1,
                            children: [
                                review.comment && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    display: "flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* default */.Z, {
                                        gutterBottom: true,
                                        color: "textPrimary",
                                        component: "div",
                                        variant: "body2",
                                        charLimit: 210,
                                        value: review.comment || "",
                                        showMoreLabel: "show more",
                                        showDoubleQuotes: true,
                                        onClick: function(e) {
                                            return handleShowMoreReviewClick(e);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    display: "flex",
                                    alignItems: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "info1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                fontWeight: 700
                                            },
                                            children: review.reviewer.displayName || "Care member"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }, "".concat(review.reviewer.displayName, "-").concat(index + 1));
        })
    });
};
/* harmony default export */ var components_ProviderReview = (ProviderReview);

;// CONCATENATED MODULE: ./src/utils/shuffleProviderServices.ts




var convertServicesToStrings = function(attributes) {
    if (!attributes) return [];
    return Object.entries(attributes).flatMap(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        if (typeof value === "object" && value !== null) {
            return Object.entries(value).filter(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), isActive = _param[1];
                return isActive;
            }).map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 1), nestedKey = _param[0];
                return constants/* PROVIDER_SERVICES */.H0[nestedKey];
            });
        }
        return value && constants/* PROVIDER_SERVICES */.H0[key] ? [
            constants/* PROVIDER_SERVICES */.H0[key]
        ] : [];
    });
};
function shuffleProviderServices(attributes) {
    if (!attributes) return [];
    var services = convertServicesToStrings(attributes);
    var rooms = convertServicesToStrings(attributes.rooms);
    var providerServicesList = (0,_to_consumable_array/* default */.Z)(services).concat((0,_to_consumable_array/* default */.Z)(rooms)).filter(function(item) {
        return item !== undefined;
    });
    return (0,shuffle/* default */.Z)(providerServicesList.slice(0, 6));
}
/* harmony default export */ var utils_shuffleProviderServices = (shuffleProviderServices);

;// CONCATENATED MODULE: ./src/components/SearchResults/components/ProviderServices.tsx





var ProviderServices = function(param) {
    var attributes = param.attributes;
    var services = (0,react.useMemo)(function() {
        var servicesList = utils_shuffleProviderServices(attributes).map(function(service, idx) {
            return idx === 0 ? (0,upperFirst/* default */.Z)(service) : service;
        });
        if (servicesList.length >= 6) {
            return "".concat(servicesList.join(", "), " & more");
        }
        return servicesList.join(", ");
    }, [
        attributes
    ]);
    if (!services.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        alignItems: "center",
        mt: 1.5,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                component: "span",
                variant: "body2",
                fontWeight: "700",
                children: [
                    "Services:",
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "span",
                variant: "body2",
                fontStyle: "italic",
                children: services
            })
        ]
    });
};
/* harmony default export */ var components_ProviderServices = (ProviderServices);

;// CONCATENATED MODULE: ./src/utils/getProviderHighlights.ts


var PROVIDER_COMMUNITIES_TYPES = {
    assistedLiving: "Assisted living",
    continuingCare: "Continuing care",
    independentLiving: "Independent living",
    memoryCare: "Memory care",
    nursingHome: "Nursing home",
    retirementCommunity: "Retirement community"
};
function getProviderHighlights(attributes) {
    if (!attributes) return [];
    var highlights = Object.entries(attributes.communityTypes).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), item = _param[0], value = _param[1];
        return value && PROVIDER_COMMUNITIES_TYPES[item];
    }).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), item = _param[0];
        return PROVIDER_COMMUNITIES_TYPES[item];
    });
    return (0,_to_consumable_array/* default */.Z)(highlights);
}
/* harmony default export */ var utils_getProviderHighlights = (getProviderHighlights);

;// CONCATENATED MODULE: ./src/components/SearchResults/components/ProviderHighlights.tsx




var ProviderHighlights = function(param) {
    var attributes = param.attributes;
    var highlights = utils_getProviderHighlights(attributes);
    if (!highlights.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        alignItems: "center",
        mt: 1.5,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                component: "span",
                variant: "body2",
                fontWeight: "700",
                children: [
                    "Highlights:",
                    " "
                ]
            }),
            highlights.map(function(value) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "span",
                    mr: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                        type: "green",
                        children: value
                    })
                }, "highlights-tag-".concat(value));
            })
        ]
    });
};
/* harmony default export */ var components_ProviderHighlights = (ProviderHighlights);

;// CONCATENATED MODULE: ./src/components/SearchResults/components/RobustSmbProviderCard.tsx
















var RobustSmbProviderCard_classes = {
    dayCareIcon: function(theme) {
        return {
            color: theme.palette.care.white,
            "& circle": {
                fill: theme.palette.care.white
            }
        };
    },
    images: function(theme) {
        return {
            "& img": {
                objectFit: "contain",
                backgroundColor: theme.palette.care.white
            }
        };
    }
};
var RobustSmbProviderCard = function(param) {
    var seoSegmentationProvider = param.seoSegmentationProvider, isClientSearchResultsQuery = param.isClientSearchResultsQuery, providerReviews = param.providerReviews, seniorAssistedLivingCenterAttributes = param.seniorAssistedLivingCenterAttributes, licenseVerified = param.licenseVerified, url = param.url;
    var ref;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var isMediumOrLarger = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var _provider = seoSegmentationProvider.provider, address = _provider.address, name = _provider.name, description = _provider.description, avgReviewRating = _provider.avgReviewRating, numberOfReviews = seoSegmentationProvider.numberOfReviews, costimate = seoSegmentationProvider.costimate, providerRate = seoSegmentationProvider.providerRate;
    var providerRateOrCostimate = providerRate !== null && providerRate !== void 0 ? providerRate : costimate;
    var rateType = providerRateOrCostimate && providerRate ? "PROVIDER_RATE" : "COSTIMATE";
    var urlThumbnail = (ref = seoSegmentationProvider.provider.logo) === null || ref === void 0 ? void 0 : ref.urlThumbnail;
    var profileAvatarProps = {
        alt: name !== null && name !== void 0 ? name : undefined,
        size: isMobileOrSmaller ? "xLarge" : "squareSmall",
        src: urlThumbnail !== null && urlThumbnail !== void 0 ? urlThumbnail : undefined,
        slotProps: {
            avatar: {
                imgProps: isClientSearchResultsQuery ? {
                    loading: "eager"
                } : {
                    loading: "lazy"
                }
            }
        },
        "data-testid": "dayCareIcon"
    };
    var smbPlaceholderIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandSmb/* default */.Z, {
        sx: RobustSmbProviderCard_classes.dayCareIcon
    });
    var targetValue = isMobileOrSmaller ? "" : "_blank";
    var handleCtaBtn = function() {
        var amplitudeData = {
            cta_text: "See profile",
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, amplitudeData);
    };
    if (url === null) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mb: {
                    xs: 2
                },
                pb: {
                    xs: 0,
                    sm: 2
                },
                component: "div",
                "data-testid": "robust-provider-card",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        justifyContent: "space-between",
                        spacing: isMobileOrSmaller ? 2 : 4,
                        mb: {
                            xs: 1,
                            sm: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                item: true,
                                sm: 9,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            variant: "h3",
                                            underline: "none",
                                            href: url,
                                            target: targetValue,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, profileAvatarProps), {
                                                sx: RobustSmbProviderCard_classes.images,
                                                children: smbPlaceholderIcon
                                            }))
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                underline: "none",
                                                href: url,
                                                target: targetValue,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h2",
                                                    children: name
                                                })
                                            }),
                                            address && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProviderAddress, {
                                                address: address
                                            }),
                                            providerRateOrCostimate && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderRate, {
                                                providerRate: providerRateOrCostimate,
                                                rateType: rateType
                                            }),
                                            isMediumOrLarger && licenseVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderLicenseVerified, {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                item: true,
                                container: true,
                                xs: 12,
                                sm: 3,
                                children: [
                                    numberOfReviews > 0 && avgReviewRating !== null && avgReviewRating > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderRating, {
                                        avgReviewRating: avgReviewRating,
                                        numberOfReviews: numberOfReviews
                                    }),
                                    isMediumOrLarger && url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        mt: 1,
                                        sx: {
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            width: "100%"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProviderSeeProfile, {
                                            url: url,
                                            onClick: handleCtaBtn,
                                            isMobileOrSmaller: isMobileOrSmaller
                                        })
                                    }),
                                    isMobileOrSmaller && licenseVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        mt: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderLicenseVerified, {})
                                    })
                                ]
                            })
                        ]
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore_ReadMore/* default */.Z, {
                            gutterBottom: true,
                            color: "textPrimary",
                            component: "div",
                            variant: "body2",
                            charLimit: isMobileOrSmaller ? 210 : 300,
                            value: (0,he.decode)(description.replace(/<br\s*\/?>/gi, "\n")) || "",
                            showMoreLabel: "show more",
                            onClick: function(e) {
                                return e.preventDefault();
                            }
                        })
                    }),
                    seniorAssistedLivingCenterAttributes && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProviderServices, {
                            attributes: seniorAssistedLivingCenterAttributes
                        })
                    }),
                    (seniorAssistedLivingCenterAttributes === null || seniorAssistedLivingCenterAttributes === void 0 ? void 0 : seniorAssistedLivingCenterAttributes.communityTypes) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProviderHighlights, {
                            attributes: seniorAssistedLivingCenterAttributes
                        })
                    }),
                    providerReviews.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProviderReview, {
                                    reviews: providerReviews
                                })
                            })
                        })
                    })
                ]
            }),
            isMobileOrSmaller && url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: {
                    xs: 2,
                    sm: 3
                },
                pb: {
                    xs: 0,
                    sm: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProviderSeeProfile, {
                    url: url,
                    onClick: handleCtaBtn,
                    isMobileOrSmaller: isMobileOrSmaller
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                ml: -2,
                mr: -2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var components_RobustSmbProviderCard = (RobustSmbProviderCard);

// EXTERNAL MODULE: ./src/components/GAMAds.tsx
var GAMAds = __webpack_require__(5823);
// EXTERNAL MODULE: ./src/components/hooks/useLDClientFlags.tsx
var useLDClientFlags = __webpack_require__(32778);
;// CONCATENATED MODULE: ./src/components/SearchResults/SearchResults.tsx













var SearchResults = function(param) {
    var isClientSearchResultsQuery = param.isClientSearchResultsQuery, results = param.results, resultType = param.resultType, serviceId = param.serviceId, serviceIdForMember = param.serviceIdForMember;
    var ref = (0,useLDClientFlags/* useLDClientFlags */.y)(), GAMFlag = ref.SEO_3487_GAM_ADS_SEO_MFE;
    var pageTemplate = (0,PageAttributesContext/* usePageAttributes */.l)().pageTemplate;
    var gamAdIndexPositions = [
        1,
        6,
        11
    ];
    var gamAdSlotNames = [
        constants/* HTL_SLOTS.SEO_DIRECTORY_INLINE_1 */.YQ.SEO_DIRECTORY_INLINE_1,
        constants/* HTL_SLOTS.SEO_DIRECTORY_INLINE_2 */.YQ.SEO_DIRECTORY_INLINE_2,
        constants/* HTL_SLOTS.SEO_DIRECTORY_INLINE_3 */.YQ.SEO_DIRECTORY_INLINE_3, 
    ];
    var isCaregiverDirectoryPage = pageTemplate === common/* PageTemplate.CAREGIVER_DIRECTORY */.P.CAREGIVER_DIRECTORY;
    var showGAMAds = (GAMFlag === null || GAMFlag === void 0 ? void 0 : GAMFlag.variationIndex) === 1;
    var isProvider = constants/* SEARCH_RESULT_TYPE */.sM[resultType] === constants/* SEARCH_RESULT_TYPE.PROVIDER */.sM.PROVIDER;
    var dayCareRobustCardFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.SEO_3126_DAYCARE_ROBUST_CARDS.id */.WV.SEO_3126_DAYCARE_ROBUST_CARDS.id);
    var showRobustProviderCard = (dayCareRobustCardFlag === null || dayCareRobustCardFlag === void 0 ? void 0 : dayCareRobustCardFlag.variationIndex) === 1;
    var salcRobustProviderCardFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.SEO_3169_SALC_ROBUST_PROVIDER_CARDS.id */.WV.SEO_3169_SALC_ROBUST_PROVIDER_CARDS.id);
    var showRobustSmbProviderCard = (salcRobustProviderCardFlag === null || salcRobustProviderCardFlag === void 0 ? void 0 : salcRobustProviderCardFlag.variationIndex) === 1 || serviceIdForMember === constants/* ServiceIdForMember.SENIOR_CARE */.u2.SENIOR_CARE;
    var renderSearchResults = function(param) {
        var profile = param.profile, profileUrl = param.profileUrl, caregiverReviews = param.caregiverReviews, providerReviews = param.providerReviews;
        if (showRobustProviderCard && isProvider) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RobustProviderCard, {
                seoSegmentationProvider: profile.seoSegmentationProvider,
                isClientSearchResultsQuery: isClientSearchResultsQuery,
                serviceId: serviceId,
                providerReviews: providerReviews,
                url: profileUrl,
                philosophies: profile.philosophies,
                schoolTypes: profile.schoolTypes,
                licenseVerified: profile.licenseVerified
            });
        }
        if (isProvider && showRobustSmbProviderCard) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RobustSmbProviderCard, {
                seoSegmentationProvider: profile.seoSegmentationProvider,
                isClientSearchResultsQuery: isClientSearchResultsQuery,
                providerReviews: providerReviews,
                url: profileUrl,
                seniorAssistedLivingCenterAttributes: profile.seniorAssistedLivingCenterAttributes,
                licenseVerified: profile.licenseVerified
            });
        }
        if (isProvider) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_ProviderSearchResult, {
                seoSegmentationProvider: profile.seoSegmentationProvider,
                isClientSearchResultsQuery: isClientSearchResultsQuery,
                serviceId: serviceId,
                providerReviews: providerReviews,
                url: profileUrl
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RobustCaregiverCard, {
            caregiver: profile.caregiver,
            isClientSearchResultsQuery: isClientSearchResultsQuery,
            caregiverReviews: caregiverReviews,
            url: profileUrl
        });
    };
    var mappedResults = results.map(function(profile) {
        var profileUrl = profile.profileURL || null;
        var ref;
        var caregiverReviews = (ref = profile === null || profile === void 0 ? void 0 : profile.caregiverReviews) !== null && ref !== void 0 ? ref : [];
        var ref1;
        var providerReviews = (ref1 = profile === null || profile === void 0 ? void 0 : profile.providerReviews) !== null && ref1 !== void 0 ? ref1 : [];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: renderSearchResults({
                profile: profile,
                profileUrl: profileUrl,
                caregiverReviews: caregiverReviews,
                providerReviews: providerReviews
            })
        }, profileUrl);
    });
    if (showGAMAds && isCaregiverDirectoryPage && !isProvider) {
        var insertElementsAtPositions = function(array, elements, positions) {
            var newList = (0,_to_consumable_array/* default */.Z)(array);
            positions.forEach(function(position, index) {
                // only insert if the position is less than the length of the array
                if (position <= newList.length) {
                    newList.splice(position + index, 0, elements[index]);
                }
            });
            return newList;
        };
        var gamAds = gamAdSlotNames.map(function(slotName) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GAMAds/* GAMAds */.U, {
                slotName: slotName
            }, slotName);
        });
        var listingWithAds = insertElementsAtPositions(mappedResults, gamAds, gamAdIndexPositions);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: listingWithAds
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: mappedResults
    });
};
/* harmony default export */ var SearchResults_SearchResults = (SearchResults);

// EXTERNAL MODULE: ./src/utils/formatStartDate.ts
var formatStartDate = __webpack_require__(26008);
;// CONCATENATED MODULE: ./src/components/SearchResults/JobSearchResult.tsx









var JobSearchResult = function(param) {
    var job = param.job, isClientSearchResultsQuery = param.isClientSearchResultsQuery;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var _job = job.job, startDate = _job.startDate, title = _job.title, hourlyRateRange = _job.hourlyRateRange, city = job.city, state = job.state, seekerAvatar = job.seekerAvatar, description = job.description, type = job.type;
    var renderHourlyRateRange = function() {
        var output = "";
        if (hourlyRateRange && hourlyRateRange.hourlyRateTo && hourlyRateRange.hourlyRateFrom) {
            // \u2013 = EN DASH; \u2022 = Bullet
            output = "$".concat(hourlyRateRange.hourlyRateFrom.amount, " – $").concat(hourlyRateRange.hourlyRateTo.amount, "/hr •");
        }
        return output;
    };
    var formattedStartDate = (0,formatStartDate/* formatStartDate */.O)(startDate);
    var profileAvatarProps = {
        alt: "Photo for ".concat(title),
        size: isMobileOrSmaller ? "large" : "xLarge",
        src: seekerAvatar !== null && seekerAvatar !== void 0 ? seekerAvatar : undefined,
        slotProps: {
            avatar: {
                imgProps: isClientSearchResultsQuery ? {
                    loading: "eager"
                } : {
                    loading: "lazy"
                }
            }
        },
        "data-testid": "seekerAvatar"
    };
    var getElongatedTitle = function() {
        var defaultText = "About who needs care: ";
        var initialDescription = description.includes(defaultText) ? description.slice(defaultText.length) : description;
        return "".concat(title, " - ").concat(initialDescription).slice(0, 65).concat("...");
    };
    var elongatedTitle = getElongatedTitle();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, profileAvatarProps), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        height: "100%",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                component: "div",
                                width: "100%",
                                children: formattedStartDate.month.toLocaleUpperCase()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                component: "div",
                                width: "100%",
                                textAlign: "center",
                                fontSize: function(theme) {
                                    return isMobileOrSmaller ? theme.typography.h5.fontSize : theme.typography.h2.fontSize;
                                },
                                children: formattedStartDate.day.toUpperCase()
                            })
                        ]
                    })
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    ml: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h3",
                            color: "primary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mb: 0.5,
                                sx: function(theme) {
                                    return (0,_define_property/* default */.Z)({
                                        overflow: "hidden",
                                        display: "-webkit-box",
                                        "-webkit-line-clamp": 2,
                                        "-webkit-box-orient": "vertical"
                                    }, theme.breakpoints.up("sm"), {
                                        "-webkit-line-clamp": 1
                                    });
                                },
                                children: elongatedTitle
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            color: "primary",
                            sx: function(theme) {
                                return {
                                    fontSize: {
                                        md: theme.typography.h4.fontSize
                                    }
                                };
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                mb: 1,
                                children: [
                                    renderHourlyRateRange(),
                                    " ",
                                    type ? constants/* JOB_TYPES */.d9[type] : "",
                                    " • Starts",
                                    " ",
                                    formattedStartDate.month,
                                    "\xa0",
                                    formattedStartDate.day,
                                    " • ",
                                    city,
                                    ", ",
                                    state
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* default */.Z, {
                            gutterBottom: true,
                            color: "textPrimary",
                            component: "div",
                            variant: isMobileOrSmaller ? "body3" : "body2",
                            charLimit: 140,
                            value: description,
                            showMoreLabel: "more",
                            onClick: function(e) {
                                return e.preventDefault();
                            }
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var SearchResults_JobSearchResult = (JobSearchResult);

// EXTERNAL MODULE: ./src/components/SeoConversionBox.tsx
var SeoConversionBox = __webpack_require__(58291);
// EXTERNAL MODULE: ./src/components/hooks/useResponsive.tsx
var useResponsive = __webpack_require__(19147);
;// CONCATENATED MODULE: ./src/components/SearchResults/JobSearchResults.tsx










var JobSearchResults = function(param) {
    var _conversionHeader = param.conversionHeader, conversionHeader = _conversionHeader === void 0 ? null : _conversionHeader, enrollmentURL = param.enrollmentURL, isClientSearchResultsQuery = param.isClientSearchResultsQuery, pageType = param.pageType, resultType = param.resultType, results = param.results, _showConversionSectionFrequency = param.showConversionSectionFrequency, showConversionSectionFrequency = _showConversionSectionFrequency === void 0 ? 0 : _showConversionSectionFrequency;
    var ref = (0,useResponsive/* useResponsive */.F)(), isSmallViewport = ref.isSmallViewport, isMediumViewport = ref.isMediumViewport, isLargeViewport = ref.isLargeViewport;
    var ref1 = (0,useLDClientFlags/* useLDClientFlags */.y)(), GAMFlag = ref1.SEO_3487_GAM_ADS_SEO_MFE;
    var showGAMAds = (GAMFlag === null || GAMFlag === void 0 ? void 0 : GAMFlag.variationIndex) === 1;
    var gamAdIndexPositions = [
        1,
        6,
        11
    ];
    var gamAdSlotNames = [
        constants/* HTL_SLOTS.SEO_DIRECTORY_INLINE_1 */.YQ.SEO_DIRECTORY_INLINE_1,
        constants/* HTL_SLOTS.SEO_DIRECTORY_INLINE_2 */.YQ.SEO_DIRECTORY_INLINE_2,
        constants/* HTL_SLOTS.SEO_DIRECTORY_INLINE_3 */.YQ.SEO_DIRECTORY_INLINE_3, 
    ];
    var aboveTheFoldTestJobsFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.SEO_3217_ABOVE_THE_FOLD_CONVERSION_TEST_PROVIDERS.id */.WV.SEO_3217_ABOVE_THE_FOLD_CONVERSION_TEST_PROVIDERS.id);
    var isAboveTheFoldTestJobs = (aboveTheFoldTestJobsFlag === null || aboveTheFoldTestJobsFlag === void 0 ? void 0 : aboveTheFoldTestJobsFlag.variationIndex) === 2;
    var targetValue = isSmallViewport || isMediumViewport ? "" : "_blank";
    var showConversionCTASection = function(index) {
        return results.length > showConversionSectionFrequency && (index + 1) % showConversionSectionFrequency === 0 && results.length - 1 !== index;
    };
    var mappedResults = results.map(function(searchResult, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: 5,
                    children: searchResult.jobDetailURL && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: searchResult.jobDetailURL,
                        target: targetValue,
                        "aria-label": "profile-link",
                        style: {
                            textDecoration: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_JobSearchResult, {
                            job: searchResult.seoSegmentationJob,
                            isClientSearchResultsQuery: isClientSearchResultsQuery
                        })
                    })
                }),
                showConversionCTASection(index) && !isAboveTheFoldTestJobs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    "data-testid": "SeoConversionCTAs",
                    my: 4,
                    mx: -2,
                    bgcolor: "grey.100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoConversionBox/* default */.Z, {
                        pageType: pageType,
                        resultType: resultType,
                        header: conversionHeader,
                        enrollmentURL: enrollmentURL
                    })
                })
            ]
        }, searchResult.jobDetailURL);
    });
    var insertAdsAtPositions = function(list, ads, positions) {
        var newList = (0,_to_consumable_array/* default */.Z)(list);
        positions.forEach(function(position, index) {
            // only insert if the position is less than the length of the array
            if (position <= newList.length) {
                newList.splice(position + index, 0, ads[index]);
            }
        });
        return newList;
    };
    if (showGAMAds && (isSmallViewport || isMediumViewport)) {
        var gamAds = gamAdSlotNames.map(function(slotName) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GAMAds/* GAMAds */.U, {
                slotName: slotName
            }, slotName);
        });
        var listingWithAds = insertAdsAtPositions(mappedResults, gamAds, gamAdIndexPositions);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: listingWithAds
        });
    }
    if (showGAMAds && isLargeViewport) {
        var gamAds1 = [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GAMAds/* GAMAds */.U, {
                slotName: constants/* HTL_SLOTS.SEO_DIRECTORY_INLINE_1 */.YQ.SEO_DIRECTORY_INLINE_1
            }, constants/* HTL_SLOTS.SEO_DIRECTORY_INLINE_1 */.YQ.SEO_DIRECTORY_INLINE_1), 
        ];
        // place ad after the 10th profile card
        var gamAdIndexPos = [
            11
        ];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: insertAdsAtPositions(mappedResults, gamAds1, gamAdIndexPos)
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: mappedResults
    });
};
/* harmony default export */ var SearchResults_JobSearchResults = (JobSearchResults);

;// CONCATENATED MODULE: ./src/components/SearchResults/ArchivedJobSearchResult.tsx







var ArchivedJobSearchResult = function(param) {
    var job = param.job;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var description = job.description, title = job.title, type = job.type;
    var profileAvatarProps = {
        alt: "Photo for seeker",
        size: isMobileOrSmaller ? "large" : "xLarge",
        src: ""
    };
    var getElongatedTitle = function() {
        var defaultText = "About who needs care: ";
        var initialDescription = description.includes(defaultText) ? description.slice(defaultText.length) : description;
        return "".concat(title, " - ").concat(initialDescription).slice(0, 65).concat("...");
    };
    var elongatedTitle = getElongatedTitle();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* default */.Z, (0,_object_spread/* default */.Z)({}, profileAvatarProps)),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    ml: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h3",
                            color: "primary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mb: 0.5,
                                sx: function(theme) {
                                    return (0,_define_property/* default */.Z)({
                                        overflow: "hidden",
                                        display: "-webkit-box",
                                        "-webkit-line-clamp": 2,
                                        "-webkit-box-orient": "vertical"
                                    }, theme.breakpoints.up("sm"), {
                                        "-webkit-line-clamp": 1
                                    });
                                },
                                children: elongatedTitle
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            color: "primary",
                            sx: function(theme) {
                                return {
                                    fontSize: {
                                        md: theme.typography.h4.fontSize
                                    }
                                };
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mb: 1,
                                children: type ? constants/* JOB_TYPES */.d9[type] : ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* default */.Z, {
                            gutterBottom: true,
                            color: "textPrimary",
                            component: "div",
                            variant: isMobileOrSmaller ? "body3" : "body2",
                            charLimit: 140,
                            value: description,
                            showMoreLabel: "more",
                            onClick: function(e) {
                                return e.preventDefault();
                            }
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var SearchResults_ArchivedJobSearchResult = (ArchivedJobSearchResult);

;// CONCATENATED MODULE: ./src/components/SearchResults/ArchivedJobSearchResults.tsx




var ArchivedJobSearchResults = function(param) {
    var city = param.city, _conversionHeader = param.conversionHeader, conversionHeader = _conversionHeader === void 0 ? null : _conversionHeader, enrollmentURL = param.enrollmentURL, pageType = param.pageType, results = param.results, resultType = param.resultType;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var targetValue = isMobileOrSmaller ? "" : "_blank";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                "data-testid": "SeoConversionCTAs",
                my: 4,
                mx: -2,
                bgcolor: "grey.100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoConversionBox/* default */.Z, {
                    pageType: pageType,
                    resultType: resultType,
                    header: conversionHeader,
                    enrollmentURL: enrollmentURL
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: {
                    xs: 0,
                    sm: 6
                },
                mb: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    align: "left",
                    variant: "h2",
                    fontWeight: "400",
                    children: [
                        "Previous Jobs in ",
                        city
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    align: "left",
                    variant: "body1",
                    children: "See some jobs that were posted or filled recently."
                })
            }),
            results.map(function(searchResult, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mb: 5,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: enrollmentURL,
                            target: targetValue,
                            "aria-label": "profile-link",
                            style: {
                                textDecoration: "none"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_ArchivedJobSearchResult, {
                                job: searchResult.seoSegmentationArchivedJob
                            })
                        })
                    })
                }, "".concat(searchResult.seoSegmentationArchivedJob.type, "-").concat(idx + 1));
            })
        ]
    });
};
/* harmony default export */ var SearchResults_ArchivedJobSearchResults = (ArchivedJobSearchResults);

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Loader/Loader.js
var Loader = __webpack_require__(4806);
;// CONCATENATED MODULE: ./src/components/SearchResults/Loading.tsx



var Loading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            mx: "auto",
            mt: 2,
            mb: 6,
            textAlign: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {
                message: "Loading results"
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/SearchResults/NoResults.tsx







var NoResults = function() {
    var ref = (0,PageAttributesContext/* usePageAttributes */.l)(), seoPageId = ref.seoPageId, serviceIdForMember = ref.serviceIdForMember, deviceChar = ref.deviceChar, pageType = ref.pageType;
    (0,react.useEffect)(function() {
        var pageProperties = {
            screen_name: constants/* ScreenName.SEGMENTATION */.CG.SEGMENTATION,
            screen_template: constants/* ScreenTemplate.SEGMENTATION */.Yj.SEGMENTATION,
            seo_page_id: Number(seoPageId),
            service_id_for_member: serviceIdForMember,
            slots: constants/* TealiumSlot.VISITOR */.vm.VISITOR
        };
        if (deviceChar && Object.keys(deviceChar).length > 0) {
            (0,analyticsHelper/* setPagePropertiesFromData */.UP)(pageProperties);
            (0,analyticsHelper/* setDeviceDataFromHeaders */.xF)(deviceChar);
        }
        var errorViewedData = {
            seo_page_type: (0,upperFirst/* default */.Z)(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase()),
            error_description: "SEO no results",
            service_id_for_member: serviceIdForMember
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.errorViewed */.Sj.errorViewed, errorViewedData);
    }, [
        deviceChar,
        pageType,
        seoPageId,
        serviceIdForMember
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            pb: 4,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h2",
                        component: "h3",
                        color: "primary",
                        children: "Sorry!"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body3",
                    color: "primary",
                    children: "There are no results in this category near your location. Please try searching for another category of results or changing your location."
                })
            ]
        })
    });
};
/* harmony default export */ var SearchResults_NoResults = (NoResults);

;// CONCATENATED MODULE: ./src/components/SearchResults/HybridSearchResults.tsx






var HybridSearchResults = function(param) {
    var caregiverSearchResults = param.caregiverSearchResults, isClientSearchResultsQuery = param.isClientSearchResultsQuery, providerSearchResults = param.providerSearchResults, serviceId = param.serviceId, smbHeadline = param.smbHeadline, serviceIdForMember = param.serviceIdForMember;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_SearchResults, {
                results: caregiverSearchResults,
                resultType: constants/* SEARCH_RESULT_TYPE.CAREGIVER */.sM.CAREGIVER,
                isClientSearchResultsQuery: isClientSearchResultsQuery,
                serviceId: serviceId,
                serviceIdForMember: serviceIdForMember
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                align: "center",
                variant: "h3",
                my: 4,
                dangerouslySetInnerHTML: {
                    __html: sanitize_html_default()(he_default().decode(smbHeadline))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_SearchResults, {
                results: providerSearchResults,
                resultType: constants/* SEARCH_RESULT_TYPE.PROVIDER */.sM.PROVIDER,
                isClientSearchResultsQuery: isClientSearchResultsQuery,
                serviceId: serviceId,
                serviceIdForMember: serviceIdForMember
            })
        ]
    });
};
/* harmony default export */ var SearchResults_HybridSearchResults = (HybridSearchResults);

;// CONCATENATED MODULE: ./src/components/SearchResults/ItemListSchema.tsx

var ItemListSchema = function(param) {
    var results = param.results, totalNumberOfResults = param.totalNumberOfResults, startIndex = param.startIndex;
    var createListItems = function() {
        return results.map(function(searchResult, index) {
            if ("caregiver" in searchResult) {
                var ref;
                var caregiverProfile = (ref = searchResult.caregiver.profiles) === null || ref === void 0 ? void 0 : ref.commonCaregiverProfile;
                return {
                    "@type": "WebPage",
                    name: "".concat(searchResult.caregiver.member.displayName, " ").concat(caregiverProfile === null || caregiverProfile === void 0 ? void 0 : caregiverProfile.bio.title),
                    url: "".concat(searchResult.profileURL),
                    position: startIndex + index + 1
                };
            }
            var _jobDetailURL;
            return {
                "@type": "ListItem",
                url: (_jobDetailURL = searchResult.jobDetailURL) !== null && _jobDetailURL !== void 0 ? _jobDetailURL : "",
                position: startIndex + index + 1
            };
        });
    };
    var itemList = {
        "@context": {
            "@vocab": "http://schema.org/"
        },
        "@type": "ItemList",
        numberOfItems: totalNumberOfResults,
        itemListElement: createListItems()
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        "data-testid": "itemListSchema",
        type: "application/ld+json",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(itemList)
        }
    });
};
/* harmony default export */ var SearchResults_ItemListSchema = (ItemListSchema);

;// CONCATENATED MODULE: ./src/components/SearchResults/LocalBusinessSchema.tsx



var LocalBusinessSchema = function(param) {
    var results = param.results;
    var serviceIdForMember = (0,PageAttributesContext/* usePageAttributes */.l)().serviceIdForMember;
    var schemaType = serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE */.u2.CHILD_CARE || serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE_LOCATION */.u2.CHILD_CARE_LOCATION ? "ChildCare" : "LocalBusiness";
    var LocalBusinessList = function() {
        return results.map(function(searchResult) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            var rateAmount = ((ref = searchResult.seoSegmentationProvider.providerRate) === null || ref === void 0 ? void 0 : ref.rate.amount) || ((ref1 = searchResult.seoSegmentationProvider.costimate) === null || ref1 === void 0 ? void 0 : ref1.rate.amount);
            var rateDuration = ((ref2 = searchResult.seoSegmentationProvider.providerRate) === null || ref2 === void 0 ? void 0 : ref2.rateDuration) || ((ref3 = searchResult.seoSegmentationProvider.costimate) === null || ref3 === void 0 ? void 0 : ref3.rateDuration);
            var hasCostimate = searchResult.seoSegmentationProvider.costimate;
            var localBusiness = {
                "@context": "http://schema.org/",
                "@type": schemaType,
                name: searchResult.seoSegmentationProvider.provider.name,
                image: (ref4 = searchResult.seoSegmentationProvider.provider.logo) === null || ref4 === void 0 ? void 0 : ref4.urlThumbnail,
                address: {
                    "@type": "PostalAddress",
                    addressLocality: (ref5 = searchResult.seoSegmentationProvider.provider.address) === null || ref5 === void 0 ? void 0 : ref5.city,
                    addressRegion: (ref6 = searchResult.seoSegmentationProvider.provider.address) === null || ref6 === void 0 ? void 0 : ref6.state
                }
            };
            if (rateAmount && rateDuration) {
                localBusiness.priceRange = hasCostimate ? "Costimate: $".concat(rateAmount, "/").concat(constants/* RATE_DURATION_ABBREVIATIONS */.r7[rateDuration]) : "Starting at $".concat(rateAmount, "/").concat(constants/* RATE_DURATION_ABBREVIATIONS */.r7[rateDuration]);
            }
            return localBusiness;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        "data-testid": "localBusinessSchema",
        type: "application/ld+json",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(LocalBusinessList())
        }
    });
};
/* harmony default export */ var SearchResults_LocalBusinessSchema = (LocalBusinessSchema);

;// CONCATENATED MODULE: ./src/components/SearchResults/ProductSchema.tsx


var ProductSchema = function(param) {
    var avgReviewRating = param.avgReviewRating, totalReviewCount = param.totalReviewCount;
    var segmentNamePluralLowerCase = (0,PageAttributesContext/* usePageAttributes */.l)().segmentNamePluralLowerCase;
    var nameTitle = segmentNamePluralLowerCase.charAt(0).toUpperCase() + segmentNamePluralLowerCase.slice(1);
    var ProductSchemaList = function() {
        var roundAvgReviewRating = avgReviewRating ? avgReviewRating.toFixed(1) : null;
        var product = {
            "@context": "https://schema.org",
            "@type": "Product",
            name: nameTitle,
            brand: {
                "@type": "Organization",
                name: "Care.com"
            },
            aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: roundAvgReviewRating,
                reviewCount: "".concat(totalReviewCount),
                bestRating: "5",
                worstRating: "1"
            }
        };
        return product;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        "data-testid": "productSchema",
        type: "application/ld+json",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(ProductSchemaList())
        }
    });
};
/* harmony default export */ var SearchResults_ProductSchema = (ProductSchema);

;// CONCATENATED MODULE: ./src/components/SearchResults/SearchResultsController.tsx











var SearchResultsController = function(param) {
    var caregiverSearchResults = param.caregiverSearchResults, city = param.city, conversionHeader = param.conversionHeader, enrollmentURL = param.enrollmentURL, isClientSearchResultsQuery = param.isClientSearchResultsQuery, isLoading = param.isLoading, jobSearchResults = param.jobSearchResults, archivedJobSearchResults = param.archivedJobSearchResults, pageType = param.pageType, providerSearchResults = param.providerSearchResults, serviceId = param.serviceId, serviceIdForMember = param.serviceIdForMember, startIndex = param.startIndex, totalNumberOfResults = param.totalNumberOfResults, segmentationStats = param.segmentationStats, smbHeadline = param.smbHeadline;
    var ref;
    var showProductSchema = ((ref = segmentationStats === null || segmentationStats === void 0 ? void 0 : segmentationStats.totalReviewCount) !== null && ref !== void 0 ? ref : 0) >= 5;
    // eslint-disable-next-line complexity
    var renderResults = function() {
        // Loading
        if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {});
        // No Results
        if (caregiverSearchResults.length === 0 && providerSearchResults.length === 0 && jobSearchResults.length === 0 && archivedJobSearchResults.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_NoResults, {});
        }
        // Caregiver Results
        if (caregiverSearchResults.length > 0 && providerSearchResults.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_SearchResults, {
                        results: caregiverSearchResults,
                        resultType: constants/* SEARCH_RESULT_TYPE.CAREGIVER */.sM.CAREGIVER,
                        isClientSearchResultsQuery: isClientSearchResultsQuery,
                        serviceId: serviceId,
                        serviceIdForMember: serviceIdForMember
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_ItemListSchema, {
                        results: caregiverSearchResults,
                        totalNumberOfResults: totalNumberOfResults,
                        startIndex: startIndex
                    }),
                    segmentationStats && showProductSchema && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_ProductSchema, {
                        avgReviewRating: segmentationStats.avgReviewRating,
                        totalReviewCount: segmentationStats.totalReviewCount
                    })
                ]
            });
        }
        // Provider Results
        if (providerSearchResults.length > 0 && caregiverSearchResults.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_SearchResults, {
                        results: providerSearchResults,
                        resultType: constants/* SEARCH_RESULT_TYPE.PROVIDER */.sM.PROVIDER,
                        isClientSearchResultsQuery: isClientSearchResultsQuery,
                        serviceId: serviceId,
                        serviceIdForMember: serviceIdForMember
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_LocalBusinessSchema, {
                        results: providerSearchResults
                    }),
                    segmentationStats && showProductSchema && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_ProductSchema, {
                        avgReviewRating: segmentationStats.avgReviewRating,
                        totalReviewCount: segmentationStats.totalReviewCount
                    })
                ]
            });
        }
        // Job and Archived Job Results
        if (jobSearchResults.length > 0 && archivedJobSearchResults.length === 0 || jobSearchResults.length === 0 && archivedJobSearchResults.length > 0 || jobSearchResults.length > 0 && archivedJobSearchResults.length > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    jobSearchResults.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_JobSearchResults, {
                                results: jobSearchResults,
                                conversionHeader: conversionHeader,
                                enrollmentURL: enrollmentURL,
                                resultType: constants/* SEARCH_RESULT_TYPE.JOB */.sM.JOB,
                                isClientSearchResultsQuery: isClientSearchResultsQuery,
                                showConversionSectionFrequency: 5,
                                pageType: pageType
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_ItemListSchema, {
                                results: jobSearchResults,
                                totalNumberOfResults: totalNumberOfResults,
                                startIndex: startIndex
                            })
                        ]
                    }),
                    archivedJobSearchResults.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_ArchivedJobSearchResults, {
                        city: city,
                        conversionHeader: conversionHeader,
                        enrollmentURL: enrollmentURL,
                        pageType: pageType,
                        results: archivedJobSearchResults,
                        resultType: constants/* SEARCH_RESULT_TYPE.JOB */.sM.JOB
                    })
                ]
            });
        }
        // Hybrid Results (i.e. /child-care)
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_HybridSearchResults, {
                    caregiverSearchResults: caregiverSearchResults,
                    isClientSearchResultsQuery: isClientSearchResultsQuery,
                    providerSearchResults: providerSearchResults,
                    serviceId: serviceId,
                    serviceIdForMember: serviceIdForMember,
                    smbHeadline: smbHeadline
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_ItemListSchema, {
                    results: caregiverSearchResults,
                    totalNumberOfResults: totalNumberOfResults,
                    startIndex: startIndex
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_LocalBusinessSchema, {
                    results: providerSearchResults
                }),
                segmentationStats && showProductSchema && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_ProductSchema, {
                    avgReviewRating: segmentationStats.avgReviewRating,
                    totalReviewCount: segmentationStats.totalReviewCount
                })
            ]
        });
    };
    return renderResults();
};
/* harmony default export */ var SearchResults_SearchResultsController = (SearchResultsController);

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/ExpandableListBlock/ExpandableListBlock.js
var ExpandableListBlock = __webpack_require__(35408);
;// CONCATENATED MODULE: ./src/components/RightRails.tsx







var RightRails_classes = {
    rightRailsContainer: {
        marginBottom: 3
    },
    linkHeaders: {
        marginBottom: 1.5
    },
    linkCategories: {
        color: "care.grey.700",
        cursor: "pointer",
        lineHeight: "30px",
        display: "block !important"
    },
    pageStat: {
        color: "care.grey.700",
        lineHeight: "30px",
        listStyle: "none"
    }
};
var RightRails = function(param) {
    var rightRails = param.rightRails;
    var ref = (0,PageAttributesContext/* usePageAttributes */.l)(), avgPayRate = ref.avgPayRate, city = ref.city, state = ref.state, segmentNamePlural = ref.segmentNamePlural, totalNumberOfResults = ref.totalNumberOfResults, avgReviewRating = ref.avgReviewRating, searchingFor = ref.searchingFor, pageType = ref.pageType;
    var showRightRailsStatsTable = pageType === globalTypes/* SEOSegmentationPageType.LOCAL */.a6.LOCAL && searchingFor !== globalTypes/* SEOSegmentationSearchingFor.ALL_JOB */.yh.ALL_JOB && searchingFor !== globalTypes/* SEOSegmentationSearchingFor.SEEKER_JOB */.yh.SEEKER_JOB && searchingFor !== globalTypes/* SEOSegmentationSearchingFor.SMB_JOB */.yh.SMB_JOB && searchingFor !== globalTypes/* SEOSegmentationSearchingFor.SMB_PROVIDER */.yh.SMB_PROVIDER;
    var filterRightRails = function() {
        var rightRailSections = rightRails;
        if (!rightRailSections) {
            return [];
        }
        if (rightRailSections[0].title === "Looking for help?") {
            rightRailSections = rightRailSections.slice(1);
        }
        return rightRailSections.filter(function(rightRail) {
            return !rightRail.title.includes("Article");
        });
    };
    var rightRailSections = filterRightRails();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: [
            showRightRailsStatsTable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: RightRails_classes.rightRailsContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        color: "primary",
                        sx: RightRails_classes.linkHeaders,
                        children: "About ".concat(city, ", ").concat(state, " ").concat(segmentNamePlural)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        component: "li",
                        sx: RightRails_classes.pageStat,
                        children: [
                            "Total Providers: ",
                            totalNumberOfResults
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        component: "li",
                        sx: RightRails_classes.pageStat,
                        children: [
                            "Average Rating: ",
                            avgReviewRating,
                            "/5 stars"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        component: "li",
                        sx: RightRails_classes.pageStat,
                        children: [
                            "Average Rate: ",
                            avgPayRate,
                            "/hr"
                        ]
                    })
                ]
            }, "About ".concat(city, ", ").concat(state, " ").concat(segmentNamePlural)),
            rightRailSections.map(function(rightRail) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: RightRails_classes.rightRailsContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h4",
                            color: "primary",
                            sx: RightRails_classes.linkHeaders,
                            children: rightRail.title
                        }),
                        rightRail.linkList.length > 20 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableListBlock/* default */.Z, {
                            minItems: 20,
                            children: rightRail.linkList.map(function(link) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    variant: "link2",
                                    sx: RightRails_classes.linkCategories,
                                    href: link.url,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        // eslint-disable-next-line react/no-danger
                                        dangerouslySetInnerHTML: {
                                            __html: sanitize_html_default()(he_default().decode(link.content))
                                        }
                                    })
                                }, link.content);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: rightRail.linkList.map(function(link) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    variant: "link2",
                                    sx: RightRails_classes.linkCategories,
                                    href: link.url,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        // eslint-disable-next-line react/no-danger
                                        dangerouslySetInnerHTML: {
                                            __html: sanitize_html_default()(he_default().decode(link.content))
                                        }
                                    })
                                }, link.content);
                            })
                        })
                    ]
                }, rightRail.title);
            })
        ]
    });
};
/* harmony default export */ var components_RightRails = (RightRails);

// EXTERNAL MODULE: ./src/components/SeoLinkList.tsx + 2 modules
var SeoLinkList = __webpack_require__(21058);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Modal/Modal.js + 5 modules
var Modal = __webpack_require__(387);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandCalendarOneTimeSchedule.js
var Icon48BrandCalendarOneTimeSchedule = __webpack_require__(60966);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandCalendarOneWeek.js
var Icon48BrandCalendarOneWeek = __webpack_require__(43965);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandCalendarOneMonth.js
var Icon48BrandCalendarOneMonth = __webpack_require__(46551);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandSearch.js
var Icon48BrandSearch = __webpack_require__(56998);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoResponseTime.js
var Icon24InfoResponseTime = __webpack_require__(89905);
// EXTERNAL MODULE: ./src/utils/createRelativeImageURL.ts
var createRelativeImageURL = __webpack_require__(83174);
;// CONCATENATED MODULE: ./src/components/SeniorCareConversionBox.tsx
/* eslint-disable no-nested-ternary */ 



var SeniorCareConversionBox_classes = {
    ctaConversion: function(theme) {
        var ref;
        return {
            backgroundColor: (ref = theme.palette.care) === null || ref === void 0 ? void 0 : ref.white,
            borderRadius: theme.spacing(3),
            minHeight: "136px",
            margin: theme.spacing(-2, 0),
            padding: theme.spacing(2, 0),
            width: "100%"
        };
    },
    ctaConversionBtn: function(theme) {
        return (0,_define_property/* default */.Z)({
            textAlign: "left",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            minWidth: "295px",
            height: "72px",
            padding: "".concat(theme.spacing(2, 3), " !important"),
            border: "1px solid ".concat(theme.palette.care.grey[300]),
            boxSizing: "border-box",
            borderRadius: "16px",
            cursor: "pointer",
            marginBottom: theme.spacing(0.2),
            textDecoration: "none",
            fontWeight: 700,
            fontSize: theme.typography.body1.fontSize,
            width: "100%"
        }, theme.breakpoints.up("sm"), {
            width: "240px"
        });
    },
    ctaButtonContainer: {
        margin: 1
    }
};
var SeniorCareConversionBox = function(param) {
    var headline = param.headline, enrollmentURL = param.enrollmentURL;
    var ctaLables = [
        {
            label: "A loved one"
        },
        {
            label: "Myself"
        }, 
    ];
    var handleCTABtn = function(e) {
        var ref;
        var amplitudeData = {
            cta_location: "header",
            cta_text: (ref = e.target.textContent) === null || ref === void 0 ? void 0 : ref.toString(),
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.monetateAssetClicked */.Sj.monetateAssetClicked, amplitudeData);
    };
    var renderCtaBtns = function() {
        return ctaLables.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                minWidth: "144px",
                sx: SeniorCareConversionBox_classes.ctaButtonContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    component: "a",
                    href: enrollmentURL,
                    variant: "outlined",
                    color: "secondary",
                    size: "medium",
                    fullWidth: true,
                    sx: SeniorCareConversionBox_classes.ctaConversionBtn,
                    "data-testid": "conversion-cta-link",
                    onClick: handleCTABtn,
                    rel: "nofollow",
                    children: item.label
                })
            }, item.label);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        sx: SeniorCareConversionBox_classes.ctaConversion,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h2",
                    align: "center",
                    color: "textSecondary",
                    fontSize: "body1.fontSize",
                    mb: 2,
                    children: headline
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                flexBasis: "100%",
                m: "",
                children: renderCtaBtns()
            })
        ]
    });
};
/* harmony default export */ var components_SeniorCareConversionBox = (SeniorCareConversionBox);

;// CONCATENATED MODULE: ./src/components/ChildCareModal.tsx






var ChildCareModal = function(param) {
    var enrollmentURL = param.enrollmentURL, pageType = param.pageType, serviceIdForMember = param.serviceIdForMember;
    var generalAgeRanges = [
        "0 – 12 months",
        "1 – 4 years",
        "4 – 6 years",
        "6+ years"
    ];
    var segmentNameSingularLowerCase = (0,PageAttributesContext/* usePageAttributes */.l)().segmentNameSingularLowerCase;
    var daycareDirectoryFirstFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.DAYCARE_DIRECTORY_FIRST_FLOW.id */.WV.DAYCARE_DIRECTORY_FIRST_FLOW.id);
    var handleModalButton = function(e) {
        var amplitudeData = {
            asset_type: "Lightbox",
            CTA: e.currentTarget.textContent,
            screen_name: constants/* ScreenName.SEGMENTATION */.CG.SEGMENTATION,
            screen_template: constants/* ScreenTemplate.SEGMENTATION */.Yj.SEGMENTATION
        };
        if (daycareDirectoryFirstFlag && daycareDirectoryFirstFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.DAYCARE_DIRECTORY_FIRST_FLOW.id */.WV.DAYCARE_DIRECTORY_FIRST_FLOW.id,
                test_variant: daycareDirectoryFirstFlag.variationIndex,
                service_id_for_member: serviceIdForMember,
                page_template: pageType
            });
        }
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.monetateAssetClicked */.Sj.monetateAssetClicked, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                align: "center",
                display: "block",
                mb: 1,
                color: "textSecondary",
                variant: "body2",
                component: "span",
                children: [
                    "Let's find a ",
                    segmentNameSingularLowerCase,
                    " for you!"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                align: "center",
                display: "block",
                color: "textSecondary",
                variant: "h1",
                component: "span",
                mb: 3,
                letterSpacing: "-1px",
                children: "How old is your child?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    "& a": {
                        width: "100%"
                    }
                },
                children: generalAgeRanges.map(function(age) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "secondary",
                        size: "large",
                        "data-testid": "age-range-button",
                        variant: "outlined",
                        sx: {
                            "& + &": {
                                marginTop: 2
                            }
                        },
                        fullWidth: true,
                        component: "a",
                        onClick: handleModalButton,
                        href: "".concat(enrollmentURL),
                        rel: "nofollow",
                        children: age
                    }, age);
                })
            })
        ]
    });
};
/* harmony default export */ var components_ChildCareModal = (ChildCareModal);

;// CONCATENATED MODULE: ./src/components/PetCareModal.tsx





var PetCareModal = function(param) {
    var enrollmentURL = param.enrollmentURL;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var petCareNeeds = [
        "1",
        "2",
        "3+"
    ];
    var handleModalButton = function(e) {
        var amplitudeData = {
            asset_type: "Lightbox",
            CTA: e.currentTarget.textContent,
            screen_name: constants/* ScreenName.SEGMENTATION */.CG.SEGMENTATION,
            screen_template: constants/* ScreenTemplate.SEGMENTATION */.Yj.SEGMENTATION
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.monetateAssetClicked */.Sj.monetateAssetClicked, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                align: "center",
                display: "block",
                mb: 1,
                color: "textSecondary",
                variant: "body2",
                component: "span",
                children: "Tell us about your needs!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                align: "center",
                display: "block",
                color: "textSecondary",
                variant: isMobileOrSmaller ? "h2" : "h1",
                component: "span",
                mb: 3,
                letterSpacing: "-1px",
                children: "How many pets need care?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: function(theme) {
                    return (0,_define_property/* default */.Z)({
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "auto",
                        width: "50%"
                    }, theme.breakpoints.up("sm"), {
                        width: "42%"
                    });
                },
                children: petCareNeeds.map(function(count) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "secondary",
                        size: "large",
                        sx: {
                            "& + &": {
                                marginTop: 2
                            },
                            "&:nth-of-type(3)": {
                                marginBottom: -2
                            }
                        },
                        variant: "outlined",
                        fullWidth: true,
                        component: "a",
                        onClick: handleModalButton,
                        href: "".concat(enrollmentURL),
                        rel: "nofollow",
                        children: count
                    }, count);
                })
            })
        ]
    });
};
/* harmony default export */ var components_PetCareModal = (PetCareModal);

;// CONCATENATED MODULE: ./src/components/WhenCareModal.tsx
/* eslint-disable no-nested-ternary */ 















var getClasses = function(isNotPopUpRedesignTest) {
    return {
        modalContainerWithFlourish: function(theme) {
            return {
                "& .MuiDialog-paper": {
                    "&::before, &::after": (0,_define_property/* default */.Z)({
                        position: "absolute",
                        width: "252px",
                        left: "50%",
                        marginLeft: "-126px",
                        height: "78px"
                    }, theme.breakpoints.up("sm"), {
                        marginTop: "-125px",
                        height: "250px",
                        top: "50%",
                        width: "85px",
                        marginLeft: "0px"
                    }),
                    "&::before": (0,_define_property/* default */.Z)({
                        content: "url(".concat((0,createRelativeImageURL/* default */.Z)(constants/* FLORAL_WHEN_CARE_MODAL.mwTopImageURL */.cE.mwTopImageURL), "?im=)"),
                        top: "-78px"
                    }, theme.breakpoints.up("sm"), {
                        content: "url(".concat((0,createRelativeImageURL/* default */.Z)(constants/* FLORAL_WHEN_CARE_MODAL.dtLeftImageURL */.cE.dtLeftImageURL), "?im=)"),
                        left: "-85px",
                        top: "50%"
                    }),
                    "&::after": (0,_define_property/* default */.Z)({
                        content: "url(".concat((0,createRelativeImageURL/* default */.Z)(constants/* FLORAL_WHEN_CARE_MODAL.mwBottomImageURL */.cE.mwBottomImageURL), "?im=)"),
                        bottom: "-78px"
                    }, theme.breakpoints.up("sm"), {
                        content: "url(".concat((0,createRelativeImageURL/* default */.Z)(constants/* FLORAL_WHEN_CARE_MODAL.dtRightImageURL */.cE.dtRightImageURL), "?im=)"),
                        right: "-85px",
                        left: "auto"
                    })
                }
            };
        },
        modalContent: function(theme) {
            return {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                minWidth: "295px",
                height: "72px",
                paddingX: 2,
                paddingY: 2,
                border: "1px solid ".concat(theme.palette.care.grey[300]),
                boxSizing: "border-box",
                borderRadius: "16px",
                cursor: "pointer",
                marginBottom: 2,
                textDecoration: "none"
            };
        },
        modalIcon: {
            height: isNotPopUpRedesignTest ? "31.5px" : "40px",
            width: isNotPopUpRedesignTest ? "34.5px" : "40px"
        }
    };
};
var WhenCareModal = function(param) {
    var enrollmentURL = param.enrollmentURL, modalTitle = param.modalTitle, pageType = param.pageType, serviceIdForMember = param.serviceIdForMember;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    (0,react.useEffect)(function() {
        var showModal = true;
        var doesCookieExist = function(cookieName) {
            return !document.cookie.split(";").some(function(item) {
                return item.trim().indexOf(cookieName) === 0;
            });
        };
        if (showModal && doesCookieExist("crcmWhenCareModalShown=")) {
            var cookieDate = new Date();
            cookieDate.setDate(cookieDate.getDate() + 90); // 90 days from today
            setTimeout(function() {
                setOpen(true);
                document.cookie = "crcmWhenCareModalShown=true; expires=".concat(cookieDate);
            }, 3000);
        }
    }, []); // Only run the useEffect on the initial render
    var isNotPopUpRedesignTest = !(serviceIdForMember === constants/* ServiceIdForMember.BABYSITTER */.u2.BABYSITTER || serviceIdForMember === constants/* ServiceIdForMember.NANNY */.u2.NANNY || serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE */.u2.CHILD_CARE || serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE_LOCATION */.u2.CHILD_CARE_LOCATION || serviceIdForMember === constants/* ServiceIdForMember.FAMILY_CHILD_CARE */.u2.FAMILY_CHILD_CARE || serviceIdForMember === constants/* ServiceIdForMember.HOUSEKEEPING */.u2.HOUSEKEEPING || serviceIdForMember === constants/* ServiceIdForMember.PET_CARE */.u2.PET_CARE || serviceIdForMember === constants/* ServiceIdForMember.PET_DAY_CARE_LOCATION */.u2.PET_DAY_CARE_LOCATION || serviceIdForMember === constants/* ServiceIdForMember.PET_SITTING_WALKING */.u2.PET_SITTING_WALKING || serviceIdForMember === constants/* ServiceIdForMember.SENIOR_CARE */.u2.SENIOR_CARE || serviceIdForMember === constants/* ServiceIdForMember.TUTORING */.u2.TUTORING || serviceIdForMember === constants/* ServiceIdForMember.TUTORING_AFTER_SCHOOL_CARE */.u2.TUTORING_AFTER_SCHOOL_CARE);
    var aboveTheFoldTestJobsFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.SEO_3217_ABOVE_THE_FOLD_CONVERSION_TEST_PROVIDERS.id */.WV.SEO_3217_ABOVE_THE_FOLD_CONVERSION_TEST_PROVIDERS.id);
    var isAboveTheFoldTestJobs = (aboveTheFoldTestJobsFlag === null || aboveTheFoldTestJobsFlag === void 0 ? void 0 : aboveTheFoldTestJobsFlag.variationIndex) === 2;
    var showPopUpChildCare = serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE_LOCATION */.u2.CHILD_CARE_LOCATION;
    var showPopUpPetCare = serviceIdForMember === constants/* ServiceIdForMember.PET_CARE */.u2.PET_CARE || serviceIdForMember === constants/* ServiceIdForMember.PET_DAY_CARE_LOCATION */.u2.PET_DAY_CARE_LOCATION || serviceIdForMember === constants/* ServiceIdForMember.PET_SITTING_WALKING */.u2.PET_SITTING_WALKING;
    var showSeniorCareConversionBox = serviceIdForMember === constants/* ServiceIdForMember.SENIOR_CARE */.u2.SENIOR_CARE || serviceIdForMember === constants/* ServiceIdForMember.HOME_CARE_LOCATION */.u2.HOME_CARE_LOCATION;
    var classes = getClasses(isNotPopUpRedesignTest);
    var handleModalButton = function(e) {
        setOpen(false);
        var amplitudeData = {
            asset_type: "Lightbox",
            CTA: e.target.textContent,
            messagingContent: "Join now",
            screen_name: constants/* ScreenName.SEGMENTATION */.CG.SEGMENTATION,
            screen_template: constants/* ScreenTemplate.SEGMENTATION */.Yj.SEGMENTATION
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.monetateAssetClicked */.Sj.monetateAssetClicked, amplitudeData);
    };
    var handleCloseModal = function() {
        setOpen(false);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.monetateAssetClicked */.Sj.monetateAssetClicked, {
            asset_type: "Lightbox",
            CTA: "X",
            messagingContent: "Join now",
            screen_name: constants/* ScreenName.SEGMENTATION */.CG.SEGMENTATION,
            screen_template: constants/* ScreenTemplate.SEGMENTATION */.Yj.SEGMENTATION
        });
    };
    var whenCareModalOptions = [
        {
            text: "Right now",
            intent: "rightNow",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandCalendarOneTimeSchedule/* default */.Z, {
                sx: classes.modalIcon
            })
        },
        {
            text: "Within a week",
            intent: "withInWeek",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandCalendarOneWeek/* default */.Z, {
                sx: classes.modalIcon
            })
        },
        {
            text: "Within a month",
            intent: "withInMonth",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandCalendarOneMonth/* default */.Z, {
                sx: classes.modalIcon
            })
        },
        {
            text: "Just browsing",
            intent: "justBrowsing",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandSearch/* default */.Z, {
                sx: classes.modalIcon
            })
        }, 
    ];
    var filteredWhenCareModalOptions = isAboveTheFoldTestJobs ? whenCareModalOptions.filter(function(option) {
        return option.intent !== "withInWeek";
    }).map(function(option) {
        return option.intent === "rightNow" ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, option), {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoResponseTime/* default */.Z, {
                sx: classes.modalIcon
            })
        }) : option;
    }) : whenCareModalOptions;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        open: open,
        variant: isMobileOrSmaller ? "default" : "dynamic",
        hideClose: isNotPopUpRedesignTest,
        onClose: handleCloseModal,
        sx: !isNotPopUpRedesignTest ? classes.modalContainerWithFlourish : undefined,
        children: [
            showSeniorCareConversionBox && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SeniorCareConversionBox, {
                headline: "Who needs care?",
                enrollmentURL: enrollmentURL
            }),
            showPopUpChildCare && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ChildCareModal, {
                enrollmentURL: enrollmentURL,
                pageType: pageType,
                serviceIdForMember: serviceIdForMember
            }),
            showPopUpPetCare && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PetCareModal, {
                enrollmentURL: enrollmentURL
            }),
            !showSeniorCareConversionBox && !showPopUpChildCare && !showPopUpPetCare && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h3",
                        textAlign: "center",
                        mb: 3,
                        px: isNotPopUpRedesignTest ? 0 : 2,
                        fontSize: isNotPopUpRedesignTest ? "h3.fontSize" : "serifHeadline3.fontSize",
                        color: "textSecondary",
                        children: modalTitle
                    }),
                    filteredWhenCareModalOptions.map(function(option) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            rel: "nofollow",
                            component: "a",
                            href: "".concat(enrollmentURL, "&intent=").concat(option.intent),
                            onClick: handleModalButton,
                            sx: classes.modalContent,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                display: "flex",
                                alignItems: "center",
                                children: [
                                    option.icon,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h3",
                                        color: "primary",
                                        ml: 2,
                                        fontWeight: isNotPopUpRedesignTest ? "700" : "400",
                                        children: option.text
                                    })
                                ]
                            })
                        }, option.intent);
                    })
                ]
            }),
            isNotPopUpRedesignTest && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                color: "secondary",
                variant: "contained",
                onClick: handleModalButton,
                sx: {
                    display: "block",
                    margin: "auto",
                    marginTop: 4
                },
                children: "Close"
            })
        ]
    });
};
/* harmony default export */ var components_WhenCareModal = (WhenCareModal);

// EXTERNAL MODULE: ./src/components/PageMeta.tsx
var PageMeta = __webpack_require__(96301);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallDevices.js
var IconIllustrationSmallDevices = __webpack_require__(45480);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallMagnifier.js
var IconIllustrationSmallMagnifier = __webpack_require__(45724);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallDollarBill.js
var IconIllustrationSmallDollarBill = __webpack_require__(98901);
;// CONCATENATED MODULE: ./src/components/JobHowItWorks.tsx




var JobHowItWorks_classes = {
    brandDeviceIcon: {
        width: "65px",
        height: "65px",
        marginTop: -1.5,
        marginLeft: -0.6
    }
};
var JobHowItWorks = function(param) {
    var enrollmentURL = param.enrollmentURL;
    var handleGetStartedClick = function() {
        var amplitudeData = {
            cta_text: "Get Started"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, amplitudeData);
    };
    var howItWorksList = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallDevices/* default */.Z, {
                sx: JobHowItWorks_classes.brandDeviceIcon
            }),
            title: "Sign up",
            content: "Create a profile to find jobs that fit your schedule"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallMagnifier/* default */.Z, {
                sx: JobHowItWorks_classes.brandDeviceIcon
            }),
            title: "Search for jobs",
            content: "Apply to jobs posted by local families hiring in your area"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallDollarBill/* default */.Z, {
                sx: JobHowItWorks_classes.brandDeviceIcon
            }),
            title: "Get hired",
            content: "Match with families, take jobs as you need them, and start earning!"
        }, 
    ];
    var howItWorksContent = howItWorksList.map(function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: function(theme) {
                return {
                    display: "flex",
                    alignItems: "center",
                    alignContent: "center",
                    flexWrap: "wrap",
                    position: "relative",
                    paddingBottom: "30px",
                    "&:not(:last-child)": {
                        "&:after": {
                            content: '"⋮"',
                            display: "block",
                            position: "absolute",
                            top: "65%",
                            left: "22px",
                            fontSize: theme.typography.h1.fontSize,
                            marginTop: theme.spacing(0.5),
                            color: theme.palette.care.navy[800]
                        }
                    }
                };
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        width: "50px",
                        height: "50px",
                        marginRight: 3,
                        textAlign: "center",
                        alignSelf: "flex-start",
                        paddingTop: "8px"
                    },
                    children: item.icon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    maxWidth: "188px",
                    flex: "1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            color: "primary",
                            mb: 0.5,
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body3",
                            color: "secondary",
                            children: item.content
                        })
                    ]
                })
            ]
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            mb: {
                xs: 1,
                sm: 7
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    mb: 3,
                    variant: "h4",
                    color: "primary",
                    children: "How it works"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: howItWorksContent
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        href: enrollmentURL,
                        color: "secondary",
                        size: "small",
                        component: "a",
                        sx: {
                            textAlign: "center"
                        },
                        onClick: handleGetStartedClick,
                        variant: "contained",
                        rel: "nofollow",
                        children: "Get started"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_JobHowItWorks = (JobHowItWorks);

;// CONCATENATED MODULE: ./src/components/ReviewCard.tsx









var ReviewCard_numberFixTo = function(value) {
    return value === null || value === void 0 ? void 0 : value.toFixed(1);
};
var ReviewCard = function(param) {
    var stats = param.stats;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var ref = (0,PageAttributesContext/* usePageAttributes */.l)(), segmentNamePlural = ref.segmentNamePlural, segmentNamePluralLowerCase = ref.segmentNamePluralLowerCase, city = ref.city, state = ref.state, pageType = ref.pageType;
    var title = pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL ? "Ratings for ".concat(segmentNamePluralLowerCase, " listed on Care.com") : "Ratings for ".concat(city, ", ").concat(state, " ").concat(segmentNamePluralLowerCase, " listed on Care.com");
    var description = pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL ? "".concat(segmentNamePlural, " are rated <b>").concat(ReviewCard_numberFixTo(stats.avgReviewRating), " out of 5 stars</b> based on <b>").concat((0,formatNumToString/* default */.Z)(stats.totalReviewCount), " reviews</b> of the <b>").concat((0,formatNumToString/* default */.Z)(stats.totalProviders), " listed ").concat(segmentNamePluralLowerCase, "</b>.") : "".concat(segmentNamePlural, " in ").concat(city, ", ").concat(state, " are rated <b>").concat(ReviewCard_numberFixTo(stats.avgReviewRating), " out of 5 stars</b> based on <b>").concat((0,formatNumToString/* default */.Z)(stats.totalReviewCount), " reviews</b> of the <b>").concat((0,formatNumToString/* default */.Z)(stats.totalProviders), " listed ").concat(segmentNamePluralLowerCase, "</b>.");
    var _avgReviewRating;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: function(theme) {
                return {
                    margin: theme.spacing(5, 0, 5)
                };
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: isMobileOrSmaller ? "h3" : "h2",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body2",
                    my: 2,
                    mx: 0,
                    children: [
                        "Average Rating",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                            name: "size-large",
                            defaultValue: (_avgReviewRating = stats.avgReviewRating) !== null && _avgReviewRating !== void 0 ? _avgReviewRating : undefined,
                            sx: {
                                px: 1,
                                py: 1,
                                verticalAlign: "middle"
                            },
                            readOnly: true
                        }),
                        ReviewCard_numberFixTo(stats.avgReviewRating),
                        " / 5"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    color: "primary",
                    dangerouslySetInnerHTML: {
                        __html: sanitize_html_default()(he_default().decode(description))
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var components_ReviewCard = (ReviewCard);

;// CONCATENATED MODULE: ./src/components/SearchResults/ProviderLatestReview.tsx






var ProviderLatestReview = function(param) {
    var latestReview = param.latestReview, name = param.name;
    var _reviewer = latestReview.reviewer, reviewerDisplayName = _reviewer.displayName, rating = latestReview.rating, comment = latestReview.comment;
    var currentRating = rating.toFixed(1);
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var amplitudeTrackingForShowMoreReview = function() {
        var amplitudeData = {
            feature_name: "Show More Review Content"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mb: 1,
                display: {
                    xs: "block",
                    sm: "flex"
                },
                sx: {
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontWeight: 700
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mb: {
                            xs: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h3",
                            children: name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "block",
                            whiteSpace: "nowrap"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                name: "size-medium",
                                defaultValue: parseFloat(currentRating),
                                readOnly: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                children: currentRating
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                ml: {
                    sm: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* default */.Z, {
                        gutterBottom: true,
                        color: "textPrimary",
                        component: "div",
                        variant: "body2",
                        charLimit: 300,
                        value: comment || "",
                        showMoreLabel: isExpanded ? "Less" : "show more",
                        onClick: function(e) {
                            var target = e.target;
                            if (target.tagName.toLowerCase() === "button") {
                                setIsExpanded(!isExpanded);
                                if (!isExpanded) {
                                    amplitudeTrackingForShowMoreReview();
                                }
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: 1,
                        textAlign: "right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body2",
                            children: [
                                "- ",
                                reviewerDisplayName || "Care member"
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SearchResults_ProviderLatestReview = (ProviderLatestReview);

;// CONCATENATED MODULE: ./src/components/SearchResults/TopReviewResults.tsx






var ProviderReviewResults = function(param) {
    var caregiverSearchResults = param.caregiverSearchResults, city = param.city, pageType = param.pageType, state = param.state, providerSearchResults = param.providerSearchResults;
    var ref = (0,PageAttributesContext/* usePageAttributes */.l)(), serviceIdForMember = ref.serviceIdForMember, segmentNameSingularLowerCase = ref.segmentNameSingularLowerCase, segmentNamePluralLowerCase = ref.segmentNamePluralLowerCase, searchingFor = ref.searchingFor;
    var isTrustAndSafetyFlag = pageType === globalTypes/* SEOSegmentationPageType.LOCAL */.a6.LOCAL && searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER && serviceIdForMember === constants/* ServiceIdForMember.PET_CARE */.u2.PET_CARE;
    var renderReviewResults = function() {
        var headline;
        if (caregiverSearchResults.length > 0) {
            headline = pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL ? "Recent ".concat(segmentNameSingularLowerCase, " reviews") : "Recent ".concat(segmentNameSingularLowerCase, " reviews in ").concat(city, ", ").concat(state);
        } else {
            headline = pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL ? "Recent reviews for local ".concat(segmentNamePluralLowerCase) : "Recent ".concat(segmentNameSingularLowerCase, " reviews in ").concat(city, ", ").concat(state);
        }
        if (serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE */.u2.CHILD_CARE) {
            headline = pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL ? "Most recent reviews for local ".concat(segmentNamePluralLowerCase) : "Most recent reviews for ".concat(segmentNamePluralLowerCase, " in ").concat(city, ", ").concat(state);
        }
        if (serviceIdForMember === constants/* ServiceIdForMember.BABYSITTER */.u2.BABYSITTER || serviceIdForMember === constants/* ServiceIdForMember.NANNY */.u2.NANNY) {
            headline = pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL ? "Recent ".concat(segmentNameSingularLowerCase, " reviews from local parents") : "Recent ".concat(segmentNameSingularLowerCase, " reviews from local parents in ").concat(city, ", ").concat(state);
        }
        if (isTrustAndSafetyFlag) {
            headline = "Recent ".concat(segmentNameSingularLowerCase, " reviews from local pet parents in ").concat(city, ", ").concat(state);
        }
        var allReviews;
        allReviews = providerSearchResults.filter(function(profile) {
            return profile.latestReview !== null;
        }).map(function(profile) {
            return profile;
        });
        if (caregiverSearchResults.length > 0) {
            allReviews = caregiverSearchResults.filter(function(profile) {
                return profile.latestReview !== null;
            }).map(function(profile) {
                return profile;
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            md: 10,
            style: {
                margin: "auto"
            },
            children: allReviews.length >= 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: {
                            xs: 4,
                            sm: 6
                        },
                        mb: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            align: "center",
                            variant: "h2",
                            children: headline
                        })
                    }),
                    allReviews.map(function(profile, index) {
                        var ref, ref1;
                        var profileName = ((ref = profile.seoSegmentationProvider) === null || ref === void 0 ? void 0 : ref.provider.name) || ((ref1 = profile.caregiver) === null || ref1 === void 0 ? void 0 : ref1.member.displayName) || "";
                        return index < 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mb: 4,
                                children: profile.latestReview && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    container: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            p: {
                                                xs: 3,
                                                sm: "3, 6"
                                            },
                                            component: "div",
                                            sx: {
                                                alignItems: "flex-start",
                                                border: "1px solid #CCD1D6",
                                                borderRadius: "8px",
                                                boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.15)",
                                                boxSizing: "border-box",
                                                justifyContent: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_ProviderLatestReview, {
                                                latestReview: profile.latestReview,
                                                name: profileName
                                            })
                                        })
                                    })
                                })
                            })
                        }, "".concat(profileName, "-").concat(index + 1));
                    })
                ]
            })
        });
    };
    return renderReviewResults();
};
/* harmony default export */ var TopReviewResults = (ProviderReviewResults);

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
;// CONCATENATED MODULE: ./src/utils/hotjarHelper.ts


var executeHotjarCommand = function(command) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if ( true && window.hj) {
        var _window;
        (_window = window).hj.apply(_window, [
            command
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
    }
};
// eslint-disable-next-line import/prefer-default-export
var hotjarHelper_event = function(actionName) {
    try {
        executeHotjarCommand("event", actionName);
        return true;
    } catch (error) {
        (0,esm_exports/* captureException */.Tb)(error);
        return false;
    }
};

;// CONCATENATED MODULE: ./src/API/getSearchResults.ts

function getSearchResults_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  query getSearchResults(\n    $seoSegmentId: ID!\n    $pageNumber: Int\n    $filters: SEOSegmentationFilterInput\n    $ipAddress: String!\n    $userGeoInfo: String!\n    $botInfo: String!\n    $userAgent: String!\n    $hasFilters: Boolean!\n    $numberOfReviewsPerProfile: Int\n  ) {\n    seoSegmentationSearchResults(\n      filters: $filters\n      pageNumber: $pageNumber\n      testCell: null\n      seoSegmentId: $seoSegmentId\n      ipAddress: $ipAddress\n      botInfo: $botInfo\n      userGeoInfo: $userGeoInfo\n      userAgent: $userAgent\n      numberOfReviewsPerProfile: $numberOfReviewsPerProfile\n    ) {\n      ... on SEOSegmentationSearchResultsSuccess {\n        ...CaregiverSearchResultFields\n        ...ProviderSearchResultFields\n        ...JobSearchResultFields\n        ...ArchivedJobSearchResultFields\n\n        filters @include(if: $hasFilters) {\n          location {\n            zipcode\n            city\n            state\n          }\n        }\n      }\n      ... on SEOSegmentationSearchResultsError {\n        errors {\n          __typename\n          message\n        }\n      }\n    }\n    seoSegmentationDetails(seoSegmentId: $seoSegmentId) {\n      __typename\n      ... on SEOSegmentationDetailsSuccess {\n        segmentationDetails {\n          searchResultsHeader\n        }\n      }\n    }\n  }\n"
    ]);
    getSearchResults_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GET_SEARCH_RESULTS = (0,lib/* default */.ZP)(getSearchResults_templateObject(), fragments_common/* CAREGIVER_SEARCH_RESULT_FIELDS */.ut, fragments_common/* PROVIDER_SEARCH_RESULT_FIELDS */.GF, fragments_common/* JOB_SEARCH_RESULT_FIELDS */.OS, fragments_common/* ARCHIVED_JOB_SEARCH_RESULT_FIELDS */.d7);
/* harmony default export */ var API_getSearchResults = (GET_SEARCH_RESULTS);

// EXTERNAL MODULE: ./src/utils/generateEnrollmentUrl.ts + 1 modules
var generateEnrollmentUrl = __webpack_require__(85715);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoLocation.js
var Icon24InfoLocation = __webpack_require__(59242);
// EXTERNAL MODULE: ./src/components/HowItWorks.tsx
var HowItWorks = __webpack_require__(65477);
// EXTERNAL MODULE: ./src/utils/getZipcodeFromGeoInfo.ts
var getZipcodeFromGeoInfo = __webpack_require__(7360);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallChildCare.js
var IconIllustrationSmallChildCare = __webpack_require__(68368);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallPolaroids.js
var IconIllustrationSmallPolaroids = __webpack_require__(82297);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallHeart.js
var IconIllustrationSmallHeart = __webpack_require__(2809);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallSeniorCare.js
var IconIllustrationSmallSeniorCare = __webpack_require__(43685);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallSafetyCheck.js
var IconIllustrationSmallSafetyCheck = __webpack_require__(54383);
;// CONCATENATED MODULE: ./src/components/ContentRibbon.tsx











var ContentRibbon_classes = {
    brandDeviceIcon: function(theme) {
        return {
            width: "65px",
            height: "65px",
            marginTop: theme.spacing(-1.5),
            marginLeft: theme.spacing(-0.6)
        };
    },
    stepIcon: function(theme) {
        return (0,_define_property/* default */.Z)({
            width: "50px",
            height: "50px",
            marginRight: 3,
            textAlign: "center",
            alignSelf: "flex-start",
            paddingTop: 1
        }, theme.breakpoints.up("md"), {
            width: "100%"
        });
    },
    stat: function(theme) {
        var _obj;
        return _obj = {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingBottom: 1,
            width: "285px"
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            flexDirection: "column",
            width: "350px"
        }), (0,_define_property/* default */.Z)(_obj, "& div:first-of-type", (0,_define_property/* default */.Z)({
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "auto",
            overflow: "visible",
            textAlign: "center",
            fontWeight: 700,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }, theme.breakpoints.up("md"), {
            height: "50px"
        })), _obj;
    },
    statDescription: function(theme) {
        return (0,_define_property/* default */.Z)({
            fontSize: theme.typography.h5.fontSize,
            padding: theme.spacing(0, 0, 0, 1),
            color: theme.palette.care.grey[700]
        }, theme.breakpoints.up("md"), {
            textAlign: "center",
            padding: theme.spacing(1, 5),
            fontSize: "1rem"
        });
    }
};
var ContentRibbon = function(param) {
    var avgPayRate = param.avgPayRate, avgYearsOfExperience = param.avgYearsOfExperience, avgReviewRating = param.avgReviewRating, totalProviders = param.totalProviders, slotProps = param.slotProps;
    var ref = (0,PageAttributesContext/* usePageAttributes */.l)(), pageType = ref.pageType, segmentNamePluralLowerCase = ref.segmentNamePluralLowerCase, city = ref.city, state = ref.state, serviceIdForMember = ref.serviceIdForMember;
    var isMobleOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var currentDate = new Intl.DateTimeFormat("en-US", {
        month: "long",
        year: "numeric"
    }).format(new Date());
    var roundAvgReviewRating = avgReviewRating ? avgReviewRating.toFixed(1) : null;
    var roundAvgYearsOfExp = avgYearsOfExperience ? Math.floor(avgYearsOfExperience) : null;
    var statForReviewRatingOrYearsOfExp = pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL ? "".concat(roundAvgReviewRating) : "".concat(roundAvgYearsOfExp);
    var ribbonIconOne = serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE_LOCATION */.u2.CHILD_CARE_LOCATION ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallChildCare/* default */.Z, {
        sx: ContentRibbon_classes.brandDeviceIcon
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallPolaroids/* default */.Z, {
        sx: ContentRibbon_classes.brandDeviceIcon
    });
    var ribbonIconThree = serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE_LOCATION */.u2.CHILD_CARE_LOCATION ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallHeart/* default */.Z, {
        sx: ContentRibbon_classes.brandDeviceIcon
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallSeniorCare/* default */.Z, {
        sx: ContentRibbon_classes.brandDeviceIcon
    });
    var headline = pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL ? "Find ".concat(segmentNamePluralLowerCase, " that you’ll love") : "Find ".concat(segmentNamePluralLowerCase, " in ").concat(city, ",&nbsp;").concat(state, " that you’ll love");
    var descriptionForTotalProviders = pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL ? "".concat(totalProviders === null || totalProviders === void 0 ? void 0 : totalProviders.toLocaleString(), " ").concat(segmentNamePluralLowerCase, " are listed on Care.com") : "".concat(totalProviders === null || totalProviders === void 0 ? void 0 : totalProviders.toLocaleString(), " ").concat(segmentNamePluralLowerCase, " are listed in ").concat(city, ",&nbsp;").concat(state);
    var descriptionForAvgPayRate = "The average posted rate is $".concat(avgPayRate === null || avgPayRate === void 0 ? void 0 : avgPayRate.amount, "/hr as of ").concat(currentDate);
    var descriptionForReviewRatingOrYearsOfExp = pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL ? "The average star rating for rated ".concat(segmentNamePluralLowerCase, " is ").concat(statForReviewRatingOrYearsOfExp) : "The average experience for nearby ".concat(segmentNamePluralLowerCase, " is ").concat(statForReviewRatingOrYearsOfExp, " years");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        item: true,
        xs: 12,
        bgcolor: "care.grey.50",
        pb: 2.5,
        mb: 2
    }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.contentRibbon), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "h2",
                variant: isMobleOrSmaller ? "h3" : "h2",
                textAlign: "center",
                padding: function(theme) {
                    return {
                        xs: theme.spacing(2, 6, 2, 6),
                        md: theme.spacing(3, 6, 2, 6)
                    };
                },
                dangerouslySetInnerHTML: {
                    __html: sanitize_html_default()(he_default().decode(headline))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: function(theme) {
                    var _obj;
                    return _obj = {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "0 15%"
                    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.only("sm"), {
                        padding: "0 30%"
                    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
                        flexDirection: "row"
                    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
                        padding: "0 15%"
                    }), _obj;
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: ContentRibbon_classes.stat,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: ContentRibbon_classes.stepIcon,
                                children: ribbonIconOne
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: ContentRibbon_classes.statDescription,
                                dangerouslySetInnerHTML: {
                                    __html: sanitize_html_default()(he_default().decode(descriptionForTotalProviders))
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: ContentRibbon_classes.stat,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: ContentRibbon_classes.stepIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallSafetyCheck/* default */.Z, {
                                    sx: ContentRibbon_classes.brandDeviceIcon
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: ContentRibbon_classes.statDescription,
                                children: descriptionForAvgPayRate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: ContentRibbon_classes.stat,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: ContentRibbon_classes.stepIcon,
                                children: ribbonIconThree
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: ContentRibbon_classes.statDescription,
                                children: descriptionForReviewRatingOrYearsOfExp
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_ContentRibbon = (ContentRibbon);

;// CONCATENATED MODULE: ./src/components/Hero.tsx



















var Hero_getClasses = function(styleProps) {
    return {
        heroContainer: function(theme) {
            var _obj;
            return _obj = {
                overflow: "hidden",
                minHeight: "444px",
                maxWidth: "1440px",
                margin: "0 auto",
                backgroundPosition: "top left, top right",
                backgroundRepeat: "no-repeat",
                backgroundSize: "auto, auto",
                backgroundColor: theme.palette.background.default,
                display: "flex",
                flexDirection: "column",
                backgroundImage: "".concat(styleProps.flourishLeftImageURLs && styleProps.largeImageURL ? "url(".concat((0,createRelativeImageURL/* default */.Z)(styleProps.flourishLeftImageURLs.largeImageURL), "?im=), url(").concat((0,createRelativeImageURL/* default */.Z)(styleProps.largeImageURL), "?im=)") : "none")
            }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
                backgroundPosition: "".concat(styleProps.hkBackgroundPositionLgOrBigger)
            }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.only("sm"), {
                backgroundSize: "25% auto, 50% auto",
                minHeight: "375px"
            }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.only("md"), {
                backgroundSize: "20% auto, 45% auto",
                minWidth: "440px",
                minHeight: "355px"
            }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.only("xs"), {
                minHeight: "375px",
                backgroundImage: "".concat(styleProps.flourishLeftImageURLs && styleProps.smallImageURL ? "url(".concat((0,createRelativeImageURL/* default */.Z)(styleProps.flourishLeftImageURLs.smallImageURL), "?im=), url(").concat((0,createRelativeImageURL/* default */.Z)(styleProps.smallImageURL), "?im=)") : "none"),
                backgroundSize: "35% auto, 45% auto"
            }), _obj;
        },
        heroContent: function(theme) {
            var _obj;
            return _obj = {
                margin: theme.spacing(-3, 0, 0, 30),
                width: "40%",
                height: "auto"
            }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.only("sm"), {
                width: "60%",
                margin: theme.spacing(0, 0, 0, 8)
            }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.only("md"), {
                width: "50%",
                margin: theme.spacing(-3, 0, 0, 22.5)
            }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.only("xs"), {
                width: "100%",
                margin: "0 auto",
                padding: theme.spacing(0, 2, 0, 2)
            }), _obj;
        },
        heroHeadline: function(theme) {
            var _obj;
            return _obj = {
                margin: theme.spacing(9, 0, 6, 30),
                width: "37%",
                color: theme.palette.text.primary,
                lineHeight: "42px",
                fontSize: "2.25rem",
                textAlign: "left"
            }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.only("sm"), {
                width: "35%",
                margin: theme.spacing(14, 0, 0, 8),
                paddingBottom: "16px"
            }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.only("md"), {
                margin: theme.spacing(10, 0, 5, 22.5),
                width: "28%"
            }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("xl"), {
                fontSize: "1.75rem",
                lineHeight: "34px"
            }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.only("xs"), {
                width: "50%",
                margin: theme.spacing(10, 0, 0, 2),
                fontSize: "1.625rem"
            }), _obj;
        },
        heroImgSubText: function(theme) {
            var _obj;
            return _obj = {
                width: "70%",
                color: theme.palette.text.primary,
                textAlign: "left",
                fontSize: "1.125rem",
                fontWeight: 400,
                lineHeight: "24px",
                margin: theme.spacing(0, 0, 3, 0)
            }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.only("sm"), {
                margin: theme.spacing(1, 0, 2, 0)
            }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.only("xs"), {
                width: "75%",
                margin: theme.spacing(2, 0, 0, 0)
            }), (0,_define_property/* default */.Z)(_obj, "& p:first-of-type", {
                marginTop: "0px"
            }), _obj;
        },
        textFieldOverride: function(theme) {
            var _obj;
            return _obj = {
                marginBottom: theme.spacing(0.5),
                paddingLeft: theme.spacing(0),
                width: "360px",
                "& .MuiInputAdornment-root": {
                    ml: 0
                },
                "& .MuiInputBase-root": {
                    minHeight: "62px"
                }
            }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.only("xs"), {
                paddingTop: 2,
                pb: 2,
                width: "100%"
            }), // removes number arrows from Chrome, Safari, Edge, Opera
            (0,_define_property/* default */.Z)(_obj, "& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button", {
                appearance: "none",
                margin: 0
            }), // removes number arrows from Firefox
            (0,_define_property/* default */.Z)(_obj, "& input[type=text]", {
                cursor: "auto",
                padding: theme.spacing(2, 2, 2, 0)
            }), _obj;
        },
        positionStart: function(theme) {
            return {
                margin: theme.spacing(0, 0, 0, 2)
            };
        },
        ctaBtn: function(theme) {
            var _obj;
            return _obj = {
                fontWeight: 700,
                marginBottom: 4,
                padding: "".concat(theme.spacing(1, 2), " !important"),
                width: "360px"
            }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.only("xs"), {
                width: "100%"
            }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
                mt: 2
            }), _obj;
        }
    };
};
var Hero = function(param) {
    var enrollmentURL = param.enrollmentURL, headline = param.headline, heroImage = param.heroImage, searchFiltersRef = param.searchFiltersRef, subHeadline = param.subHeadline, segmentationStats = param.segmentationStats, userGeoInfo = param.userGeoInfo, _directoryFirstExperience = param.directoryFirstExperience, directoryFirstExperience = _directoryFirstExperience === void 0 ? false : _directoryFirstExperience;
    var ref;
    var ref1 = (0,PageAttributesContext/* usePageAttributes */.l)(), serviceIdForMember = ref1.serviceIdForMember, segmentNamePluralLowerCase = ref1.segmentNamePluralLowerCase, segmentNameSingularLowerCase = ref1.segmentNameSingularLowerCase, pageType = ref1.pageType;
    var styleProps = {
        flourishLeftImageURLs: (0,_object_spread/* default */.Z)({}, constants/* FLOURISH_LEFT_IMAGE_URLS */.CL),
        largeImageURL: heroImage === null || heroImage === void 0 ? void 0 : heroImage.largeImageURL,
        smallImageURL: heroImage === null || heroImage === void 0 ? void 0 : heroImage.smallImageURL,
        hkBackgroundPositionLgOrBigger: serviceIdForMember === constants/* ServiceIdForMember.HOUSEKEEPING */.u2.HOUSEKEEPING ? "top left, 88% center" : "top left, top right"
    };
    var classes = Hero_getClasses(styleProps);
    var prefillZipCode = function() {
        if (pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL) {
            var match = userGeoInfo === null || userGeoInfo === void 0 ? void 0 : userGeoInfo.match(/zip=(\d{5})/);
            if (match && match[1]) {
                return match[1];
            }
        }
        return "";
    };
    var prefillZipCodeForDirectoryFirst = function() {
        return (0,getZipcodeFromGeoInfo/* getZipcodeFromGeoInfo */.Z)(userGeoInfo);
    };
    var zipCodeRegex = /^\d{0,5}$/;
    var prefilledZipCode = prefillZipCode();
    var ref2 = (0,react.useState)({
        zipCode: prefilledZipCode
    }), zip = ref2[0], setZip = ref2[1];
    var zipInputRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (zipInputRef.current) {
            zipInputRef.current.setSelectionRange(zipInputRef.current.value.length, zipInputRef.current.value.length);
            zipInputRef.current.focus();
        }
    }, [
        zip
    ]);
    var hideGetStartedCta = serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE_LOCATION */.u2.CHILD_CARE_LOCATION || serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE */.u2.CHILD_CARE;
    var enrollmentLink = function() {
        if (directoryFirstExperience) {
            if (zip.zipCode && zip.zipCode.length === 5) {
                return "".concat(enrollmentURL, "&zipcode=").concat(zip.zipCode);
            }
            return "".concat(enrollmentURL, "&zipcode=").concat(prefillZipCodeForDirectoryFirst());
        }
        if (!directoryFirstExperience && zip.zipCode) {
            return "".concat(enrollmentURL, "&zipcode=").concat(zip.zipCode);
        }
        return "".concat(enrollmentURL);
    }();
    var getCtaText = function() {
        if (hideGetStartedCta) return "Start matching";
        return "Get Started";
    };
    var daycareDirectoryFirstFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.DAYCARE_DIRECTORY_FIRST_FLOW.id */.WV.DAYCARE_DIRECTORY_FIRST_FLOW.id);
    var handleCtaBtn = function() {
        var amplitudeData = {
            cta_text: getCtaText(),
            cta_type: "button"
        };
        if (daycareDirectoryFirstFlag && daycareDirectoryFirstFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.DAYCARE_DIRECTORY_FIRST_FLOW.id */.WV.DAYCARE_DIRECTORY_FIRST_FLOW.id,
                test_variant: daycareDirectoryFirstFlag.variationIndex,
                service_id_for_member: serviceIdForMember,
                page_template: pageType
            });
        }
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)("CTA Interacted", amplitudeData);
    };
    var onZipCodeChange = function(e) {
        var zipCodeVal = e.target.value;
        if (!zipCodeRegex.test(zipCodeVal)) {
            return;
        }
        setZip(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), {
                zipCode: zipCodeVal
            });
        });
    };
    var handleKeyUp = function(event) {
        if (event.key === "Enter") {
            globalThis.location.href = "".concat(enrollmentLink);
            handleCtaBtn();
        }
    };
    var renderZipCodeComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                    id: "zipCode",
                    name: "zipCode",
                    inputRef: zipInputRef,
                    onKeyUp: handleKeyUp,
                    placeholder: "ZIP code",
                    value: zip.zipCode,
                    onChange: onZipCodeChange,
                    InputProps: {
                        startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "start",
                            sx: classes.positionStart,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoLocation/* default */.Z, {})
                        })
                    },
                    sx: classes.textFieldOverride
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    sx: classes.ctaBtn,
                    color: "primary",
                    component: "a",
                    href: enrollmentLink,
                    onClick: handleCtaBtn,
                    size: "large",
                    variant: "contained",
                    rel: "nofollow",
                    children: getCtaText()
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                role: "dialog",
                "data-testid": "hero-container",
                sx: classes.heroContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        align: "center",
                        variant: "h1",
                        color: "primary",
                        sx: classes.heroHeadline,
                        dangerouslySetInnerHTML: {
                            __html: sanitize_html_default()(he_default().decode(headline))
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: classes.heroContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                "data-testid": "sub-text",
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML: {
                                    __html: sanitize_html_default()(he_default().decode(subHeadline))
                                },
                                sx: classes.heroImgSubText
                            }),
                            renderZipCodeComponent()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                ref: searchFiltersRef
            }),
            (segmentationStats === null || segmentationStats === void 0 ? void 0 : (ref = segmentationStats.avgPayRate) === null || ref === void 0 ? void 0 : ref.amount) && (segmentationStats === null || segmentationStats === void 0 ? void 0 : segmentationStats.avgReviewRating) && (segmentationStats === null || segmentationStats === void 0 ? void 0 : segmentationStats.avgYearsOfExperience) && (segmentationStats === null || segmentationStats === void 0 ? void 0 : segmentationStats.totalProviders) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ContentRibbon, {
                avgPayRate: segmentationStats.avgPayRate,
                avgYearsOfExperience: segmentationStats.avgYearsOfExperience,
                avgReviewRating: segmentationStats.avgReviewRating,
                totalProviders: segmentationStats.totalProviders
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorks/* default */.Z, {
                serviceIdForMember: serviceIdForMember,
                segmentNamePluralLowerCase: segmentNamePluralLowerCase,
                segmentNameSingularLowerCase: segmentNameSingularLowerCase
            })
        ]
    });
};
/* harmony default export */ var components_Hero = (Hero);

;// CONCATENATED MODULE: ./src/components/JobHero.tsx







var JobHero = function(param) {
    var enrollmentURL = param.enrollmentURL, headline = param.headline, heroImage = param.heroImage, subHeadline = param.subHeadline;
    var handleJoinFreeBtn = function() {
        var amplitudeData = {
            cta_text: "Join free to get started",
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)("CTA Interacted", amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: function(theme) {
            return (0,_define_property/* default */.Z)({
                overflow: "hidden",
                minHeight: "250px",
                padding: "".concat(theme.spacing(3), " 0"),
                backgroundPosition: "50% bottom",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundColor: theme.palette.care.grey[600],
                display: "flex",
                justifyContent: "center",
                backgroundImage: heroImage ? "url(".concat((0,createRelativeImageURL/* default */.Z)(heroImage.smallImageURL), ")") : "none"
            }, theme.breakpoints.up("sm"), {
                minHeight: "300px",
                backgroundImage: heroImage ? "url(".concat((0,createRelativeImageURL/* default */.Z)(heroImage.largeImageURL), ")") : "none"
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                minHeight: "250px",
                padding: 2
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    align: "center",
                    variant: "h1",
                    color: "primary",
                    sx: {
                        color: "care.white",
                        lineHeight: "32px",
                        fontSize: "2rem",
                        letterSpacing: "0.1px"
                    },
                    children: headline
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    "data-testid": "sub-text",
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: sanitize_html_default()(he_default().decode(subHeadline))
                    },
                    sx: {
                        color: "care.white",
                        textAlign: "center",
                        marginBottom: 2,
                        fontSize: "1rem",
                        fontWeight: 400,
                        lineHeight: "24px",
                        "& p:first-of-type": {
                            marginBottom: 0
                        },
                        "& p + p": {
                            margin: 0
                        }
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    href: enrollmentURL,
                    color: "primary",
                    variant: "contained",
                    component: "a",
                    className: "flexible",
                    onClick: handleJoinFreeBtn,
                    rel: "nofollow",
                    children: "Join free to get started"
                })
            ]
        })
    });
};
/* harmony default export */ var components_JobHero = (JobHero);

// EXTERNAL MODULE: ./src/components/ArticleCarousel.tsx
var ArticleCarousel = __webpack_require__(44559);
// EXTERNAL MODULE: ./src/components/SafetyModalWrapper.tsx
var SafetyModalWrapper = __webpack_require__(6150);
;// CONCATENATED MODULE: ./src/components/BackgroundCheckBanner.tsx






var BackgroundCheckBanner = function() {
    var ref = (0,react.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var handleBackgroundCheck = function() {
        setOpenModal(true);
        var amplitudeData = {
            feature_name: "background check banner"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                component: "button",
                p: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                color: "care.grey.900",
                mt: -2,
                border: "none",
                sx: function(theme) {
                    return {
                        height: "60px",
                        backgroundColor: theme.palette.care.blue[100],
                        fontWeight: 700,
                        "&:hover": {
                            cursor: "pointer"
                        }
                    };
                },
                onClick: handleBackgroundCheck,
                tabIndex: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        component: "span",
                        display: "inline-block",
                        mr: 0.5,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoBgcFilled/* default */.Z, {
                            size: "30px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        component: "span",
                        variant: isMobile ? "h5" : "h3",
                        children: [
                            "All caregivers are background checked.\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: "span",
                                borderBottom: 2,
                                children: "See more"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyModalWrapper/* SafetyModalWrapper */.S, {
                openModal: openModal,
                setOpenModal: setOpenModal
            })
        ]
    });
};
/* harmony default export */ var components_BackgroundCheckBanner = (BackgroundCheckBanner);

// EXTERNAL MODULE: ./src/utils/mapNavigationMenuContent.ts
var mapNavigationMenuContent = __webpack_require__(17411);
// EXTERNAL MODULE: ./src/components/contexts/SegmentationFiltersContext.tsx
var SegmentationFiltersContext = __webpack_require__(99207);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/StickyContainer/StickyContainer.js
var StickyContainer = __webpack_require__(14721);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityClose.js
var Icon24UtilityClose = __webpack_require__(82843);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Selector/Selector.js
var Selector = __webpack_require__(35740);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Pill/Pill.js
var Pill = __webpack_require__(26929);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 3 modules
var Accordion = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
;// CONCATENATED MODULE: ./src/components/Filters/MultiSelectPills.tsx






var MultiSelectPills = function(param) {
    var handleOnChangeEvent = param.handleOnChangeEvent, selectedValues = param.selectedValues, pillOptions = param.pillOptions, category = param.category, sectionName = param.sectionName;
    var localStorageFilters = (0,filtersStorage/* loadFilters */.dm)();
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var seniorCareProfessionalSkillsMap = {
        CERTIFIED_NURSING_ASSISTANT: "certifiedNursingAssistant",
        SENIOR_CARE_CPR_TRAINED: "seniorCareCprTrained",
        HOME_HEALTH_AIDE: "homeHealthAid",
        REGISTERED_NURSE: "registeredNurse"
    };
    var preferencesMap = {
        COMFORTABLE_WITH_PETS: "comfortableWithPets",
        HAS_CAR: "hasCar",
        NON_SMOKER: "nonSmoker"
    };
    // select all pill options that are currently in local storage
    var isSelected = function(value, section) {
        switch(section){
            case "SENIOR_CARE_CAN_HELP_WITH":
                var ref;
                return localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref = localStorageFilters.seniorCareSubServices) === null || ref === void 0 ? void 0 : ref.includes(value);
            case "SENIOR_CARE_PROFESSIONAL_SKILLS":
                var ref1;
                return (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters[seniorCareProfessionalSkillsMap[value]]) || value === globalTypes/* SEOSeniorCareSubServices.DEMENTIA */.ze.DEMENTIA && (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref1 = localStorageFilters.seniorCareSubServices) === null || ref1 === void 0 ? void 0 : ref1.includes(globalTypes/* SEOSeniorCareSubServices.DEMENTIA */.ze.DEMENTIA));
            case "PREFERENCES":
                return localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters[preferencesMap[value]];
            case "LANGUAGES_SPOKEN":
                var ref2;
                return localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref2 = localStorageFilters.languages) === null || ref2 === void 0 ? void 0 : ref2.includes(value);
            case "CHILD_AGE_RANGES":
                var ref3;
                return localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref3 = localStorageFilters.childCareAgeGroups) === null || ref3 === void 0 ? void 0 : ref3.includes(value);
            case "CHILD_CARE_PROFESSIONAL_SKILLS":
                var ref4;
                return localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref4 = localStorageFilters.childCareQualifications) === null || ref4 === void 0 ? void 0 : ref4.includes(value);
            case "HOME_CARE_CAN_HELP_WITH":
                var ref5;
                return localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref5 = localStorageFilters.housekeepingSubServices) === null || ref5 === void 0 ? void 0 : ref5.includes(value);
            default:
                return false;
        }
    };
    var pills = /*#__PURE__*/ (0,jsx_runtime.jsx)(Selector/* default */.Z, {
        onChange: function(values) {
            return handleOnChangeEvent(values);
        },
        horizontal: true,
        value: selectedValues,
        name: category,
        sx: function(theme) {
            return {
                "& > li": {
                    margin: theme.spacing(0.5, 1, 0.5, 0)
                }
            };
        },
        children: pillOptions.map(function(param) {
            var label = param.label, value = param.value;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* default */.Z, {
                label: label,
                value: value,
                selected: isSelected(value, category)
            }, value);
        })
    });
    var mobileView = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h3",
                    children: sectionName
                })
            }),
            pills
        ]
    });
    var desktopView = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
        elevation: 0,
        defaultExpanded: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {}),
                sx: {
                    padding: 0,
                    width: "fit-content"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h3",
                    children: sectionName
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                sx: function(theme) {
                    return {
                        padding: theme.spacing(0, 0, 0, 0.5)
                    };
                },
                children: pills
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "section",
        mb: 2,
        children: isMobile ? mobileView : desktopView
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/SeniorCare/CanHelpWith.tsx



var CanHelpWith = function(param) {
    var canHelpWithServices = param.canHelpWithServices, setCanHelpWithServices = param.setCanHelpWithServices;
    var seniorCareSubServicesOptions = [
        {
            label: "Companionship",
            value: globalTypes/* SEOSeniorCareSubServices.COMPANIONSHIP */.ze.COMPANIONSHIP
        },
        {
            label: "Mobility assistance",
            value: globalTypes/* SEOSeniorCareSubServices.MOBILITY_ASSISTANCE */.ze.MOBILITY_ASSISTANCE
        },
        {
            label: "Personal care",
            value: globalTypes/* SEOSeniorCareSubServices.PERSONAL_CARE */.ze.PERSONAL_CARE
        },
        {
            label: "Specialized care",
            value: globalTypes/* SEOSeniorCareSubServices.SPECIALIZED_CARE */.ze.SPECIALIZED_CARE
        },
        {
            label: "Transportation",
            value: globalTypes/* SEOSeniorCareSubServices.TRANSPORTATION */.ze.TRANSPORTATION
        }, 
    ];
    var handleOnChangeEvent = function(values) {
        // Dementia exists under "Professional skills" section on the UI, but is added to seniorCareSubServices
        if (canHelpWithServices && canHelpWithServices.includes(globalTypes/* SEOSeniorCareSubServices.DEMENTIA */.ze.DEMENTIA)) {
            setCanHelpWithServices(values.concat(globalTypes/* SEOSeniorCareSubServices.DEMENTIA */.ze.DEMENTIA));
        } else {
            setCanHelpWithServices(values);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectPills, {
        sectionName: "Can help with",
        handleOnChangeEvent: handleOnChangeEvent,
        pillOptions: seniorCareSubServicesOptions,
        category: "SENIOR_CARE_CAN_HELP_WITH",
        selectedValues: canHelpWithServices || []
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/PayRate.tsx







var PayRate_PayRate = function(param) {
    var hourlyRate = param.hourlyRate, setHourlyRate = param.setHourlyRate;
    var localStorageFilters = (0,filtersStorage/* loadFilters */.dm)();
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    // check if hourlyRate filter is currently applied
    (0,react.useEffect)(function() {
        var currentHourlyRate = function() {
            var ref;
            var previousHourlyRate = localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref = localStorageFilters.hourlyRate) === null || ref === void 0 ? void 0 : ref.split("-");
            if (previousHourlyRate && (previousHourlyRate === null || previousHourlyRate === void 0 ? void 0 : previousHourlyRate.length) === 2) {
                var _previousHourlyRate = (0,_sliced_to_array/* default */.Z)(previousHourlyRate, 2), previousMin = _previousHourlyRate[0], previousMax = _previousHourlyRate[1];
                return [
                    Number(previousMin),
                    Number(previousMax)
                ];
            }
            return hourlyRate;
        };
        setHourlyRate(currentHourlyRate());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handlePayRateChanges = function(val) {
        if (Array.isArray(val) && val.length === 2) {
            var _val = (0,_sliced_to_array/* default */.Z)(val, 2), minHourlyRate = _val[0], maxHourlyRate = _val[1];
            setHourlyRate([
                minHourlyRate,
                maxHourlyRate
            ]);
        }
    };
    var slider = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mt: 1,
        pl: 1,
        pr: 2.5,
        sx: {
            maxWidth: "327px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
            appendRange: true,
            max: 50,
            min: 10,
            step: 1,
            prefix: "$",
            unit: "/ hour",
            value: hourlyRate,
            onChange: handlePayRateChanges,
            "aria-label": "range-slider",
            sx: function(theme) {
                return {
                    "& .MuiSlider-root": {
                        padding: "13px 0"
                    },
                    "& span.bigLabel": {
                        marginLeft: theme.spacing(-1)
                    }
                };
            }
        })
    });
    var mobileView = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h3",
                children: "Pay rate"
            }),
            slider
        ]
    });
    var desktopView = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
        elevation: 0,
        defaultExpanded: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {}),
                sx: {
                    padding: 0,
                    width: "fit-content"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h3",
                    children: "Pay rate"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                sx: function(theme) {
                    return {
                        padding: theme.spacing(0, 0, 0, 0.5)
                    };
                },
                children: slider
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "section",
        mb: 2,
        children: isMobile ? mobileView : desktopView
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/SeniorCare/ProfessionalSkills.tsx





var ProfessionalSkills = function(param) {
    var setProfessionalSkillsObject = param.setProfessionalSkillsObject, seniorCareSubServices = param.seniorCareSubServices, setSeniorCareSubServices = param.setSeniorCareSubServices;
    var localStorageFilters = (0,filtersStorage/* loadFilters */.dm)();
    var CERTIFIED_NURSING_ASSISTANT = "CERTIFIED_NURSING_ASSISTANT";
    var SENIOR_CARE_CPR_TRAINED = "SENIOR_CARE_CPR_TRAINED";
    var HOME_HEALTH_AIDE = "HOME_HEALTH_AIDE";
    var REGISTERED_NURSE = "REGISTERED_NURSE";
    var DEMENTIA = globalTypes/* SEOSeniorCareSubServices.DEMENTIA */.ze.DEMENTIA;
    /*
   * The value of "Alzheimers/Dementia experience" currently does exist in our index.
   * Therefore, we are substituting its value for 'DEMENTIA' which exists in SEOSeniorCareSubServices
   */ var seniorCareProfessionalSkillsList = [
        {
            label: "Alzheimers/Dementia experience",
            value: DEMENTIA
        },
        {
            label: "Certified nursing assistant",
            value: CERTIFIED_NURSING_ASSISTANT
        },
        {
            label: "Cpr trained",
            value: SENIOR_CARE_CPR_TRAINED
        },
        {
            label: "Home health aide",
            value: HOME_HEALTH_AIDE
        },
        {
            label: "Registered nurse",
            value: REGISTERED_NURSE
        }, 
    ];
    var ref = (0,react.useState)([]), professionalSkillsList = ref[0], setProfessionalSkillsList = ref[1];
    // check if any professional skill filters are currently applied from local storage
    (0,react.useEffect)(function() {
        var ref;
        var currentProfessionalSkills = {
            certifiedNursingAssistant: false,
            seniorCareCprTrained: false,
            homeHealthAid: false,
            registeredNurse: false
        };
        var currentProfessionalSkillsList = [];
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.certifiedNursingAssistant) {
            currentProfessionalSkills.certifiedNursingAssistant = true;
            currentProfessionalSkillsList.push(CERTIFIED_NURSING_ASSISTANT);
        }
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.seniorCareCprTrained) {
            currentProfessionalSkills.seniorCareCprTrained = true;
            currentProfessionalSkillsList.push(SENIOR_CARE_CPR_TRAINED);
        }
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.homeHealthAid) {
            currentProfessionalSkills.homeHealthAid = true;
            currentProfessionalSkillsList.push(HOME_HEALTH_AIDE);
        }
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.registeredNurse) {
            currentProfessionalSkills.registeredNurse = true;
            currentProfessionalSkillsList.push(REGISTERED_NURSE);
        }
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : (ref = localStorageFilters.seniorCareSubServices) === null || ref === void 0 ? void 0 : ref.includes(DEMENTIA)) {
            currentProfessionalSkillsList.push(DEMENTIA);
        }
        setProfessionalSkillsObject(currentProfessionalSkills);
        setProfessionalSkillsList(currentProfessionalSkillsList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleOnChangeEvent = function(values) {
        var professionalSkillsFilters = {
            certifiedNursingAssistant: false,
            seniorCareCprTrained: false,
            homeHealthAid: false,
            registeredNurse: false
        };
        values.forEach(function(skill) {
            switch(skill){
                case CERTIFIED_NURSING_ASSISTANT:
                    professionalSkillsFilters.certifiedNursingAssistant = true;
                    break;
                case SENIOR_CARE_CPR_TRAINED:
                    professionalSkillsFilters.seniorCareCprTrained = true;
                    break;
                case HOME_HEALTH_AIDE:
                    professionalSkillsFilters.homeHealthAid = true;
                    break;
                case REGISTERED_NURSE:
                    professionalSkillsFilters.registeredNurse = true;
                    break;
                case DEMENTIA:
                    if (!seniorCareSubServices || seniorCareSubServices.length < 1) {
                        setSeniorCareSubServices([
                            DEMENTIA
                        ]);
                    } else if (seniorCareSubServices && !seniorCareSubServices.includes(DEMENTIA)) {
                        var subServices = seniorCareSubServices.slice();
                        subServices.push(DEMENTIA);
                        setSeniorCareSubServices(subServices);
                    }
                    break;
                default:
            }
        });
        // remove Dementia from subservices if it has not been selected
        if (!values.includes(DEMENTIA) && (seniorCareSubServices === null || seniorCareSubServices === void 0 ? void 0 : seniorCareSubServices.includes(DEMENTIA))) {
            var subServices = seniorCareSubServices.slice();
            var index = seniorCareSubServices.indexOf(DEMENTIA);
            subServices.splice(index, 1);
            setSeniorCareSubServices(subServices);
        }
        setProfessionalSkillsList(values);
        setProfessionalSkillsObject(professionalSkillsFilters);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectPills, {
        sectionName: "Professional skills",
        handleOnChangeEvent: handleOnChangeEvent,
        pillOptions: seniorCareProfessionalSkillsList,
        category: "SENIOR_CARE_PROFESSIONAL_SKILLS",
        selectedValues: professionalSkillsList
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Preferences.tsx




var Preferences = function(param) {
    var setPreferencesObject = param.setPreferencesObject;
    var localStorageFilters = (0,filtersStorage/* loadFilters */.dm)();
    var COMFORTABLE_WITH_PETS = "COMFORTABLE_WITH_PETS";
    var HAS_CAR = "HAS_CAR";
    var NON_SMOKER = "NON_SMOKER";
    var preferenceOptions = [
        {
            label: "Comfortable with pets",
            value: COMFORTABLE_WITH_PETS
        },
        {
            label: "Has own transportation",
            value: HAS_CAR
        },
        {
            label: "Non-smoker",
            value: NON_SMOKER
        }, 
    ];
    var ref = (0,react.useState)([]), preferencesList = ref[0], setPreferencesList = ref[1];
    // check if any preference filters are currently applied from local storage
    (0,react.useEffect)(function() {
        var localStoragePreferencesFilters = {
            comfortableWithPets: false,
            hasCar: false,
            nonSmoker: false
        };
        var currentPreferencesList = [];
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.comfortableWithPets) {
            localStoragePreferencesFilters.comfortableWithPets = true;
            currentPreferencesList.push(COMFORTABLE_WITH_PETS);
        }
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.hasCar) {
            localStoragePreferencesFilters.hasCar = true;
            currentPreferencesList.push(HAS_CAR);
        }
        if (localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.nonSmoker) {
            localStoragePreferencesFilters.nonSmoker = true;
            currentPreferencesList.push(NON_SMOKER);
        }
        setPreferencesObject(localStoragePreferencesFilters);
        setPreferencesList(currentPreferencesList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleOnChangeEvent = function(values) {
        var preferencesFilters = {
            comfortableWithPets: false,
            hasCar: false,
            nonSmoker: false
        };
        values.forEach(function(skill) {
            switch(skill){
                case COMFORTABLE_WITH_PETS:
                    preferencesFilters.comfortableWithPets = true;
                    break;
                case HAS_CAR:
                    preferencesFilters.hasCar = true;
                    break;
                case NON_SMOKER:
                    preferencesFilters.nonSmoker = true;
                    break;
                default:
            }
        });
        setPreferencesObject(preferencesFilters);
        setPreferencesList(values);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectPills, {
        sectionName: "Preferences",
        handleOnChangeEvent: handleOnChangeEvent,
        pillOptions: preferenceOptions,
        category: "PREFERENCES",
        selectedValues: preferencesList
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/LanguagesSpoken.tsx



var LanguagesSpoken = function(param) {
    var languagesSpoken = param.languagesSpoken, setLanguagesSpoken = param.setLanguagesSpoken;
    var languagesList = [
        {
            label: "American Sign Language",
            value: globalTypes/* Language.SIGN_LANGUAGE_ASL */.SQ.SIGN_LANGUAGE_ASL
        },
        {
            label: "Arabic",
            value: globalTypes/* Language.ARABIC */.SQ.ARABIC
        },
        {
            label: "Chinese (Mandarin)",
            value: globalTypes/* Language.CHINESE */.SQ.CHINESE
        },
        {
            label: "English",
            value: globalTypes/* Language.ENGLISH */.SQ.ENGLISH
        },
        {
            label: "French",
            value: globalTypes/* Language.FRENCH */.SQ.FRENCH
        },
        {
            label: "German",
            value: globalTypes/* Language.GERMAN */.SQ.GERMAN
        },
        {
            label: "Hindi",
            value: globalTypes/* Language.HINDI */.SQ.HINDI
        },
        {
            label: "Japanese",
            value: globalTypes/* Language.JAPANESE */.SQ.JAPANESE
        },
        {
            label: "Korean",
            value: globalTypes/* Language.KOREAN */.SQ.KOREAN
        },
        {
            label: "Portuguese",
            value: globalTypes/* Language.PORTUGUESE */.SQ.PORTUGUESE
        },
        {
            label: "Russian",
            value: globalTypes/* Language.RUSSIAN */.SQ.RUSSIAN
        },
        {
            label: "Spanish",
            value: globalTypes/* Language.SPANISH */.SQ.SPANISH
        },
        {
            label: "Tagalog",
            value: globalTypes/* Language.TAGALOG */.SQ.TAGALOG
        }, 
    ];
    var handleOnChangeEvent = function(values) {
        setLanguagesSpoken(values);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectPills, {
        sectionName: "Languages spoken",
        handleOnChangeEvent: handleOnChangeEvent,
        pillOptions: languagesList,
        category: "LANGUAGES_SPOKEN",
        selectedValues: languagesSpoken || []
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/SeniorCare/SeniorCareFilters.tsx






var SeniorCareFilters = function(param) {
    var hourlyRate = param.hourlyRate, setHourlyRate = param.setHourlyRate, seniorCareSubServices = param.seniorCareSubServices, setSeniorCareSubServices = param.setSeniorCareSubServices, setProfessionalSkillsObject = param.setProfessionalSkillsObject, setPreferencesObject = param.setPreferencesObject, languagesSpoken = param.languagesSpoken, setLanguagesSpoken = param.setLanguagesSpoken;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayRate_PayRate, {
                hourlyRate: hourlyRate,
                setHourlyRate: setHourlyRate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CanHelpWith, {
                canHelpWithServices: seniorCareSubServices,
                setCanHelpWithServices: setSeniorCareSubServices
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfessionalSkills, {
                setProfessionalSkillsObject: setProfessionalSkillsObject,
                seniorCareSubServices: seniorCareSubServices,
                setSeniorCareSubServices: setSeniorCareSubServices
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Preferences, {
                setPreferencesObject: setPreferencesObject
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguagesSpoken, {
                languagesSpoken: languagesSpoken,
                setLanguagesSpoken: setLanguagesSpoken
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/PetCare/PetCareFilters.tsx


var PetCareFilters = function(param) {
    var hourlyRate = param.hourlyRate, setHourlyRate = param.setHourlyRate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PayRate_PayRate, {
        hourlyRate: hourlyRate,
        setHourlyRate: setHourlyRate
    });
};


// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilitySubtract.js
var Icon24UtilitySubtract = __webpack_require__(44153);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityAdd.js
var Icon24UtilityAdd = __webpack_require__(21256);
;// CONCATENATED MODULE: ./src/components/Filters/Verticals/ChildCare/NumberOfChildren.tsx



var NumberOfChildren_classes = {
    button: function(theme) {
        return {
            width: "auto",
            height: "auto",
            padding: 0,
            "& svg": {
                height: "auto",
                "& path": {
                    fill: "".concat(theme.palette.care.white, " !important")
                }
            }
        };
    },
    disableButton: function(theme) {
        return {
            "& circle": {
                fill: theme.palette.grey[400]
            }
        };
    }
};
var NumberOfChildren = function(param) {
    var numberOfChildren = param.numberOfChildren, setNumberOfChildren = param.setNumberOfChildren;
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var isMinimumOrLessValue = numberOfChildren <= 1;
    var isMaximumOrMoreValue = numberOfChildren >= 5;
    var childOrChildren = numberOfChildren < 2 ? "Child" : "Children";
    var handleAdd = function(numOfChildren) {
        if (numOfChildren < 5) {
            setNumberOfChildren(numOfChildren + 1);
        }
    };
    var handleSubtract = function(numOfChildren) {
        if (numOfChildren > 1) {
            setNumberOfChildren(numOfChildren - 1);
        }
    };
    var renderNumberOfChildren = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        alignItems: "center",
        justifyContent: isMobile ? "space-between" : "flex-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                minWidth: "22%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "h2",
                    children: [
                        numberOfChildren < 5 ? numberOfChildren : "".concat(numberOfChildren, "+"),
                        " ",
                        childOrChildren
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: function() {
                            return handleSubtract(numberOfChildren);
                        },
                        disabled: isMinimumOrLessValue,
                        "data-testid": "subtract-button",
                        sx: NumberOfChildren_classes.button,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilitySubtract/* default */.Z, {
                            size: 40,
                            sx: isMinimumOrLessValue ? NumberOfChildren_classes.disableButton : undefined
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: function() {
                            return handleAdd(numberOfChildren);
                        },
                        disabled: isMaximumOrMoreValue,
                        "data-testid": "add-button",
                        sx: NumberOfChildren_classes.button,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityAdd/* default */.Z, {
                            size: 40,
                            sx: isMaximumOrMoreValue ? NumberOfChildren_classes.disableButton : undefined
                        })
                    })
                ]
            })
        ]
    });
    var mobileView = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h3",
                children: "Number of children"
            }),
            renderNumberOfChildren
        ]
    });
    var desktopView = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
        elevation: 0,
        defaultExpanded: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {}),
                sx: {
                    padding: 0,
                    width: "fit-content"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h3",
                    children: "Number of children"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                sx: function(theme) {
                    return {
                        padding: theme.spacing(0, 0, 0, 0.5)
                    };
                },
                children: renderNumberOfChildren
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "section",
        mb: 2,
        children: isMobile ? mobileView : desktopView
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/ChildCare/ChildAgeRanges.tsx



var ChildAgeRanges = function(param) {
    var childCareAgeGroupsList = param.childCareAgeGroupsList, setChildCareAgeGroupsList = param.setChildCareAgeGroupsList;
    var childCareAgeRangeList = [
        {
            label: "0 - 11 months",
            value: globalTypes/* ChildCareAgeGroups.NEWBORN */._$.NEWBORN
        },
        {
            label: "1 - 3 yrs",
            value: globalTypes/* ChildCareAgeGroups.TODDLER */._$.TODDLER
        },
        {
            label: "4 - 5 yrs",
            value: globalTypes/* ChildCareAgeGroups.EARLY_SCHOOL */._$.EARLY_SCHOOL
        },
        {
            label: "6 - 11 yrs",
            value: globalTypes/* ChildCareAgeGroups.ELEMENTARY_SCHOOL */._$.ELEMENTARY_SCHOOL
        },
        {
            label: "12+ yrs",
            value: globalTypes/* ChildCareAgeGroups.TEEN */._$.TEEN
        }, 
    ];
    var handleOnChangeEvent = function(values) {
        setChildCareAgeGroupsList(values);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectPills, {
        sectionName: "Child age ranges",
        handleOnChangeEvent: handleOnChangeEvent,
        pillOptions: childCareAgeRangeList,
        category: "CHILD_AGE_RANGES",
        selectedValues: childCareAgeGroupsList
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/ChildCare/ProfessionalSkills.tsx



var ProfessionalSkills_ProfessionalSkills = function(param) {
    var childCareProfessionalSkillsList = param.childCareProfessionalSkillsList, setChildCareProfessionalSkillsList = param.setChildCareProfessionalSkillsList;
    var childCareProfessionalSkills = [
        {
            label: "CPR training",
            value: globalTypes/* SEOChildCareQualifications.CPR_TRAINING */.BY.CPR_TRAINING
        },
        {
            label: "First Aid training",
            value: globalTypes/* SEOChildCareQualifications.FIRST_AID_TRAINING */.BY.FIRST_AID_TRAINING
        },
        {
            label: "Special needs care",
            value: globalTypes/* SEOChildCareQualifications.SPECIAL_NEEDS_CARE */.BY.SPECIAL_NEEDS_CARE
        }, 
    ];
    var handleOnChangeEvent = function(values) {
        setChildCareProfessionalSkillsList(values);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectPills, {
        sectionName: "Professional skills",
        handleOnChangeEvent: handleOnChangeEvent,
        pillOptions: childCareProfessionalSkills,
        category: "CHILD_CARE_PROFESSIONAL_SKILLS",
        selectedValues: childCareProfessionalSkillsList
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/ChildCare/ChildCareFilters.tsx







var ChildCareFilters = function(param) {
    var hourlyRate = param.hourlyRate, setHourlyRate = param.setHourlyRate, numberOfChildren = param.numberOfChildren, setNumberOfChildren = param.setNumberOfChildren, childCareAgeGroupsList = param.childCareAgeGroupsList, setChildCareAgeGroupsList = param.setChildCareAgeGroupsList, childCareProfessionalSkillsList = param.childCareProfessionalSkillsList, setChildCareProfessionalSkillsList = param.setChildCareProfessionalSkillsList, setPreferencesObject = param.setPreferencesObject, languagesSpoken = param.languagesSpoken, setLanguagesSpoken = param.setLanguagesSpoken;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayRate_PayRate, {
                hourlyRate: hourlyRate,
                setHourlyRate: setHourlyRate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberOfChildren, {
                numberOfChildren: numberOfChildren,
                setNumberOfChildren: setNumberOfChildren
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildAgeRanges, {
                childCareAgeGroupsList: childCareAgeGroupsList,
                setChildCareAgeGroupsList: setChildCareAgeGroupsList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfessionalSkills_ProfessionalSkills, {
                childCareProfessionalSkillsList: childCareProfessionalSkillsList,
                setChildCareProfessionalSkillsList: setChildCareProfessionalSkillsList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Preferences, {
                setPreferencesObject: setPreferencesObject
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguagesSpoken, {
                languagesSpoken: languagesSpoken,
                setLanguagesSpoken: setLanguagesSpoken
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/utils/getAmplitudeFilters.ts


var ALZHEIMERS_DEMENTIA_EXPERIENCE = "ALZHEIMERS_DEMENTIA_EXPERIENCE";
var CERTIFIED_NURSING_ASSISTANT = "CERTIFIED_NURSING_ASSISTANT";
var SENIOR_CARE_CPR_TRAINED = "SENIOR_CARE_CPR_TRAINED";
var HOME_HEALTH_AIDE = "HOME_HEALTH_AIDE";
var REGISTERED_NURSE = "REGISTERED_NURSE";
var COMFORTABLE_WITH_PETS = "COMFORTABLE_WITH_PETS";
var HAS_CAR = "HAS_CAR";
var NON_SMOKER = "NON_SMOKER";
var getAmplitudeFilters = function(filters, vertical) {
    var amplitudeFilters = {
        feature_name: "Filters Applied"
    };
    var preferencesList = [];
    var professionalSkillsList = [];
    switch(vertical){
        case "SENIOR_CARE":
            var ref;
            // set 'can_help_with'
            if (filters === null || filters === void 0 ? void 0 : (ref = filters.seniorCareSubServices) === null || ref === void 0 ? void 0 : ref.includes(globalTypes/* SEOSeniorCareSubServices.DEMENTIA */.ze.DEMENTIA)) {
                // Remove 'Dementia' from 'can_help_with'
                var canHelpWith = filters.seniorCareSubServices.slice();
                var index = canHelpWith.indexOf(globalTypes/* SEOSeniorCareSubServices.DEMENTIA */.ze.DEMENTIA);
                canHelpWith.splice(index, 1);
                // Add 'Alzheimers/Dementia experience' to 'professionalSkillsList'
                professionalSkillsList.push(ALZHEIMERS_DEMENTIA_EXPERIENCE);
                if (canHelpWith.length > 0) {
                    amplitudeFilters.can_help_with = canHelpWith.join(", ");
                }
            } else if ((filters === null || filters === void 0 ? void 0 : filters.seniorCareSubServices) && filters.seniorCareSubServices.length > 0) {
                amplitudeFilters.can_help_with = filters.seniorCareSubServices.join(", ");
            }
            // set 'professional_skills' for Senior Care vertical
            if (filters === null || filters === void 0 ? void 0 : filters.certifiedNursingAssistant) {
                professionalSkillsList.push(CERTIFIED_NURSING_ASSISTANT);
            }
            if (filters === null || filters === void 0 ? void 0 : filters.seniorCareCprTrained) {
                professionalSkillsList.push(SENIOR_CARE_CPR_TRAINED);
            }
            if (filters === null || filters === void 0 ? void 0 : filters.homeHealthAid) {
                professionalSkillsList.push(HOME_HEALTH_AIDE);
            }
            if (filters === null || filters === void 0 ? void 0 : filters.registeredNurse) {
                professionalSkillsList.push(REGISTERED_NURSE);
            }
            if (professionalSkillsList.length > 0) {
                amplitudeFilters.professional_skills = professionalSkillsList.join(", ");
            }
            break;
        case "CHILD_CARE":
            // set 'number_of_children'
            if (filters === null || filters === void 0 ? void 0 : filters.numberOfChildren) {
                amplitudeFilters.number_of_children = filters.numberOfChildren;
            }
            // set 'child_age_ranges'
            if ((filters === null || filters === void 0 ? void 0 : filters.childCareAgeGroups) && filters.childCareAgeGroups.length > 0) {
                amplitudeFilters.child_age_ranges = filters.childCareAgeGroups.join(", ");
            }
            // set 'professional_skills' for Child Care vertical
            if ((filters === null || filters === void 0 ? void 0 : filters.childCareQualifications) && filters.childCareQualifications.length > 0) {
                amplitudeFilters.professional_skills = filters.childCareQualifications.join(", ");
            }
            break;
        case "HOME_CARE":
            // set 'can_help_with' for Home Care vertical
            if (filters === null || filters === void 0 ? void 0 : filters.housekeepingSubServices) {
                amplitudeFilters.can_help_with = filters.housekeepingSubServices.join(", ");
            }
            break;
        default:
    }
    // set 'min_rate' and 'max_rate'
    if (filters === null || filters === void 0 ? void 0 : filters.hourlyRate) {
        var ref1 = (0,_sliced_to_array/* default */.Z)(filters.hourlyRate.split("-"), 2), minHourlyRate = ref1[0], maxHourlyRate = ref1[1];
        amplitudeFilters.min_rate = Number(minHourlyRate);
        amplitudeFilters.max_rate = Number(maxHourlyRate);
    }
    // set 'preferences' for Senior Care and Child Care verticals
    if (filters === null || filters === void 0 ? void 0 : filters.comfortableWithPets) {
        preferencesList.push(COMFORTABLE_WITH_PETS);
    }
    if (filters === null || filters === void 0 ? void 0 : filters.hasCar) {
        preferencesList.push(HAS_CAR);
    }
    if (filters === null || filters === void 0 ? void 0 : filters.nonSmoker) {
        preferencesList.push(NON_SMOKER);
    }
    if (preferencesList.length > 0) {
        amplitudeFilters.preferences = preferencesList.join(", ");
    }
    // set 'languages_spoken'
    if ((filters === null || filters === void 0 ? void 0 : filters.languages) && filters.languages.length > 0) {
        amplitudeFilters.languages_spoken = filters.languages.join(", ");
    }
    return amplitudeFilters;
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/HomeCare/CanHelpWith.tsx



var CanHelpWith_CanHelpWith = function(param) {
    var canHelpWithServices = param.canHelpWithServices, setCanHelpWithServices = param.setCanHelpWithServices;
    var homeCareSubServicesOptions = [
        {
            label: "Bathroom cleaning",
            value: globalTypes/* HousekeepingService.BATHROOM_CLEANING */.gg.BATHROOM_CLEANING
        },
        {
            label: "Carpet cleaning",
            value: globalTypes/* HousekeepingService.CARPET_CLEANING */.gg.CARPET_CLEANING
        },
        {
            label: "Kitchen cleaning",
            value: globalTypes/* HousekeepingService.KITCHEN_CLEANING */.gg.KITCHEN_CLEANING
        },
        {
            label: "Laundry",
            value: globalTypes/* HousekeepingService.LAUNDRY */.gg.LAUNDRY
        },
        {
            label: "Window cleaning",
            value: globalTypes/* HousekeepingService.WINDOW_WASHING */.gg.WINDOW_WASHING
        }, 
    ];
    var handleOnChangeEvent = function(values) {
        setCanHelpWithServices(values);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectPills, {
        sectionName: "Can help with",
        handleOnChangeEvent: handleOnChangeEvent,
        pillOptions: homeCareSubServicesOptions,
        category: "HOME_CARE_CAN_HELP_WITH",
        selectedValues: canHelpWithServices || []
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Verticals/HomeCare/HomeCareFilters.tsx



var HomeCareFilters = function(param) {
    var hourlyRate = param.hourlyRate, setHourlyRate = param.setHourlyRate, housekeepingSubServices = param.housekeepingSubServices, setHousekeepingSubServices = param.setHousekeepingSubServices;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayRate_PayRate, {
                hourlyRate: hourlyRate,
                setHourlyRate: setHourlyRate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CanHelpWith_CanHelpWith, {
                canHelpWithServices: housekeepingSubServices,
                setCanHelpWithServices: setHousekeepingSubServices
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/Filters.tsx



















var Filters_Filters = function(param) {
    var setPopoverAnchorEl = param.setPopoverAnchorEl, setOpenFiltersPopover = param.setOpenFiltersPopover, setOpenFiltersModal = param.setOpenFiltersModal;
    var localStorageFilters = (0,filtersStorage/* loadFilters */.dm)();
    var ref = (0,SegmentationFiltersContext/* useSegmentationFiltersContext */.RZ)(), fetchResults = ref.fetchResults, filters = ref.filters;
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var ref1 = (0,PageAttributesContext/* usePageAttributes */.l)(), searchingFor = ref1.searchingFor, serviceIdForMember = ref1.serviceIdForMember;
    var professionalSkillsOptions = {
        certifiedNursingAssistant: false,
        seniorCareCprTrained: false,
        homeHealthAid: false,
        registeredNurse: false
    };
    var preferencesOptions = {
        comfortableWithPets: false,
        hasCar: false,
        nonSmoker: false
    };
    var ref2 = (0,react.useState)([
        10,
        50
    ]), hourlyRate = ref2[0], setHourlyRate = ref2[1];
    var ref3 = (0,react.useState)((localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.seniorCareSubServices) || []), seniorCareSubServices = ref3[0], setSeniorCareSubServices = ref3[1];
    var ref4 = (0,react.useState)(professionalSkillsOptions), seniorCareProfessionalSkillsObject = ref4[0], setSeniorCareProfessionalSkillsObject = ref4[1];
    var ref5 = (0,react.useState)(preferencesOptions), preferencesObject = ref5[0], setPreferencesObject = ref5[1];
    var ref6 = (0,react.useState)((localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.languages) || []), languagesSpoken = ref6[0], setLanguagesSpoken = ref6[1];
    var ref7;
    var ref8 = (0,react.useState)((ref7 = localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.numberOfChildren) !== null && ref7 !== void 0 ? ref7 : 1), numberOfChildren = ref8[0], setNumberOfChildren = ref8[1];
    var ref9 = (0,react.useState)((localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.childCareAgeGroups) || []), childCareAgeGroupsList = ref9[0], setChildCareAgeGroupsList = ref9[1];
    var ref10 = (0,react.useState)((localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.childCareQualifications) || []), childCareProfessionalSkillsList = ref10[0], setChildCareProfessionalSkillsList = ref10[1];
    var ref11 = (0,react.useState)((localStorageFilters === null || localStorageFilters === void 0 ? void 0 : localStorageFilters.housekeepingSubServices) || []), housekeepingSubServices = ref11[0], setHousekeepingSubServices = ref11[1];
    var showPetCareUserFilters = searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER && serviceIdForMember === constants/* ServiceIdForMember.PET_CARE */.u2.PET_CARE;
    var showSeniorCareUserFilters = searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER && serviceIdForMember === constants/* ServiceIdForMember.SENIOR_CARE */.u2.SENIOR_CARE;
    var showChildCareUserFilters = (searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER || searchingFor === globalTypes/* SEOSegmentationSearchingFor.ALL_PROVIDER */.yh.ALL_PROVIDER) && (serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE */.u2.CHILD_CARE || serviceIdForMember === constants/* ServiceIdForMember.BABYSITTER */.u2.BABYSITTER || serviceIdForMember === constants/* ServiceIdForMember.NANNY */.u2.NANNY);
    var showHomeCareUserFilters = (searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER || searchingFor === globalTypes/* SEOSegmentationSearchingFor.ALL_PROVIDER */.yh.ALL_PROVIDER) && serviceIdForMember === constants/* ServiceIdForMember.HOUSEKEEPING */.u2.HOUSEKEEPING;
    var handleCloseButton = function() {
        if (setOpenFiltersPopover) {
            setOpenFiltersPopover(false);
        }
        if (setOpenFiltersModal) {
            setOpenFiltersModal(false);
        }
        if (setPopoverAnchorEl) {
            setPopoverAnchorEl(null);
        }
    };
    var handleResetClick = function() {
        var ref;
        (0,filtersStorage/* clearFilters */.K5)();
        fetchResults({
            zipcode: filters === null || filters === void 0 ? void 0 : (ref = filters.location) === null || ref === void 0 ? void 0 : ref.zipcode
        }, true);
        handleCloseButton();
    };
    var getCurrentFilters = function() {
        var _hourlyRate = (0,_sliced_to_array/* default */.Z)(hourlyRate, 2), minHourlyRate = _hourlyRate[0], maxHourlyRate = _hourlyRate[1];
        var currentHourlyRate = "".concat(minHourlyRate, "-").concat(maxHourlyRate);
        if (showPetCareUserFilters) {
            return {
                hourlyRate: currentHourlyRate
            };
        }
        if (showSeniorCareUserFilters) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                hourlyRate: currentHourlyRate,
                seniorCareSubServices: seniorCareSubServices
            }, seniorCareProfessionalSkillsObject, preferencesObject), {
                languages: languagesSpoken
            });
        }
        if (showChildCareUserFilters) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                hourlyRate: currentHourlyRate,
                numberOfChildren: numberOfChildren,
                childCareAgeGroups: childCareAgeGroupsList,
                childCareQualifications: childCareProfessionalSkillsList
            }, preferencesObject), {
                languages: languagesSpoken
            });
        }
        if (showHomeCareUserFilters) {
            return {
                hourlyRate: currentHourlyRate,
                housekeepingSubServices: housekeepingSubServices
            };
        }
        return {};
    };
    var getCurrentVertical = function() {
        if (showPetCareUserFilters) {
            return "PET_CARE";
        }
        if (showSeniorCareUserFilters) {
            return "SENIOR_CARE";
        }
        if (showChildCareUserFilters) {
            return "CHILD_CARE";
        }
        if (showHomeCareUserFilters) {
            return "HOME_CARE";
        }
        return "";
    };
    var handleApplyClick = function() {
        var ref;
        var currentFilters = getCurrentFilters();
        var currentVertical = getCurrentVertical();
        var amplitudeFilters = getAmplitudeFilters(currentFilters, currentVertical);
        // save filters to local storage
        (0,filtersStorage/* saveFilters */.HJ)(currentFilters);
        if (setPopoverAnchorEl) {
            setPopoverAnchorEl(null);
        }
        if (setOpenFiltersPopover) {
            setOpenFiltersPopover(false);
        }
        if (setOpenFiltersModal) {
            setOpenFiltersModal(false);
        }
        fetchResults((0,_object_spread/* default */.Z)({
            zipcode: filters === null || filters === void 0 ? void 0 : (ref = filters.location) === null || ref === void 0 ? void 0 : ref.zipcode
        }, currentFilters), true);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, amplitudeFilters);
    };
    var closeButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mb: 3.5,
        textAlign: "right",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            onClick: handleCloseButton,
            "aria-label": "filter-close-btn",
            "data-testid": "close-filters-button",
            size: "large",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityClose/* default */.Z, {})
        })
    });
    var applyButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        color: "secondary",
        variant: "contained",
        size: "large",
        sx: function(theme) {
            return {
                height: "40px",
                minWidth: {
                    xs: "100%",
                    sm: "327px"
                },
                margin: "0 auto",
                fontSize: theme.typography.body1.fontSize
            };
        },
        onClick: handleApplyClick,
        children: "Apply"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        disableGutters: isMobile,
        sx: function(theme) {
            return (0,_define_property/* default */.Z)({
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between"
            }, theme.breakpoints.up("md"), {
                width: "100%",
                maxWidth: "578px",
                paddingTop: theme.spacing(2.5),
                paddingBottom: theme.spacing(2)
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        item: true,
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                container: true,
                                item: true,
                                xs: 11,
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    mb: 3.5,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h2",
                                            children: "Filters"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            color: "primary",
                                            size: "small",
                                            sx: {
                                                width: "60px"
                                            },
                                            onClick: handleResetClick,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body2",
                                                children: "Reset"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 1,
                                children: closeButton
                            })
                        ]
                    }),
                    showPetCareUserFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PetCareFilters, {
                            hourlyRate: hourlyRate,
                            setHourlyRate: setHourlyRate
                        })
                    }),
                    showSeniorCareUserFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeniorCareFilters, {
                            hourlyRate: hourlyRate,
                            setHourlyRate: setHourlyRate,
                            seniorCareSubServices: seniorCareSubServices,
                            setSeniorCareSubServices: setSeniorCareSubServices,
                            setProfessionalSkillsObject: setSeniorCareProfessionalSkillsObject,
                            setPreferencesObject: setPreferencesObject,
                            languagesSpoken: languagesSpoken,
                            setLanguagesSpoken: setLanguagesSpoken
                        })
                    }),
                    showChildCareUserFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildCareFilters, {
                            hourlyRate: hourlyRate,
                            setHourlyRate: setHourlyRate,
                            numberOfChildren: numberOfChildren,
                            setNumberOfChildren: setNumberOfChildren,
                            childCareAgeGroupsList: childCareAgeGroupsList,
                            setChildCareAgeGroupsList: setChildCareAgeGroupsList,
                            childCareProfessionalSkillsList: childCareProfessionalSkillsList,
                            setChildCareProfessionalSkillsList: setChildCareProfessionalSkillsList,
                            setPreferencesObject: setPreferencesObject,
                            languagesSpoken: languagesSpoken,
                            setLanguagesSpoken: setLanguagesSpoken
                        })
                    }),
                    showHomeCareUserFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCareFilters, {
                            hourlyRate: hourlyRate,
                            setHourlyRate: setHourlyRate,
                            housekeepingSubServices: housekeepingSubServices,
                            setHousekeepingSubServices: setHousekeepingSubServices
                        })
                    })
                ]
            }),
            applyButton
        ]
    });
};


// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityFilters.js
var Icon24UtilityFilters = __webpack_require__(70834);
;// CONCATENATED MODULE: ./src/components/Filters/FiltersCTA.tsx




var FiltersCTA = function(param) {
    var setOpenFiltersPopover = param.setOpenFiltersPopover, setOpenFiltersModal = param.setOpenFiltersModal, setPopoverAnchorEl = param.setPopoverAnchorEl;
    var handleFiltersCTAClick = function(event) {
        if (setOpenFiltersModal) {
            setOpenFiltersModal(true);
        }
        if (setOpenFiltersPopover) {
            setOpenFiltersPopover(true);
        }
        if (setPopoverAnchorEl) {
            setPopoverAnchorEl(event.currentTarget);
        }
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, {
            feature_name: "Filters Viewed"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mb: {
            md: 6
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "outlined",
            size: "small",
            color: "secondary",
            onClick: handleFiltersCTAClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        pr: 1,
                        pt: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityFilters/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "span",
                        variant: "body1",
                        children: "Filter"
                    })
                ]
            })
        })
    });
};


;// CONCATENATED MODULE: ./src/components/Filters/FiltersModal.tsx






var FiltersModal = function() {
    var ref = (0,react.useState)(false), openFiltersModal = ref[0], setOpenFiltersModal = ref[1];
    var handleCloseModal = function() {
        setOpenFiltersModal(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyContainer/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersCTA, {
                    setOpenFiltersModal: setOpenFiltersModal
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                open: openFiltersModal,
                onClose: handleCloseModal,
                hideClose: true,
                "aria-labelledby": "listing-page-filters-modal",
                sx: function(theme) {
                    return {
                        "& .MuiDialogContent-root": {
                            paddingBottom: 0
                        },
                        "& .MuiDialog-paper": (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
                            padding: theme.spacing(3),
                            margin: 0,
                            top: 0,
                            width: "100%",
                            minWidth: "unset",
                            maxWidth: "unset",
                            height: "100%",
                            maxHeight: "100%",
                            borderRadius: "0px"
                        })
                    };
                },
                variant: "dynamic",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_Filters, {
                    setOpenFiltersModal: setOpenFiltersModal
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/HeaderText.tsx




var HeaderText = function() {
    var ref = (0,PageAttributesContext/* usePageAttributes */.l)(), segmentNamePluralLowerCase = ref.segmentNamePluralLowerCase, city = ref.city, state = ref.state, pageType = ref.pageType;
    // Example: "Infant Daycares"
    var firstWordUpperCase = segmentNamePluralLowerCase.charAt(0).toUpperCase() + segmentNamePluralLowerCase.slice(1);
    var headlineText = pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL ? "".concat(firstWordUpperCase, " near me") : "".concat(firstWordUpperCase, " in ").concat(city, ", ").concat(state);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        my: {
            xs: 0,
            sm: 6
        },
        mb: {
            xs: 3
        },
        mt: {
            xs: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "h2",
            align: "center",
            children: headlineText
        })
    });
};
/* harmony default export */ var components_HeaderText = (HeaderText);

// EXTERNAL MODULE: ./node_modules/@mui/material/Popover/Popover.js + 1 modules
var Popover = __webpack_require__(14564);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/InlineTextField/InlineTextField.js
var InlineTextField = __webpack_require__(99842);
// EXTERNAL MODULE: ./src/components/hooks/useZipCodeValidation.tsx + 1 modules
var useZipCodeValidation = __webpack_require__(89698);
;// CONCATENATED MODULE: ./src/components/Filters/LocationFilter.tsx















var LocationFilter = function() {
    var ref = (0,SegmentationFiltersContext/* useSegmentationFiltersContext */.RZ)(), filters = ref.filters, setFilters = ref.setFilters, fetchResults = ref.fetchResults;
    var userGeoInfo = (0,PageAttributesContext/* usePageAttributes */.l)().userGeoInfo;
    var ref1 = (0,useZipCodeValidation/* default */.Z)(), validate = ref1.validate, hasError = ref1.hasError;
    var localStorageFilters = (0,filtersStorage/* loadFilters */.dm)();
    var ref2 = (0,react.useState)(null), anchorEl = ref2[0], setAnchorEl = ref2[1];
    var ref3 = (0,react.useState)(""), zipCodeInput = ref3[0], setZipCodeInput = ref3[1];
    var ref4 = (0,react.useState)(""), cityInput = ref4[0], setCityInput = ref4[1];
    var ref5 = (0,react.useState)(""), stateInput = ref5[0], setStateInput = ref5[1];
    var ref6 = (0,react.useState)(""), savedCity = ref6[0], setSavedCity = ref6[1];
    var ref7 = (0,react.useState)(""), savedState = ref7[0], setSavedState = ref7[1];
    (0,react.useEffect)(function() {
        var fetchGeoInfo = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, zipMatch, prefillZip, data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            zipMatch = (ref = userGeoInfo === null || userGeoInfo === void 0 ? void 0 : userGeoInfo.match(/zip=(\d{5})/)) === null || ref === void 0 ? void 0 : ref[1];
                            prefillZip = zipMatch;
                            setZipCodeInput(prefillZip);
                            return [
                                4,
                                validate(prefillZip)
                            ];
                        case 1:
                            data = _state.sent();
                            setCityInput(data === null || data === void 0 ? void 0 : data.city);
                            setStateInput(data === null || data === void 0 ? void 0 : data.state);
                            if (!filters) {
                                setFilters({
                                    location: {
                                        zipcode: prefillZip,
                                        city: data === null || data === void 0 ? void 0 : data.city,
                                        state: globalTypes/* UsStateCode */.y9[data === null || data === void 0 ? void 0 : data.state]
                                    }
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchGeoInfo() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchGeoInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (filters) {
            var location = filters.location;
            if (location) {
                setZipCodeInput((location === null || location === void 0 ? void 0 : location.zipcode) || "");
                setCityInput((location === null || location === void 0 ? void 0 : location.city) || "");
                setStateInput((location === null || location === void 0 ? void 0 : location.state) || "");
                setSavedCity((location === null || location === void 0 ? void 0 : location.city) || "");
                setSavedState((location === null || location === void 0 ? void 0 : location.state) || "");
            }
        }
    }, [
        filters
    ]);
    var onChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var value, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        value = event.target.value;
                        setSavedCity("");
                        setSavedState("");
                        if (value.length > 5) return [
                            2
                        ];
                        setZipCodeInput(value);
                        if (!(value.length <= 5)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            validate(value)
                        ];
                    case 1:
                        data = _state.sent();
                        setCityInput((data === null || data === void 0 ? void 0 : data.city) || "");
                        setStateInput((data === null || data === void 0 ? void 0 : data.state) || "");
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onChange(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.clickOnSegmentationFilter */.Sj.clickOnSegmentationFilter, {
            zipCode: zipCodeInput
        });
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var handleApplyClick = function() {
        var ref;
        var resetPage = zipCodeInput === "" || zipCodeInput !== (filters === null || filters === void 0 ? void 0 : (ref = filters.location) === null || ref === void 0 ? void 0 : ref.zipcode);
        var updatedFilters = {
            zipcode: zipCodeInput
        };
        if (localStorageFilters) {
            updatedFilters = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, localStorageFilters), {
                zipcode: zipCodeInput
            });
        }
        fetchResults(updatedFilters, resetPage);
        setAnchorEl(null);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.applySegmentationFilter */.Sj.applySegmentationFilter, {
            zipCode: zipCodeInput
        });
    };
    var handleKeyUp = function(event) {
        if (event.key === "Enter") {
            handleApplyClick();
        }
    };
    var getHelperText = function() {
        if (hasError) return "Enter a valid ZIP code (e.g. “02453”)";
        if (zipCodeInput && savedCity && savedState) {
            return "".concat(savedCity, ", ").concat(savedState);
        }
        if (zipCodeInput && cityInput && stateInput) {
            return "".concat(cityInput, ", ").concat(stateInput);
        }
        return "";
    };
    var getDisplayText = function() {
        if (savedCity && savedState) {
            return "".concat(savedCity, ", ").concat(savedState);
        }
        if (zipCodeInput && cityInput && stateInput) {
            return "".concat(cityInput, ", ").concat(stateInput);
        }
        return "City, State";
    };
    var open = Boolean(anchorEl);
    var showDisplay = (0,react.useMemo)(function() {
        return Boolean(savedCity && savedState) || Boolean(zipCodeInput && cityInput && stateInput);
    }, [
        savedCity,
        savedState,
        zipCodeInput,
        cityInput,
        stateInput
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        mb: {
            xs: 3,
            sm: 6
        },
        mr: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                "aria-describedby": "location-filter",
                color: "secondary",
                variant: "outlined",
                onClick: handleClick,
                sx: function(theme) {
                    return {
                        minWidth: "252px",
                        height: "48px",
                        borderRadius: "12px",
                        borderColor: theme.palette.care.grey[300]
                    };
                },
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoLocation/* default */.Z, {}),
                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {}),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body3",
                    sx: function(theme) {
                        return {
                            flex: 1,
                            textAlign: "left",
                            fontSize: "1.125rem",
                            fontWeight: showDisplay ? 700 : 400,
                            color: showDisplay ? undefined : theme.palette.care.grey[500]
                        };
                    },
                    children: getDisplayText()
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                id: "location-filter",
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                sx: function(theme) {
                    return {
                        "& .MuiPaper-root": {
                            minWidth: "100px",
                            borderRadius: "24px",
                            border: "1px solid ".concat(theme.palette.care.grey[300]),
                            marginTop: theme.spacing(1),
                            boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.15);",
                            padding: theme.spacing(3, 2),
                            maxWidth: "375px",
                            width: "252px"
                        },
                        "& .MuiLink-root": {
                            textAlign: "right"
                        }
                    };
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineTextField/* default */.Z, {
                                id: "locationFilter-zipCode",
                                name: "locationFilter-zipCode",
                                label: "ZIP code",
                                type: "number",
                                value: zipCodeInput,
                                error: hasError,
                                helperText: getHelperText(),
                                onKeyUp: handleKeyUp,
                                onChange: onChange,
                                sx: {
                                    paddingBottom: "16px",
                                    // removes number arrows from Chrome, Safari, Edge, Opera
                                    "& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
                                        appearance: "none",
                                        margin: 0
                                    },
                                    // removes number arrows from Firefox
                                    "& input[type=number]": {
                                        appearance: "textfield"
                                    }
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            textAlign: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                color: "secondary",
                                variant: "contained",
                                onClick: handleApplyClick,
                                disabled: (zipCodeInput === null || zipCodeInput === void 0 ? void 0 : zipCodeInput.length) > 0 && (zipCodeInput === null || zipCodeInput === void 0 ? void 0 : zipCodeInput.length) < 5 || hasError,
                                children: "Apply"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Filters_LocationFilter = (LocationFilter);

;// CONCATENATED MODULE: ./src/components/Filters/FiltersPopover.tsx





var FiltersPopover = function() {
    var ref = (0,react.useState)(false), openFiltersPopover = ref[0], setOpenFiltersPopover = ref[1];
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var handlePopoverClose = function() {
        setAnchorEl(null);
        setOpenFiltersPopover(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        mt: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersCTA, {
                setOpenFiltersPopover: setOpenFiltersPopover,
                setPopoverAnchorEl: setAnchorEl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                id: "listing-page-filters-popover",
                open: openFiltersPopover,
                anchorEl: anchorEl,
                onClose: handlePopoverClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    width: "559px",
                    maxHeight: "742px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_Filters, {
                        setPopoverAnchorEl: setAnchorEl,
                        setOpenFiltersPopover: setOpenFiltersPopover
                    })
                })
            })
        ]
    });
};


// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallStar.js
var IconIllustrationSmallStar = __webpack_require__(71946);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityInfo.js
var Icon24UtilityInfo = __webpack_require__(38015);
;// CONCATENATED MODULE: ./src/components/ListPage/StatsContentRibbon.tsx












var StatsContentRibbon_classes = {
    icon: {
        width: {
            xs: "48px",
            md: "104px"
        },
        height: {
            xs: "48px",
            md: "104px"
        }
    },
    headline: {
        fontSize: {
            xs: "h2.fontSize",
            md: "display3.fontSize"
        },
        lineHeight: {
            xs: "26px",
            md: "42px"
        },
        fontWeight: "bold"
    }
};
var StatsContentRibbon = function(param) {
    var avgPayRate = param.avgPayRate, avgYearsOfExperience = param.avgYearsOfExperience, avgReviewRating = param.avgReviewRating, totalProviders = param.totalProviders, slotProps = param.slotProps;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,PageAttributesContext/* usePageAttributes */.l)(), pageType = ref5.pageType, segmentNamePluralLowerCase = ref5.segmentNamePluralLowerCase, segmentNamePlural = ref5.segmentNamePlural, city = ref5.city, state = ref5.state, searchingFor = ref5.searchingFor;
    var ref6 = (0,useResponsive/* useResponsive */.F)(), isSmallViewport = ref6.isSmallViewport, isMediumViewport = ref6.isMediumViewport;
    var ref7 = (0,react.useState)(false), openModal = ref7[0], setOpenModal = ref7[1];
    var currentDate = new Intl.DateTimeFormat("en-US", {
        month: "long",
        year: "numeric"
    }).format(new Date());
    var ref8;
    var roundAvgReviewRating = (ref8 = avgReviewRating === null || avgReviewRating === void 0 ? void 0 : avgReviewRating.toFixed(1)) !== null && ref8 !== void 0 ? ref8 : null;
    var ref9;
    var roundAvgYearsOfExp = (ref9 = avgYearsOfExperience && Math.floor(avgYearsOfExperience)) !== null && ref9 !== void 0 ? ref9 : null;
    var totalProvidersString = totalProviders === null || totalProviders === void 0 ? void 0 : totalProviders.toLocaleString();
    var isNationalPage = pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL;
    var isProviderPage = searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER;
    var segmentName = isProviderPage ? segmentNamePluralLowerCase : segmentNamePlural;
    var nationalStats = {
        headline: "".concat(segmentName, " that you'll love"),
        totalProviders: "".concat(totalProvidersString, " ").concat(segmentNamePluralLowerCase, " are listed on Care.com"),
        avgPayRate: "The average rate is $".concat(avgPayRate === null || avgPayRate === void 0 ? void 0 : avgPayRate.amount, "/hr as of ").concat(currentDate),
        avgReviewRating: "The average star rating for ".concat(segmentNamePluralLowerCase, " is ").concat(roundAvgReviewRating)
    };
    var localStats = {
        headline: "".concat(segmentName, " in ").concat(city, ",&nbsp;").concat(state, " that you'll love"),
        totalProviders: "".concat(totalProvidersString, " ").concat(segmentNamePluralLowerCase, " are listed in ").concat(city, ",&nbsp;").concat(state),
        avgPayRate: "The average rate is $".concat(avgPayRate === null || avgPayRate === void 0 ? void 0 : avgPayRate.amount, "/hr as of ").concat(currentDate),
        avgYearsOfExperience: "The average years of experience for ".concat(segmentNamePluralLowerCase, " is ").concat(roundAvgYearsOfExp, " years")
    };
    var totalProviderStats = {
        key: "totalProviders",
        national: nationalStats.totalProviders,
        local: localStats.totalProviders,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallPolaroids/* default */.Z, (0,_object_spread/* default */.Z)({
            sx: StatsContentRibbon_classes.icon
        }, slotProps === null || slotProps === void 0 ? void 0 : (ref = slotProps.icons) === null || ref === void 0 ? void 0 : ref.polaroid))
    };
    var avgPayRateStats = {
        key: "avgPayRate",
        national: nationalStats.avgPayRate,
        local: localStats.avgPayRate,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallDollarBill/* default */.Z, (0,_object_spread/* default */.Z)({
            sx: StatsContentRibbon_classes.icon
        }, slotProps === null || slotProps === void 0 ? void 0 : (ref1 = slotProps.icons) === null || ref1 === void 0 ? void 0 : ref1.dollar))
    };
    var avgReviewRatingStats = {
        key: "avgReviewRating",
        national: nationalStats.avgReviewRating,
        local: null,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallStar/* default */.Z, (0,_object_spread/* default */.Z)({
            sx: StatsContentRibbon_classes.icon
        }, slotProps === null || slotProps === void 0 ? void 0 : (ref2 = slotProps.icons) === null || ref2 === void 0 ? void 0 : ref2.star))
    };
    var avgYearsOfExperienceStats = {
        key: "avgYearsOfExperience",
        national: null,
        local: localStats.avgYearsOfExperience,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallSeniorCare/* default */.Z, (0,_object_spread/* default */.Z)({
            sx: StatsContentRibbon_classes.icon
        }, slotProps === null || slotProps === void 0 ? void 0 : (ref3 = slotProps.icons) === null || ref3 === void 0 ? void 0 : ref3.heart))
    };
    var nationalContent = [
        totalProviderStats,
        avgPayRateStats,
        avgReviewRatingStats
    ];
    var localContent = [
        totalProviderStats,
        avgPayRateStats,
        avgYearsOfExperienceStats
    ];
    var headline = isNationalPage ? nationalStats.headline : localStats.headline;
    var content = isNationalPage ? nationalContent : localContent;
    var handleSafetyModal = function() {
        setOpenModal(true);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, {
            feature_name: "background check banner"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                maxWidth: "md",
                sx: {
                    borderRadius: 4,
                    boxShadow: "0 0 16px 0 rgba(0, 0, 0, 0.15)",
                    mt: 4,
                    mb: {
                        xs: 6,
                        sm: 3,
                        md: 8
                    },
                    mx: {
                        xs: 3,
                        md: "auto"
                    },
                    px: {
                        xs: 3,
                        md: 10
                    },
                    py: {
                        xs: 3,
                        md: 4
                    },
                    maxWidth: {
                        md: "calc(100vw - 5%)",
                        lg: "1080px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        display: "flex",
                        justifyContent: {
                            xs: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "h2",
                                component: "h2",
                                sx: {
                                    pb: 3,
                                    pr: {
                                        xs: 1,
                                        md: 0
                                    },
                                    maxWidth: {
                                        md: "780px"
                                    }
                                },
                                children: [
                                    isProviderPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                component: "span",
                                                sx: (0,_object_spread/* default */.Z)({
                                                    backgroundColor: "care.blue.100",
                                                    borderRadius: 2,
                                                    px: 1,
                                                    ml: {
                                                        xs: -1
                                                    }
                                                }, StatsContentRibbon_classes.headline),
                                                children: "Background-checked"
                                            }),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        component: "span",
                                        sx: (0,_object_spread/* default */.Z)({
                                            m: 0,
                                            display: "inline"
                                        }, StatsContentRibbon_classes.headline),
                                        dangerouslySetInnerHTML: {
                                            __html: sanitize_html_default()(he_default().decode(headline))
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                px: {
                                    md: 2
                                },
                                mt: {
                                    sm: -0.5,
                                    md: 0
                                },
                                onClick: handleSafetyModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityInfo/* default */.Z, (0,_object_spread/* default */.Z)({
                                    size: isSmallViewport || isMediumViewport ? 32 : 40,
                                    sx: {
                                        cursor: "pointer",
                                        borderRadius: "50%",
                                        "&:hover": {
                                            backgroundColor: "care.grey.100"
                                        }
                                    }
                                }, slotProps === null || slotProps === void 0 ? void 0 : (ref4 = slotProps.icons) === null || ref4 === void 0 ? void 0 : ref4.info))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mx: {
                            sm: "20%",
                            md: "auto"
                        },
                        display: "flex",
                        flexDirection: {
                            xs: "column",
                            md: "row"
                        },
                        justifyContent: {
                            xs: "center",
                            md: "space-between"
                        },
                        alignItems: {
                            md: "center"
                        },
                        children: content.map(function(param) {
                            var key = param.key, national = param.national, local = param.local, icon = param.icon;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                pb: {
                                    xs: 3,
                                    md: 0
                                },
                                display: "flex",
                                alignItems: "center",
                                flexDirection: {
                                    md: "column"
                                },
                                maxWidth: {
                                    md: "275px"
                                },
                                px: {
                                    md: 3
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        pr: {
                                            xs: 3.5,
                                            md: 0
                                        },
                                        children: icon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body1",
                                        textAlign: {
                                            md: "center"
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: sanitize_html_default()(he_default().decode(isNationalPage ? national !== null && national !== void 0 ? national : "" : local !== null && local !== void 0 ? local : ""))
                                        }
                                    })
                                ]
                            }, key);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyModalWrapper/* SafetyModalWrapper */.S, {
                openModal: openModal,
                setOpenModal: setOpenModal
            })
        ]
    });
};


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/components/ListPage/Hero/HeroContentContext.tsx



var initialState = {
    headline: "",
    subHeadline: "",
    enrollmentURL: "",
    directoryFirstExperience: false,
    userGeoInfo: "",
    isJobSegment: false
};
var HeroContentContext = /*#__PURE__*/ (0,react.createContext)(initialState);
var useHeroContent = function() {
    return (0,react.useContext)(HeroContentContext);
};
var HeroContentProvider = function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroContentContext.Provider, {
        value: props,
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 3 modules
var TextField_TextField = __webpack_require__(61903);
;// CONCATENATED MODULE: ./src/components/ListPage/Hero/ZipCodeCTA.tsx













var ZipCodeCTA_classes = {
    textFieldOverride: function(theme) {
        return {
            width: {
                xs: "100%",
                sm: "360px"
            },
            mb: {
                xs: 2,
                md: 3
            },
            py: 1,
            "& .MuiInputAdornment-root": {
                ml: 0
            },
            "& .MuiInputBase-root": {
                minHeight: "62px"
            },
            // removes number arrows from Chrome, Safari, Edge, Opera
            "& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
                appearance: "none",
                margin: 0
            },
            // removes number arrows from Firefox
            "& input[type=text]": {
                cursor: "auto",
                padding: theme.spacing(2, 2, 2, 0)
            }
        };
    }
};
var ZipCodeCTA = function() {
    var ref = useHeroContent(), enrollmentURL = ref.enrollmentURL, directoryFirstExperience = ref.directoryFirstExperience, userGeoInfo = ref.userGeoInfo;
    var ref1 = (0,PageAttributesContext/* usePageAttributes */.l)(), pageType = ref1.pageType, serviceIdForMember = ref1.serviceIdForMember;
    var zipCodeRegex = /^\d{0,5}$/;
    var zipInputRef = (0,react.useRef)(null);
    var prefillZipCode = function() {
        if (pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL) {
            var match = userGeoInfo === null || userGeoInfo === void 0 ? void 0 : userGeoInfo.match(/zip=(\d{5})/);
            if (match && match[1]) {
                return match[1];
            }
        }
        return "";
    };
    var prefillZipCodeForDirectoryFirst = function() {
        return (0,getZipcodeFromGeoInfo/* getZipcodeFromGeoInfo */.Z)(userGeoInfo);
    };
    var prefilledZipCode = prefillZipCode();
    var ref2 = (0,react.useState)({
        zipCode: prefilledZipCode
    }), zip = ref2[0], setZip = ref2[1];
    (0,react.useEffect)(function() {
        if (zipInputRef.current) {
            zipInputRef.current.setSelectionRange(zipInputRef.current.value.length, zipInputRef.current.value.length);
            zipInputRef.current.focus();
        }
    }, [
        zip
    ]);
    var onZipCodeChange = function(e) {
        var zipCodeVal = e.target.value;
        if (!zipCodeRegex.test(zipCodeVal)) {
            return;
        }
        setZip(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), {
                zipCode: zipCodeVal
            });
        });
    };
    var enrollmentLink = function() {
        if (directoryFirstExperience) {
            if (zip.zipCode && zip.zipCode.length === 5) {
                return "".concat(enrollmentURL, "&zipcode=").concat(zip.zipCode);
            }
            return "".concat(enrollmentURL, "&zipcode=").concat(prefillZipCodeForDirectoryFirst());
        }
        if (!directoryFirstExperience && zip.zipCode) {
            return "".concat(enrollmentURL, "&zipcode=").concat(zip.zipCode);
        }
        return "".concat(enrollmentURL);
    }();
    var daycareDirectoryFirstFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.DAYCARE_DIRECTORY_FIRST_FLOW.id */.WV.DAYCARE_DIRECTORY_FIRST_FLOW.id);
    var hideGetStartedCta = serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE_LOCATION */.u2.CHILD_CARE_LOCATION || serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE */.u2.CHILD_CARE;
    var getCtaText = function() {
        if (hideGetStartedCta) return "Start matching";
        return "Get Started";
    };
    var handleCtaBtn = function() {
        var amplitudeData = {
            cta_text: getCtaText(),
            cta_type: "button"
        };
        if (daycareDirectoryFirstFlag && daycareDirectoryFirstFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.DAYCARE_DIRECTORY_FIRST_FLOW.id */.WV.DAYCARE_DIRECTORY_FIRST_FLOW.id,
                test_variant: daycareDirectoryFirstFlag.variationIndex,
                service_id_for_member: serviceIdForMember,
                page_template: pageType
            });
        }
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)("CTA Interacted", amplitudeData);
    };
    var handleKeyUp = function(event) {
        if (event.key === "Enter") {
            globalThis.location.href = "".concat(enrollmentLink);
            handleCtaBtn();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        flexDirection: "column",
        maxWidth: {
            xs: "100%",
            sm: "360px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField_TextField/* default */.Z, {
                id: "zipCode",
                name: "zipCode",
                inputRef: zipInputRef,
                onKeyUp: handleKeyUp,
                placeholder: "ZIP code",
                value: zip.zipCode,
                onChange: onZipCodeChange,
                variant: "standard",
                InputProps: {
                    startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                        position: "start",
                        sx: {
                            mr: {
                                xs: 1
                            },
                            fontWeight: 400
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoLocation/* default */.Z, {})
                    })
                },
                sx: ZipCodeCTA_classes.textFieldOverride
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                sx: {
                    width: "100%"
                },
                color: "primary",
                component: "a",
                href: enrollmentLink,
                onClick: handleCtaBtn,
                size: "large",
                variant: "contained",
                rel: "nofollow",
                children: getCtaText()
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/ListPage/Hero/JobHeroCTA.tsx




var JobHeroCTA = function() {
    var enrollmentURL = useHeroContent().enrollmentURL;
    var handleJoinFreeBtn = function() {
        var amplitudeData = {
            cta_text: "Join free to get started",
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)("CTA Interacted", amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        display: "flex",
        flexDirection: "column",
        maxWidth: {
            xs: "100%",
            sm: "360px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            sx: {
                width: "100%"
            },
            href: enrollmentURL,
            color: "primary",
            variant: "contained",
            component: "a",
            onClick: handleJoinFreeBtn,
            size: "large",
            rel: "nofollow",
            children: "Join free to get started"
        })
    });
};
/* harmony default export */ var Hero_JobHeroCTA = (JobHeroCTA);

;// CONCATENATED MODULE: ./src/components/ListPage/Hero/HeroContentCard.tsx







var HeroContentCard_classes = {
    container: {
        paddingX: {
            xs: 3
        },
        marginLeft: {
            sm: 5,
            md: 10,
            xl: "calc((100vw - 1440px) / 2 + 80px)"
        },
        paddingY: {
            sm: 5
        }
    },
    containerJobs: {
        paddingX: {
            xs: 3
        },
        marginLeft: {
            sm: 5,
            md: 6,
            xl: "calc((100vw - 1440px) / 2 + 80px)"
        },
        paddingY: {
            sm: 12
        }
    },
    content: {
        minWidth: {
            md: "490px"
        },
        maxWidth: {
            sm: "450px",
            md: "590px",
            lg: "650px"
        },
        backgroundColor: "rgb(255, 255, 255, 0.9)",
        padding: {
            sm: 3,
            md: 5
        },
        borderRadius: "16px"
    },
    contentJobs: {
        minWidth: {
            md: "400px"
        },
        maxWidth: {
            sm: "400px",
            md: "450px",
            lg: "540px"
        },
        backgroundColor: "rgb(255, 255, 255, 0.9)",
        padding: {
            sm: 3,
            md: 5
        },
        borderRadius: "16px"
    },
    headline: function(theme) {
        return {
            fontWeight: 700,
            fontSize: {
                xs: theme.typography.h1.fontSize,
                lg: theme.typography.display2.fontSize
            },
            lineHeight: {
                xs: theme.typography.h1.lineHeight,
                lg: theme.typography.display2.lineHeight
            },
            m: 0,
            pb: 2
        };
    },
    subHeadline: function(theme) {
        return {
            fontWeight: 400,
            fontSize: {
                xs: theme.typography.body1.fontSize,
                lg: theme.typography.h2.fontSize
            },
            lineHeight: {
                xs: theme.typography.body1.lineHeight,
                lg: "28px"
            },
            pb: {
                xs: 3,
                md: 4
            },
            "& p": {
                m: 0
            }
        };
    }
};
var HeroContentCard = function() {
    var ref = useHeroContent(), headline = ref.headline, subHeadline = ref.subHeadline, isJobSegment = ref.isJobSegment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        sx: isJobSegment ? HeroContentCard_classes.containerJobs : HeroContentCard_classes.container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: isJobSegment ? HeroContentCard_classes.contentJobs : HeroContentCard_classes.content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h1",
                    color: "primary",
                    dangerouslySetInnerHTML: {
                        __html: sanitize_html_default()(he_default().decode(headline))
                    },
                    sx: HeroContentCard_classes.headline
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: HeroContentCard_classes.subHeadline,
                    dangerouslySetInnerHTML: {
                        __html: sanitize_html_default()(he_default().decode(subHeadline))
                    }
                }),
                !isJobSegment && /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeCTA, {}),
                isJobSegment && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_JobHeroCTA, {})
            ]
        })
    });
};


;// CONCATENATED MODULE: ./src/components/ListPage/helpers/getHeroImages.ts



var getHeroImages_ref = config_default()(), getHeroImages_NEXT_ASSET_URL = getHeroImages_ref.publicRuntimeConfig.NEXT_ASSET_URL;
var createHeroImages = function(baseName) {
    return {
        heroImageMobileURL: "".concat(getHeroImages_NEXT_ASSET_URL, "/images/above-the-fold/").concat(baseName, "-mobile.jpg"),
        heroImageTabletURL: "".concat(getHeroImages_NEXT_ASSET_URL, "/images/above-the-fold/").concat(baseName, "-tablet.jpg"),
        heroImageDesktopURL: "".concat(getHeroImages_NEXT_ASSET_URL, "/images/above-the-fold/").concat(baseName, "-desktop.jpg")
    };
};
var _obj;
var ABOVE_THE_FOLD_HERO_IMAGES = Object.freeze((_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* ServiceIdForMember.SENIOR_CARE */.u2.SENIOR_CARE, createHeroImages("senior-care")), (0,_define_property/* default */.Z)(_obj, constants/* ServiceIdForMember.SENIOR_CARE_JOB */.u2.SENIOR_CARE_JOB, createHeroImages("senior-care")), (0,_define_property/* default */.Z)(_obj, constants/* ServiceIdForMember.PET_CARE */.u2.PET_CARE, createHeroImages("pet-care-general")), (0,_define_property/* default */.Z)(_obj, constants/* ServiceIdForMember.PET_CARE_JOB */.u2.PET_CARE_JOB, createHeroImages("pet-care-general")), (0,_define_property/* default */.Z)(_obj, constants/* ServiceIdForMember.HOUSEKEEPING */.u2.HOUSEKEEPING, createHeroImages("housekeeping")), (0,_define_property/* default */.Z)(_obj, constants/* ServiceIdForMember.HOUSEKEEPING_JOB */.u2.HOUSEKEEPING_JOB, createHeroImages("housekeeping")), (0,_define_property/* default */.Z)(_obj, constants/* ServiceIdForMember.TUTORING */.u2.TUTORING, createHeroImages("tutoring")), (0,_define_property/* default */.Z)(_obj, constants/* ServiceIdForMember.TUTORING_JOB */.u2.TUTORING_JOB, createHeroImages("tutoring")), (0,_define_property/* default */.Z)(_obj, constants/* ServiceIdForMember.SPECIAL_NEEDS */.u2.SPECIAL_NEEDS, createHeroImages("special-needs")), (0,_define_property/* default */.Z)(_obj, constants/* ServiceIdForMember.SPECIAL_NEEDS_JOB */.u2.SPECIAL_NEEDS_JOB, createHeroImages("special-needs")), (0,_define_property/* default */.Z)(_obj, constants/* ServiceIdForMember.CARE_GIGS */.u2.CARE_GIGS, createHeroImages("personal-assistant")), (0,_define_property/* default */.Z)(_obj, constants/* ServiceIdForMember.CARE_GIGS_JOB */.u2.CARE_GIGS_JOB, createHeroImages("personal-assistant")), (0,_define_property/* default */.Z)(_obj, constants/* ServiceIdForMember.CHILD_CARE */.u2.CHILD_CARE, createHeroImages("child-care")), (0,_define_property/* default */.Z)(_obj, constants/* ServiceIdForMember.CHILD_CARE_JOB */.u2.CHILD_CARE_JOB, createHeroImages("child-care")), (0,_define_property/* default */.Z)(_obj, "newborn", createHeroImages("newborn")), (0,_define_property/* default */.Z)(_obj, "petCareCat", createHeroImages("pet-care-cat")), (0,_define_property/* default */.Z)(_obj, "petCareBird", createHeroImages("pet-care-bird")), _obj));
var getHeroImages = function(seoSegmentId, serviceIdForMember) {
    // separate the segment from the rest of the url (e.g. /child-care/boston-ma -> /child-care)
    var segment = "/".concat(seoSegmentId.split("/")[1]);
    var segmentationsWithCatImage = [
        "/cat-sitters",
        "/cat-groomers",
        "/cat-boarding",
        "/cat-trainers",
        "/cat-sitting-jobs", 
    ];
    var segmentationsWithNewbornImage = [
        "/newborn-nannies",
        "/infant-nannies",
        "/infant-child-care",
        "/infant-babysitters",
        "/night-nannies",
        "/infant-daycare", 
    ];
    if (serviceIdForMember === constants/* ServiceIdForMember.BABYSITTER */.u2.BABYSITTER || serviceIdForMember === constants/* ServiceIdForMember.NANNY */.u2.NANNY) {
        return ABOVE_THE_FOLD_HERO_IMAGES[constants/* ServiceIdForMember.CHILD_CARE */.u2.CHILD_CARE];
    }
    if (serviceIdForMember === constants/* ServiceIdForMember.TUTORING_AFTER_SCHOOL_CARE */.u2.TUTORING_AFTER_SCHOOL_CARE) {
        return ABOVE_THE_FOLD_HERO_IMAGES[constants/* ServiceIdForMember.TUTORING */.u2.TUTORING];
    }
    if (serviceIdForMember === constants/* ServiceIdForMember.PET_DAY_CARE_LOCATION */.u2.PET_DAY_CARE_LOCATION) {
        return ABOVE_THE_FOLD_HERO_IMAGES[constants/* ServiceIdForMember.PET_CARE */.u2.PET_CARE];
    }
    if (segmentationsWithCatImage.includes(segment)) {
        return ABOVE_THE_FOLD_HERO_IMAGES.petCareCat;
    }
    if (segment.includes("/bird-sitters") || segment.includes("/bird-sitting-jobs")) {
        return ABOVE_THE_FOLD_HERO_IMAGES.petCareBird;
    }
    if (segmentationsWithNewbornImage.includes(segment)) {
        return ABOVE_THE_FOLD_HERO_IMAGES.newborn;
    }
    // default images to child care if no match
    return ABOVE_THE_FOLD_HERO_IMAGES[serviceIdForMember] || ABOVE_THE_FOLD_HERO_IMAGES[constants/* ServiceIdForMember.CHILD_CARE */.u2.CHILD_CARE];
};


;// CONCATENATED MODULE: ./src/components/ListPage/helpers/getHeroImageStyles.ts


var getHeroImageStyles_obj;
var ABOVE_THE_FOLD_IMAGE_STYLES = Object.freeze((getHeroImageStyles_obj = {}, (0,_define_property/* default */.Z)(getHeroImageStyles_obj, constants/* ServiceIdForMember.SENIOR_CARE */.u2.SENIOR_CARE, {
    backgroundPosition: {
        xs: "center"
    }
}), (0,_define_property/* default */.Z)(getHeroImageStyles_obj, constants/* ServiceIdForMember.PET_CARE */.u2.PET_CARE, {
    backgroundPosition: {
        xs: "center",
        md: "60% 50%",
        lg: "center"
    }
}), (0,_define_property/* default */.Z)(getHeroImageStyles_obj, constants/* ServiceIdForMember.HOUSEKEEPING */.u2.HOUSEKEEPING, {
    backgroundPosition: {
        xs: "center",
        md: "60% 50%",
        lg: "center"
    }
}), (0,_define_property/* default */.Z)(getHeroImageStyles_obj, constants/* ServiceIdForMember.TUTORING */.u2.TUTORING, {
    backgroundPosition: {
        xs: "center"
    }
}), (0,_define_property/* default */.Z)(getHeroImageStyles_obj, constants/* ServiceIdForMember.SPECIAL_NEEDS */.u2.SPECIAL_NEEDS, {
    backgroundPosition: {
        xs: "center",
        md: "60% 50%",
        lg: "center"
    }
}), (0,_define_property/* default */.Z)(getHeroImageStyles_obj, constants/* ServiceIdForMember.CARE_GIGS */.u2.CARE_GIGS, {
    backgroundPosition: {
        xs: "center",
        md: "60% 50%",
        lg: "center"
    }
}), (0,_define_property/* default */.Z)(getHeroImageStyles_obj, constants/* ServiceIdForMember.CHILD_CARE */.u2.CHILD_CARE, {
    backgroundPosition: {
        xs: "center",
        lg: "40% 50%"
    }
}), (0,_define_property/* default */.Z)(getHeroImageStyles_obj, "newborn", {
    backgroundPosition: {
        xs: "center",
        lg: "40% 50%"
    }
}), (0,_define_property/* default */.Z)(getHeroImageStyles_obj, "petCareCat", {
    backgroundPosition: {
        xs: "center",
        lg: "35% 50%"
    }
}), (0,_define_property/* default */.Z)(getHeroImageStyles_obj, "petCareBird", {
    backgroundPosition: {
        xs: "center",
        md: "60% 50%",
        lg: "center"
    }
}), getHeroImageStyles_obj));
var getHeroImageStyles = function(seoSegmentId, serviceIdForMember) {
    // separate the segment from the rest of the url (e.g. /child-care/boston-ma -> /child-care)
    var segment = "/".concat(seoSegmentId.split("/")[1]);
    var segmentationsWithCatImage = [
        "/cat-sitters",
        "/cat-groomers",
        "/cat-boarding",
        "/cat-trainers", 
    ];
    var segmentationsWithNewbornImage = [
        "/newborn-nannies",
        "/infant-nannies",
        "/infant-child-care",
        "/infant-babysitters",
        "/night-nannies",
        "/infant-daycare", 
    ];
    if (serviceIdForMember === constants/* ServiceIdForMember.BABYSITTER */.u2.BABYSITTER || serviceIdForMember === constants/* ServiceIdForMember.NANNY */.u2.NANNY) {
        return ABOVE_THE_FOLD_IMAGE_STYLES[constants/* ServiceIdForMember.CHILD_CARE */.u2.CHILD_CARE];
    }
    if (serviceIdForMember === constants/* ServiceIdForMember.TUTORING_AFTER_SCHOOL_CARE */.u2.TUTORING_AFTER_SCHOOL_CARE) {
        return ABOVE_THE_FOLD_IMAGE_STYLES[constants/* ServiceIdForMember.TUTORING */.u2.TUTORING];
    }
    if (serviceIdForMember === constants/* ServiceIdForMember.PET_DAY_CARE_LOCATION */.u2.PET_DAY_CARE_LOCATION) {
        return ABOVE_THE_FOLD_IMAGE_STYLES[constants/* ServiceIdForMember.PET_CARE */.u2.PET_CARE];
    }
    if (segmentationsWithCatImage.includes(segment)) {
        return ABOVE_THE_FOLD_IMAGE_STYLES.petCareCat;
    }
    if (segment.includes("/bird-sitters")) {
        return ABOVE_THE_FOLD_IMAGE_STYLES.petCareBird;
    }
    if (segmentationsWithNewbornImage.includes(segment)) {
        return ABOVE_THE_FOLD_IMAGE_STYLES.newborn;
    }
    // default image style to child care if no match
    return ABOVE_THE_FOLD_IMAGE_STYLES[serviceIdForMember] || ABOVE_THE_FOLD_IMAGE_STYLES[constants/* ServiceIdForMember.CHILD_CARE */.u2.CHILD_CARE];
};


;// CONCATENATED MODULE: ./src/components/ListPage/Hero/Hero.tsx










var Hero_Hero_getClasses = function(heroImageStyles) {
    return {
        imageContainer: (0,_object_spread/* default */.Z)({
            width: "100%",
            height: {
                xs: "150px",
                sm: "480px",
                md: "565px"
            },
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            borderRadius: {
                xs: "0 0 64px 64px",
                sm: "0 0 120px 120px"
            },
            overflow: "hidden",
            marginBottom: 3
        }, heroImageStyles)
    };
};
var Hero_Hero = function(param) {
    var headline = param.headline, subHeadline = param.subHeadline, enrollmentURL = param.enrollmentURL, userGeoInfo = param.userGeoInfo, _directoryFirstExperience = param.directoryFirstExperience, directoryFirstExperience = _directoryFirstExperience === void 0 ? false : _directoryFirstExperience, _isJobSegment = param.isJobSegment, isJobSegment = _isJobSegment === void 0 ? false : _isJobSegment;
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    var ref = (0,PageAttributesContext/* usePageAttributes */.l)(), serviceIdForMember = ref.serviceIdForMember, seoSegmentId = ref.seoSegmentId;
    var ref1 = getHeroImages(seoSegmentId, serviceIdForMember), heroImageMobileURL = ref1.heroImageMobileURL, heroImageTabletURL = ref1.heroImageTabletURL, heroImageDesktopURL = ref1.heroImageDesktopURL;
    var heroImageStyles = getHeroImageStyles(seoSegmentId, serviceIdForMember);
    var backgroundImage = {
        backgroundImage: {
            xs: "url(".concat((0,createRelativeImageURL/* default */.Z)(heroImageMobileURL), ")"),
            sm: "url(".concat((0,createRelativeImageURL/* default */.Z)(heroImageTabletURL), ")"),
            md: "url(".concat((0,createRelativeImageURL/* default */.Z)(heroImageDesktopURL), ")")
        }
    };
    var classes = Hero_Hero_getClasses((0,_object_spread/* default */.Z)({}, backgroundImage, heroImageStyles));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroContentProvider, {
        headline: headline,
        subHeadline: subHeadline,
        enrollmentURL: enrollmentURL,
        directoryFirstExperience: directoryFirstExperience,
        userGeoInfo: userGeoInfo,
        isJobSegment: isJobSegment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            height: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: classes.imageContainer,
                    children: !isSmallViewport && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroContentCard, {})
                }),
                isSmallViewport && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroContentCard, {})
            ]
        })
    });
};


// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevronRight.js
var Icon24UtilityChevronRight = __webpack_require__(16178);
;// CONCATENATED MODULE: ./src/components/ListPage/WhenDoYouWantAJob.tsx








var WhenDoYouWantAJob_classes = {
    icon: {
        width: {
            xs: "48px",
            md: "64px"
        },
        height: {
            xs: "48px",
            md: "64px"
        }
    },
    headline: {
        fontSize: {
            xs: "h2.fontSize",
            md: "display3.fontSize"
        },
        lineHeight: {
            xs: "26px",
            md: "42px"
        },
        fontWeight: "bold"
    },
    seolink: function(theme) {
        return {
            color: theme.palette.care.grey[900],
            "&:hover": {
                color: theme.palette.care.navy[600]
            }
        };
    }
};
var WhenDoYouWantAJob = function(param) {
    var enrollmentURL = param.enrollmentURL, slotProps = param.slotProps;
    var ref, ref1, ref2;
    var rightNow = {
        key: "rightNow",
        label: "Right now",
        intent: "rightNow",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoResponseTime/* default */.Z, (0,_object_spread/* default */.Z)({
            sx: WhenDoYouWantAJob_classes.icon
        }, slotProps === null || slotProps === void 0 ? void 0 : (ref = slotProps.icons) === null || ref === void 0 ? void 0 : ref.responseTime))
    };
    var withInMonth = {
        key: "withInMonth",
        label: "Within a month",
        intent: "withInMonth",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandCalendarOneMonth/* default */.Z, (0,_object_spread/* default */.Z)({
            sx: WhenDoYouWantAJob_classes.icon
        }, slotProps === null || slotProps === void 0 ? void 0 : (ref1 = slotProps.icons) === null || ref1 === void 0 ? void 0 : ref1.calendar))
    };
    var justBrowsing = {
        key: "justBrowsing",
        label: "Just browsing",
        intent: "justBrowsing",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandSearch/* default */.Z, (0,_object_spread/* default */.Z)({
            sx: WhenDoYouWantAJob_classes.icon
        }, slotProps === null || slotProps === void 0 ? void 0 : (ref2 = slotProps.icons) === null || ref2 === void 0 ? void 0 : ref2.search))
    };
    var headline = "When do you want a job?";
    var content = [
        rightNow,
        withInMonth,
        justBrowsing
    ];
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var handleCareButton = function(e) {
        var ref;
        var amplitudeData = {
            cta_location: "header",
            cta_text: (ref = e.target.textContent) === null || ref === void 0 ? void 0 : ref.toString(),
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        sx: {
            mt: {
                xs: 4,
                sm: 0
            },
            mb: {
                xs: 1,
                sm: 3
            },
            mx: {
                xs: 1,
                md: "auto"
            },
            px: {
                xs: 1,
                md: 10
            },
            py: {
                xs: 1,
                md: 2
            },
            maxWidth: {
                md: "calc(100vw - 5%)",
                lg: "940px"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "flex",
                justifyContent: {
                    xs: "left",
                    md: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h2",
                    component: "h2",
                    sx: {
                        pb: {
                            xs: 1,
                            md: 4
                        },
                        pr: {
                            xs: 1,
                            md: 0
                        },
                        maxWidth: {
                            md: "780px"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "span",
                        sx: (0,_object_spread/* default */.Z)({
                            m: 0,
                            display: "inline"
                        }, WhenDoYouWantAJob_classes.headline),
                        dangerouslySetInnerHTML: {
                            __html: sanitize_html_default()(he_default().decode(headline))
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "flex",
                flexDirection: {
                    xs: "column",
                    md: "row"
                },
                justifyContent: {
                    xs: "center",
                    md: "space-between"
                },
                children: content.map(function(param) {
                    var key = param.key, label = param.label, intent = param.intent, icon = param.icon;
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: WhenDoYouWantAJob_classes.seolink,
                        href: "".concat(enrollmentURL, "&intent=").concat(intent),
                        underline: "none",
                        onClick: handleCareButton,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                borderRadius: 4,
                                boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.15)",
                                px: {
                                    xs: 3,
                                    md: "auto"
                                }
                            },
                            minHeight: {
                                md: "154px"
                            },
                            pb: {
                                xs: 2,
                                md: 0
                            },
                            pt: {
                                xs: 2,
                                md: 3
                            },
                            mt: {
                                xs: 2,
                                md: 0
                            },
                            display: "flex",
                            alignItems: "center",
                            flexDirection: {
                                md: "column"
                            },
                            minWidth: {
                                md: "240px"
                            },
                            px: {
                                md: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    pr: {
                                        xs: 3.5,
                                        md: 0
                                    },
                                    children: icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: {
                                        xs: "85%",
                                        md: "auto"
                                    },
                                    flexDirection: {
                                        md: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            flex: "1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: isMobileOrSmaller ? "h3" : "h2",
                                                textAlign: {
                                                    md: "center"
                                                },
                                                dangerouslySetInnerHTML: {
                                                    __html: sanitize_html_default()(he_default().decode(label))
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevronRight/* default */.Z, (0,_object_spread/* default */.Z)({
                                                size: isMobileOrSmaller ? 23 : 25
                                            }, slotProps === null || slotProps === void 0 ? void 0 : (ref = slotProps.icons) === null || ref === void 0 ? void 0 : ref.chevron))
                                        })
                                    ]
                                })
                            ]
                        }, key)
                    }, key);
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/pages/segmentationListings/SegmentationListingPage.tsx












// import { HTLBIDSlot } from '@care/htl-bid';










































var SegmentationListingPage_classes = {
    divider: function(theme) {
        return (0,_define_property/* default */.Z)({
            marginRight: -2,
            marginLeft: -2,
            marginTop: 3
        }, theme.breakpoints.up("sm"), {
            marginRight: 0,
            marginLeft: 0
        });
    }
};
// eslint-disable-next-line complexity
var SegmentationListingPage = function(param) {
    var seoSegmentId = param.seoSegmentId, initialPageNumber = param.initialPageNumber, pageData = param.pageData, ipAddress = param.ipAddress, botInfo = param.botInfo, userGeoInfo = param.userGeoInfo, userAgent = param.userAgent, deviceChar = param.deviceChar, testName = param.testName, numberOfReviewsPerProfile = param.numberOfReviewsPerProfile;
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var ref4 = (0,useLDClientFlags/* useLDClientFlags */.y)(), GAMFlag = ref4.SEO_3487_GAM_ADS_SEO_MFE;
    var showGAMAds = (GAMFlag === null || GAMFlag === void 0 ? void 0 : GAMFlag.variationIndex) === 1;
    var _seoSegmentationSearchResults = pageData.seoSegmentationSearchResults, initialFilters = _seoSegmentationSearchResults.filters, initialPagination = _seoSegmentationSearchResults.pagination, initialCaregiverSearchResults = _seoSegmentationSearchResults.caregiverSearchResults, initialProviderSearchResults = _seoSegmentationSearchResults.providerSearchResults, initialJobSearchResults = _seoSegmentationSearchResults.jobSearchResults, initialArchivedJobSearchResults = _seoSegmentationSearchResults.archivedJobSearchResults, _seoSegmentationSearchResults1 = pageData.seoSegmentationSearchResults, seoBackEndTests = _seoSegmentationSearchResults1.tests, segmentationIntro = pageData.getSEOSegmentationIntro, faqs = pageData.getSEOSegmentationFAQs, segmentationLinkSections = pageData.getSEOSegmentationLinkSections, seoArticles = pageData.seoArticlesList, seoNavigationLinkSection = pageData.seoNavigationLinkSection;
    var segmentationDetails = pageData.seoSegmentationDetails;
    var seoPageMetadata = segmentationDetails.seoPageMetadata, initialSearchResultsHeader = segmentationDetails.searchResultsHeader;
    var breadcrumbs = pageData.seoSegmentationBreadcrumbs.__typename === "SEOSegmentationBreadcrumbsSuccess" ? pageData.seoSegmentationBreadcrumbs.breadcrumbs : null;
    var caregiverSegmentationStats = ((ref = pageData.seoSegmentationStats) === null || ref === void 0 ? void 0 : ref.__typename) === "SEOSegmentationStatsSuccess" ? pageData.seoSegmentationStats.caregiverStats : null;
    var heroImage = pageData.seoSegmentationHeroImage.__typename === "SEOSegmentationHeroImageSuccess" ? pageData.seoSegmentationHeroImage.heroImage : null;
    var ref5 = (0,react.useState)(initialPageNumber), pageNumber = ref5[0], setPageNumber = ref5[1];
    var ref6 = (0,react.useState)(initialFilters), filters = ref6[0], setFilters = ref6[1];
    var ref7 = (0,react.useState)(initialPagination), pagination = ref7[0], setPagination = ref7[1];
    var ref8 = (0,react.useState)(initialCaregiverSearchResults), caregiverSearchResults = ref8[0], setCaregiverSearchResults = ref8[1];
    var ref9 = (0,react.useState)(initialProviderSearchResults), providerSearchResults = ref9[0], setProviderSearchResults = ref9[1];
    var ref10 = (0,react.useState)(initialJobSearchResults), jobSearchResults = ref10[0], setJobSearchResults = ref10[1];
    var ref11 = (0,react.useState)(initialArchivedJobSearchResults), archivedJobSearchResults = ref11[0], setArchivedJobSearchResults = ref11[1];
    var ref12 = (0,react.useState)(initialSearchResultsHeader), searchResultsHeader = ref12[0], setSearchResultsHeader = ref12[1];
    var stringifyDeviceChar = JSON.stringify(deviceChar);
    var searchingFor = (0,PageAttributesContext/* usePageAttributes */.l)().searchingFor;
    var hotJarEventsTestFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.SEO_1586_A_B_TEST_HOT_JAR_EVENTS_TEST.id */.WV.SEO_1586_A_B_TEST_HOT_JAR_EVENTS_TEST.id);
    var daycareDirectoryFirstFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.DAYCARE_DIRECTORY_FIRST_FLOW.id */.WV.DAYCARE_DIRECTORY_FIRST_FLOW.id);
    var aboveTheFoldTestFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.SEO_3193_ABOVE_THE_FOLD_CONVERSION_TEST.id */.WV.SEO_3193_ABOVE_THE_FOLD_CONVERSION_TEST.id);
    var dayCareRobustCardFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.SEO_3126_DAYCARE_ROBUST_CARDS.id */.WV.SEO_3126_DAYCARE_ROBUST_CARDS.id);
    var isAboveTheFoldTest = (aboveTheFoldTestFlag === null || aboveTheFoldTestFlag === void 0 ? void 0 : aboveTheFoldTestFlag.variationIndex) === 2;
    var salcRobustProviderCardFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.SEO_3169_SALC_ROBUST_PROVIDER_CARDS.id */.WV.SEO_3169_SALC_ROBUST_PROVIDER_CARDS.id);
    var aboveTheFoldTestJobsFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.SEO_3217_ABOVE_THE_FOLD_CONVERSION_TEST_PROVIDERS.id */.WV.SEO_3217_ABOVE_THE_FOLD_CONVERSION_TEST_PROVIDERS.id);
    var isAboveTheFoldTestJobs = (aboveTheFoldTestJobsFlag === null || aboveTheFoldTestJobsFlag === void 0 ? void 0 : aboveTheFoldTestJobsFlag.variationIndex) === 2;
    var showPetCareUserFilters = searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER && segmentationDetails.serviceIdForMember === constants/* ServiceIdForMember.PET_CARE */.u2.PET_CARE;
    var showSeniorCareUserFilters = searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER && segmentationDetails.serviceIdForMember === constants/* ServiceIdForMember.SENIOR_CARE */.u2.SENIOR_CARE;
    var showChildCareUserFilters = (searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER || searchingFor === globalTypes/* SEOSegmentationSearchingFor.ALL_PROVIDER */.yh.ALL_PROVIDER) && (segmentationDetails.serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE */.u2.CHILD_CARE || segmentationDetails.serviceIdForMember === constants/* ServiceIdForMember.BABYSITTER */.u2.BABYSITTER || segmentationDetails.serviceIdForMember === constants/* ServiceIdForMember.NANNY */.u2.NANNY);
    var showHomeCareUserFilters = (searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER || searchingFor === globalTypes/* SEOSegmentationSearchingFor.ALL_PROVIDER */.yh.ALL_PROVIDER) && segmentationDetails.serviceIdForMember === constants/* ServiceIdForMember.HOUSEKEEPING */.u2.HOUSEKEEPING;
    var isJobSegment = segmentationDetails.searchingFor in constants/* JOB_SEARCHING_FOR */.kK;
    var isNationalLocationFilterFlag = segmentationDetails.pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL && !isJobSegment;
    var showBackgroundCheckChildCareBanner = searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER;
    var showCaregiversAboveReviews = searchingFor === globalTypes/* SEOSegmentationSearchingFor.PROVIDER */.yh.PROVIDER || searchingFor === globalTypes/* SEOSegmentationSearchingFor.ALL_PROVIDER */.yh.ALL_PROVIDER || searchingFor !== globalTypes/* SEOSegmentationSearchingFor.SMB_PROVIDER */.yh.SMB_PROVIDER || (dayCareRobustCardFlag === null || dayCareRobustCardFlag === void 0 ? void 0 : dayCareRobustCardFlag.variationIndex) === 1 || (salcRobustProviderCardFlag === null || salcRobustProviderCardFlag === void 0 ? void 0 : salcRobustProviderCardFlag.variationIndex) === 1;
    var showUserFilters = showPetCareUserFilters || showSeniorCareUserFilters || showChildCareUserFilters || showHomeCareUserFilters;
    var showLocationFilter = segmentationDetails.pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL;
    // Feature Flag view conditions
    var showCtaPlacementTest = false;
    if ((ref1 = segmentationDetails.serviceIdForMember) === null || ref1 === void 0 ? void 0 : ref1.includes(constants/* SERVICE_ID_FOR_MEMBER */.qj[segmentationDetails.serviceIdForMember])) {
        showCtaPlacementTest = true;
    }
    var searchFiltersRef = (0,react.useRef)(null);
    var locationFilterRef = (0,react.useRef)(null);
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(API_getSearchResults, {
        variables: {
            filters: (0,filtersStorage/* loadFilters */.dm)(),
            pageNumber: pageNumber,
            seoSegmentId: seoSegmentId,
            ipAddress: ipAddress,
            botInfo: botInfo,
            userGeoInfo: userGeoInfo,
            userAgent: userAgent,
            hasFilters: isNationalLocationFilterFlag || showUserFilters,
            numberOfReviewsPerProfile: numberOfReviewsPerProfile
        },
        onCompleted: function(data) {
            var searchResultData = data.seoSegmentationSearchResults.__typename === "SEOSegmentationSearchResultsSuccess" ? data.seoSegmentationSearchResults : null;
            if (searchResultData) {
                setFilters(searchResultData.filters);
                setPagination(searchResultData.pagination);
                setCaregiverSearchResults(searchResultData.caregiverSearchResults);
                setProviderSearchResults(searchResultData.providerSearchResults);
                setJobSearchResults(searchResultData.jobSearchResults);
                setArchivedJobSearchResults(searchResultData.archivedJobSearchResults);
            }
            if (data.seoSegmentationDetails.__typename === "SEOSegmentationDetailsSuccess" && (data === null || data === void 0 ? void 0 : data.seoSegmentationDetails.segmentationDetails) !== null) {
                setSearchResultsHeader(data === null || data === void 0 ? void 0 : data.seoSegmentationDetails.segmentationDetails.searchResultsHeader);
            }
            if (isNationalLocationFilterFlag) {
                var ref;
                (ref = locationFilterRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
            }
        }
    }), 2), getSearchResults = ref13[0], ref14 = ref13[1], isLoading = ref14.loading, isClientSearchResultsQuery = ref14.called;
    var directoryFirstExperience = (daycareDirectoryFirstFlag === null || daycareDirectoryFirstFlag === void 0 ? void 0 : daycareDirectoryFirstFlag.variationIndex) === 1 && daycareDirectoryFirstFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH;
    var getEnrollmentURL = function() {
        return (0,generateEnrollmentUrl/* default */.Z)({
            router: router,
            serviceIdForMember: segmentationDetails.serviceIdForMember,
            serviceId: segmentationDetails.serviceId,
            isMobile: deviceChar.is_mobile === "true",
            directoryFirstExperience: directoryFirstExperience
        });
    };
    var enrollmentURL = getEnrollmentURL();
    var pageType = segmentationDetails.pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL ? "National" : "Local";
    var seoPageType = function() {
        if (isJobSegment) {
            return "Provider SEO page";
        }
        if (providerSearchResults && providerSearchResults.length > 0) {
            return "SMB SEO page";
        }
        return "Seeker SEO page";
    };
    var trackPageViewedEvent = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(pageTitle, serviceIdForMember, amplitudeTestName) {
            var amplitudeDataForPageViewed, amplitudeDataForTestExposure;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        amplitudeDataForPageViewed = {
                            seo_page_title: pageTitle,
                            seo_page_type: seoPageType(),
                            service_id_for_member: serviceIdForMember,
                            page_template: pageType
                        };
                        amplitudeDataForTestExposure = {
                            test_name: amplitudeTestName,
                            test_variant: "1",
                            service_id_for_member: serviceIdForMember,
                            page_template: pageType
                        };
                        if (!amplitudeTestName) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, amplitudeDataForTestExposure)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoPageViewed */.Sj.seoPageViewed, amplitudeDataForPageViewed)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function trackPageViewedEvent(pageTitle, serviceIdForMember, amplitudeTestName) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        (0,filtersStorage/* clearFilters */.K5)();
    }, []);
    /*
   * Handling of page url from URL
   */ (0,react.useEffect)(function() {
        trackPageViewedEvent(segmentationDetails.headline, segmentationDetails.serviceIdForMember, testName);
        if (seoBackEndTests) {
            seoBackEndTests.forEach(function(seoBETest) {
                return (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                    test_name: seoBETest.testName,
                    test_variant: seoBETest.testVariant,
                    service_id_for_member: segmentationDetails.serviceIdForMember,
                    page_template: pageType
                });
            });
        }
        if (hotJarEventsTestFlag && hotJarEventsTestFlag.reason.kind === "RULE_MATCH") {
            if (typeof hotJarEventsTestFlag.variationIndex === "number") {
                hotjarHelper_event("".concat(constants/* UI_FEATURE_FLAGS.SEO_1586_A_B_TEST_HOT_JAR_EVENTS_TEST.id */.WV.SEO_1586_A_B_TEST_HOT_JAR_EVENTS_TEST.id, "-variation-").concat(hotJarEventsTestFlag.variationIndex));
            }
        }
        if (aboveTheFoldTestFlag && aboveTheFoldTestFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.SEO_3193_ABOVE_THE_FOLD_CONVERSION_TEST.id */.WV.SEO_3193_ABOVE_THE_FOLD_CONVERSION_TEST.id,
                test_variant: aboveTheFoldTestFlag.variationIndex,
                service_id_for_member: segmentationDetails.serviceIdForMember,
                page_template: pageType
            });
        }
        if (dayCareRobustCardFlag && dayCareRobustCardFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.SEO_3126_DAYCARE_ROBUST_CARDS.id */.WV.SEO_3126_DAYCARE_ROBUST_CARDS.id,
                test_variant: dayCareRobustCardFlag.variationIndex,
                service_id_for_member: segmentationDetails.serviceIdForMember,
                page_template: pageType
            });
        }
        if (salcRobustProviderCardFlag && salcRobustProviderCardFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.SEO_3169_SALC_ROBUST_PROVIDER_CARDS.id */.WV.SEO_3169_SALC_ROBUST_PROVIDER_CARDS.id,
                test_variant: salcRobustProviderCardFlag.variationIndex,
                service_id_for_member: segmentationDetails.serviceIdForMember,
                page_template: pageType
            });
        }
        if (aboveTheFoldTestJobsFlag && aboveTheFoldTestJobsFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.SEO_3217_ABOVE_THE_FOLD_CONVERSION_TEST_PROVIDERS.id */.WV.SEO_3217_ABOVE_THE_FOLD_CONVERSION_TEST_PROVIDERS.id,
                test_variant: aboveTheFoldTestJobsFlag.variationIndex,
                service_id_for_member: segmentationDetails.serviceIdForMember,
                page_template: pageType
            });
        }
        if (GAMFlag && GAMFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.SEO_3487_GAM_ADS_SEO_MFE.id */.WV.SEO_3487_GAM_ADS_SEO_MFE.id,
                test_variant: GAMFlag.variationIndex,
                service_id_for_member: segmentationDetails.serviceIdForMember,
                page_template: pageType
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        var pageProperties = {
            screen_name: constants/* ScreenName.SEGMENTATION */.CG.SEGMENTATION,
            screen_template: constants/* ScreenTemplate.SEGMENTATION */.Yj.SEGMENTATION,
            seo_page_id: seoPageMetadata.seoPageId,
            service_id_for_member: seoPageMetadata.serviceIdForMember,
            slots: constants/* TealiumSlot.VISITOR */.vm.VISITOR
        };
        if (deviceChar && Object.keys(deviceChar).length > 0) {
            (0,analyticsHelper/* setPagePropertiesFromData */.UP)(pageProperties);
            (0,analyticsHelper/* setDeviceDataFromHeaders */.xF)(deviceChar);
        }
    }, [
        stringifyDeviceChar,
        deviceChar,
        seoPageMetadata.seoPageId,
        seoPageMetadata.serviceIdForMember, 
    ]);
    /*
   * Handling page clicks for pagination
   */ var handlePageClick = function(newPage) {
        var ref;
        var filterSelected = (0,filtersStorage/* loadFilters */.dm)() || {};
        if (filters) {
            if (filters.location) {
                filterSelected.zipcode = filters.location.zipcode;
            }
        }
        (ref = searchFiltersRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth"
        });
        setPageNumber(newPage);
        getSearchResults({
            variables: {
                filters: filterSelected,
                pageNumber: newPage,
                seoSegmentId: seoSegmentId,
                ipAddress: ipAddress,
                botInfo: botInfo,
                userGeoInfo: userGeoInfo,
                userAgent: userAgent,
                hasFilters: isNationalLocationFilterFlag || showUserFilters,
                numberOfReviewsPerProfile: numberOfReviewsPerProfile
            }
        });
    };
    var handleFiltersApply = function() {
        handlePageClick(1); // pull Apply changes from localStorage but set page as 1
        router.push(seoSegmentId, undefined, {
            shallow: true
        });
    };
    // Component subrender methods
    var renderStats = function() {
        if ((segmentationDetails === null || segmentationDetails === void 0 ? void 0 : segmentationDetails.pageType) === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL) {
            var ref;
            if (caregiverSegmentationStats && caregiverSearchResults.length > 0 && ((ref = caregiverSegmentationStats === null || caregiverSegmentationStats === void 0 ? void 0 : caregiverSegmentationStats.totalProviders) !== null && ref !== void 0 ? ref : 0) > 0) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SeoStats, (0,_object_spread/* default */.Z)({}, caregiverSegmentationStats));
            }
        }
        return null;
    };
    var howItWorksDivider = /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: SegmentationListingPage_classes.divider,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
        })
    });
    var ref15, ref16;
    var showReviewCard = ((ref15 = caregiverSegmentationStats === null || caregiverSegmentationStats === void 0 ? void 0 : caregiverSegmentationStats.totalReviewCount) !== null && ref15 !== void 0 ? ref15 : 0) >= 5 && ((ref16 = caregiverSegmentationStats === null || caregiverSegmentationStats === void 0 ? void 0 : caregiverSegmentationStats.avgReviewRating) !== null && ref16 !== void 0 ? ref16 : 0) >= 4;
    var navigationMenuContent = (0,mapNavigationMenuContent/* mapNavigationMenuContent */.U)(seoNavigationLinkSection === null || seoNavigationLinkSection === void 0 ? void 0 : seoNavigationLinkSection.seoNavigationLinkSection);
    var filtersCtx = (0,react.useMemo)(function() {
        return {
            filters: filters,
            setFilters: function(filterVals) {
                setFilters(filterVals);
            },
            fetchResults: function(filterVals, resetPage) {
                var ref;
                (ref = searchFiltersRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
                getSearchResults({
                    variables: {
                        filters: filterVals,
                        pageNumber: resetPage ? 1 : pageNumber,
                        seoSegmentId: seoSegmentId,
                        ipAddress: ipAddress,
                        botInfo: botInfo,
                        userGeoInfo: userGeoInfo,
                        userAgent: userAgent,
                        hasFilters: isNationalLocationFilterFlag || showUserFilters,
                        numberOfReviewsPerProfile: numberOfReviewsPerProfile
                    }
                });
                if (resetPage) {
                    setPageNumber(1);
                    router.push(seoSegmentId, undefined, {
                        shallow: true
                    });
                }
            }
        };
    }, [
        filters,
        getSearchResults,
        pageNumber,
        seoSegmentId,
        ipAddress,
        botInfo,
        userGeoInfo,
        userAgent,
        numberOfReviewsPerProfile,
        isNationalLocationFilterFlag,
        showUserFilters,
        router, 
    ]);
    var estimatedZipcode = function() {
        return (0,getZipcodeFromGeoInfo/* getZipcodeFromGeoInfo */.Z)(userGeoInfo);
    };
    var whenCareModalEnrollmentUrl = function() {
        if (directoryFirstExperience && segmentationDetails.serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE_LOCATION */.u2.CHILD_CARE_LOCATION) {
            return "".concat(enrollmentURL, "&zipcode=").concat(estimatedZipcode());
        }
        return "".concat(enrollmentURL);
    }();
    var ref17, ref18, ref19, ref20;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SegmentationFiltersContext/* SegmentationFiltersContext.Provider */.$I.Provider, {
        value: filtersCtx,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default */.Z, {
                title: seoPageMetadata.title,
                canonicalUrl: seoPageMetadata.canonicalURL,
                metaDescriptions: seoPageMetadata.metaDescriptions,
                metaKeywords: seoPageMetadata.metaKeywords,
                hrefLangLinks: seoPageMetadata.hrefLangLinks,
                paginationPageCount: initialPagination.numberOfPages,
                paginationCurrentPage: pageNumber
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoGlobalNavbar/* default */.Z, {
                enrollmentURL: enrollmentURL,
                internalLinkingMenuContent: navigationMenuContent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                children: [
                    isJobSegment && !isAboveTheFoldTestJobs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_JobHero, {
                            enrollmentURL: enrollmentURL,
                            headline: segmentationDetails.headline,
                            heroImage: heroImage,
                            subHeadline: segmentationDetails.subHeadline
                        })
                    }),
                    isJobSegment && isAboveTheFoldTestJobs && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Hero, {
                                enrollmentURL: enrollmentURL,
                                headline: segmentationDetails.headline,
                                subHeadline: segmentationDetails.subHeadline,
                                userGeoInfo: userGeoInfo,
                                directoryFirstExperience: directoryFirstExperience,
                                isJobSegment: isJobSegment
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhenDoYouWantAJob, {
                                enrollmentURL: enrollmentURL
                            })
                        ]
                    }),
                    !isJobSegment && !isAboveTheFoldTest && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sx: function(theme) {
                            return {
                                borderTop: "1px solid ".concat(theme.palette.care.white)
                            };
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Hero, {
                            enrollmentURL: enrollmentURL,
                            headline: segmentationDetails.headline,
                            heroImage: heroImage,
                            searchFiltersRef: searchFiltersRef,
                            subHeadline: segmentationDetails.subHeadline,
                            segmentationStats: caregiverSegmentationStats,
                            userGeoInfo: userGeoInfo,
                            directoryFirstExperience: directoryFirstExperience
                        })
                    }),
                    !isJobSegment && isAboveTheFoldTest && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Hero, {
                                enrollmentURL: enrollmentURL,
                                headline: segmentationDetails.headline,
                                subHeadline: segmentationDetails.subHeadline,
                                userGeoInfo: userGeoInfo,
                                directoryFirstExperience: directoryFirstExperience
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StatsContentRibbon, {
                                avgPayRate: (ref17 = caregiverSegmentationStats === null || caregiverSegmentationStats === void 0 ? void 0 : caregiverSegmentationStats.avgPayRate) !== null && ref17 !== void 0 ? ref17 : null,
                                avgReviewRating: (ref18 = caregiverSegmentationStats === null || caregiverSegmentationStats === void 0 ? void 0 : caregiverSegmentationStats.avgReviewRating) !== null && ref18 !== void 0 ? ref18 : null,
                                avgYearsOfExperience: (ref19 = caregiverSegmentationStats === null || caregiverSegmentationStats === void 0 ? void 0 : caregiverSegmentationStats.avgYearsOfExperience) !== null && ref19 !== void 0 ? ref19 : null,
                                totalProviders: (ref20 = caregiverSegmentationStats === null || caregiverSegmentationStats === void 0 ? void 0 : caregiverSegmentationStats.totalProviders) !== null && ref20 !== void 0 ? ref20 : null
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                ref: searchFiltersRef
                            })
                        ]
                    }),
                    isJobSegment && !isAboveTheFoldTestJobs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoConversionBox/* default */.Z, {
                            enrollmentURL: enrollmentURL,
                            header: segmentationDetails.conversionHeader
                        })
                    }),
                    showBackgroundCheckChildCareBanner && !isAboveTheFoldTest && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BackgroundCheckBanner, {})
                    }),
                    (!isMobile && breadcrumbs.length > 1 || breadcrumbs.length > 1 && !isJobSegment) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mt: isAboveTheFoldTest ? 0 : 3,
                            mb: isAboveTheFoldTest ? 4 : -1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                maxWidth: "lg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                                    breadcrumbs: breadcrumbs
                                })
                            })
                        })
                    }),
                    isJobSegment && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                mb: isAboveTheFoldTestJobs ? 7 : 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                    maxWidth: "lg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyFilters_Filters, {
                                        searchFilters: segmentationDetails.searchFilters,
                                        searchResultsHeader: searchResultsHeader,
                                        onChange: handleFiltersApply,
                                        searchFiltersRef: searchFiltersRef,
                                        enrollmentURL: enrollmentURL,
                                        serviceId: segmentationDetails.serviceId,
                                        serviceIdForMember: segmentationDetails.serviceIdForMember,
                                        showMoreFilters: caregiverSearchResults.length > 0,
                                        showJobDetails: jobSearchResults.length > 0,
                                        searchingFor: segmentationDetails.searchingFor
                                    })
                                })
                            }),
                            !isAboveTheFoldTestJobs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            maxWidth: "lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: isJobSegment ? 7 : 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            pb: 4,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                    item: true,
                                                    xs: 12,
                                                    children: [
                                                        !showCaregiversAboveReviews && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopReviewResults, {
                                                            caregiverSearchResults: initialCaregiverSearchResults,
                                                            city: segmentationDetails.city,
                                                            pageType: segmentationDetails.pageType,
                                                            seoSegmentId: seoSegmentId,
                                                            state: segmentationDetails.state,
                                                            providerSearchResults: initialProviderSearchResults
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            ref: locationFilterRef
                                                        }),
                                                        !isAboveTheFoldTest && !isAboveTheFoldTestJobs && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HeaderText, {}),
                                                        !isAboveTheFoldTestJobs && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                            display: "flex",
                                                            children: [
                                                                showLocationFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters_LocationFilter, {}),
                                                                showUserFilters && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersPopover, {})
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_SearchResultsController, {
                                                            isLoading: isLoading,
                                                            caregiverSearchResults: caregiverSearchResults,
                                                            providerSearchResults: providerSearchResults,
                                                            city: segmentationDetails.city,
                                                            conversionHeader: segmentationDetails.conversionHeader,
                                                            crossSell: segmentationDetails.crossSell,
                                                            enrollmentURL: enrollmentURL,
                                                            isClientSearchResultsQuery: isClientSearchResultsQuery,
                                                            jobSearchResults: jobSearchResults,
                                                            archivedJobSearchResults: archivedJobSearchResults,
                                                            pageType: segmentationDetails.pageType,
                                                            serviceId: segmentationDetails.serviceId,
                                                            serviceIdForMember: segmentationDetails.serviceIdForMember,
                                                            startIndex: pagination.startIndex,
                                                            state: segmentationDetails.state,
                                                            totalNumberOfResults: pagination.totalNumberOfResults,
                                                            segmentationStats: caregiverSegmentationStats,
                                                            smbHeadline: segmentationDetails.smbHeadline
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                                        onPageClick: handlePageClick,
                                                        pagination: pagination,
                                                        segmentId: seoSegmentId,
                                                        pageSelected: pageNumber
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    item: true,
                                                    xs: 12,
                                                    children: showCaregiversAboveReviews && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopReviewResults, {
                                                        caregiverSearchResults: initialCaregiverSearchResults,
                                                        city: segmentationDetails.city,
                                                        pageType: segmentationDetails.pageType,
                                                        seoSegmentId: seoSegmentId,
                                                        state: segmentationDetails.state,
                                                        providerSearchResults: initialProviderSearchResults
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        container: true,
                                                        children: !isJobSegment && segmentationLinkSections !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoLinkList/* default */.Z, {
                                                            seoLinkList: segmentationLinkSections,
                                                            internalLinkingHeadline: segmentationDetails.internalLinkingHeadline
                                                        })
                                                    })
                                                }),
                                                (seoArticles === null || seoArticles === void 0 ? void 0 : (ref2 = seoArticles.seoArticlesList) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.articles) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && !isJobSegment && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCarousel/* default */.Z, {
                                                        articles: seoArticles.seoArticlesList.articles
                                                    })
                                                }),
                                                isMobile && breadcrumbs.length > 1 && isJobSegment && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                                                        breadcrumbs: breadcrumbs
                                                    })
                                                }),
                                                segmentationIntro && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageInfo, {
                                                        segmentationIntro: segmentationIntro
                                                    })
                                                }),
                                                isMobile && isJobSegment && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: SegmentationListingPage_classes.divider,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                                        sx: SegmentationListingPage_classes.divider
                                                    })
                                                }),
                                                caregiverSegmentationStats && renderStats(),
                                                faqs && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                            item: true,
                                                            xs: 12,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                sx: showCtaPlacementTest ? undefined : SegmentationListingPage_classes.divider,
                                                                children: isJobSegment && /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoConversionBox/* default */.Z, {
                                                                    header: segmentationDetails.conversionHeader,
                                                                    enrollmentURL: enrollmentURL
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                            item: true,
                                                            xs: 12,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs/* default */.Z, {
                                                                faqs: faqs
                                                            })
                                                        }),
                                                        isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            sx: SegmentationListingPage_classes.divider,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                                                        })
                                                    ]
                                                }),
                                                showReviewCard && caregiverSegmentationStats && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReviewCard, {
                                                        stats: caregiverSegmentationStats
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    isJobSegment && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 5,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            mt: 1,
                                            sx: {
                                                width: "330px",
                                                float: "right"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                container: true,
                                                children: [
                                                    segmentationDetails.pageType === "NATIONAL" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_JobHowItWorks, {
                                                                enrollmentURL: enrollmentURL
                                                            }),
                                                            howItWorksDivider
                                                        ]
                                                    }),
                                                    showGAMAds && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(GAMAds/* GAMAds */.U, {
                                                        slotName: constants/* HTL_SLOTS.SEO_DIRECTORY_RR_1 */.YQ.SEO_DIRECTORY_RR_1
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RightRails, {
                                                        rightRails: segmentationLinkSections
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WhenCareModal, {
                enrollmentURL: whenCareModalEnrollmentUrl,
                modalTitle: segmentationDetails.conversionHeader,
                pageType: pageType,
                serviceIdForMember: segmentationDetails.serviceIdForMember
            }),
            isMobile && showUserFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersModal, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGlobalFooter/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var segmentationListings_SegmentationListingPage = (SegmentationListingPage);
var getServerSideProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                segmentationListingPageProps(context)
            ];
        });
    });
    return function getServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 37424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getGAMContentType; }
/* harmony export */ });
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79967);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49093);


/*
 * This function returns the GAM content type based on the page template and/or searchingFor value.
 *
 * @param searchingFor - The searchingFor value from SEOSegmentationSearchingFor
 * @param pageTemplate - The page template value from PageTemplate
 * @returns The GAM content type.
 */ var getGAMContentType = function(param) {
    var searchingFor = param.searchingFor, pageTemplate = param.pageTemplate;
    if (pageTemplate === _types_common__WEBPACK_IMPORTED_MODULE_1__/* .PageTemplate.COST_GUIDE */ .P.COST_GUIDE) {
        return "none";
    }
    if (searchingFor === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .SEOSegmentationSearchingFor.ALL_JOB */ .yh.ALL_JOB || searchingFor === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .SEOSegmentationSearchingFor.SEEKER_JOB */ .yh.SEEKER_JOB || searchingFor === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .SEOSegmentationSearchingFor.SMB_JOB */ .yh.SMB_JOB) {
        return "seeker";
    }
    return "provider";
};



/***/ }),

/***/ 28057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getGAMVerticalShortName; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79967);


var getGAMVerticalShortName = function(serviceId) {
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.CAREGIGSX */ .Xs.CAREGIGSX || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.CARE_GIGS */ .UW.CARE_GIGS) {
        return "cg";
    }
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.PETCAREXX */ .Xs.PETCAREXX || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.PET_CARE */ .UW.PET_CARE) {
        return "pc";
    }
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.SENIRCARE */ .Xs.SENIRCARE || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.SENIOR_CARE */ .UW.SENIOR_CARE) {
        return "sc";
    }
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.TUTORINGX */ .Xs.TUTORINGX || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.TUTORING */ .UW.TUTORING) {
        return "tu";
    }
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.HOUSEKEEP */ .Xs.HOUSEKEEP || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.HOUSEKEEPING */ .UW.HOUSEKEEPING) {
        return "hk";
    }
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.CHILDCARE */ .Xs.CHILDCARE || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.CHILD_CARE */ .UW.CHILD_CARE) {
        return "cc";
    }
    return "none";
};



/***/ }),

/***/ 78542:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*
 * Regex to convert numbers into comma separated format(ex. 45200 -> 45,200)
 */ var formatNumToString = function(value) {
    if (Number.isNaN(value) || value === null) return "";
    return value.toLocaleString("en-US");
};
/* harmony default export */ __webpack_exports__["Z"] = (formatNumToString);


/***/ }),

/***/ 26008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ formatStartDate; }
/* harmony export */ });
var formatStartDate = function(dateInput) {
    var useLongMonth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    // Ensure the date is consistently formatted in a format like "YYYY-MM-DD" to "YYYY/MM/DD"
    var formattedDate = new Date(dateInput.replace(/-/g, "/")).toLocaleString("en-us", {
        month: useLongMonth ? "long" : "short",
        day: "numeric"
    }).split(" ");
    return {
        month: formattedDate[0],
        day: formattedDate[1]
    };
};


/***/ }),

/***/ 85715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_generateEnrollmentUrl; }
});

;// CONCATENATED MODULE: ./src/utils/getServerSidePropsUtil.ts
// Write tests for these and use them in getServerSideProps
var getSegmentUrl = function(query) {
    var ref;
    var segmentURL = (ref = query.segment) === null || ref === void 0 ? void 0 : ref.toString();
    var ref1;
    var pageStringArr = (ref1 = segmentURL === null || segmentURL === void 0 ? void 0 : segmentURL.split("-page")) !== null && ref1 !== void 0 ? ref1 : ""; // remove anything after -page
    return "/".concat(pageStringArr[0]);
};
var getVerticalUrl = function(query) {
    var ref;
    var verticalURL = (ref = query.vertical) === null || ref === void 0 ? void 0 : ref.toString();
    return "".concat(verticalURL);
};
var getPageNumber = function(query) {
    var ref;
    var segmentURL = ((ref = query.segment) === null || ref === void 0 ? void 0 : ref.toString()) || "";
    var page = 1;
    var urlPageNumber = segmentURL === null || segmentURL === void 0 ? void 0 : segmentURL.replace(/^\D+/g, ""); // find number
    if (urlPageNumber.length > 0) {
        page = Number(urlPageNumber);
    }
    return page;
};

// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/utils/generateEnrollmentUrl.ts


var generateEnrollmentUrl = function(param) {
    var router = param.router, serviceIdForMember = param.serviceIdForMember, tmp = param.serviceId, argServiceId = tmp === void 0 ? "" : tmp, _serviceShortName = param.serviceShortName, serviceShortName = _serviceShortName === void 0 ? "" : _serviceShortName, serviceProfileId = param.serviceProfileId, _directoryFirstExperience = param.directoryFirstExperience, directoryFirstExperience = _directoryFirstExperience === void 0 ? false : _directoryFirstExperience;
    var serviceId = argServiceId !== "" ? argServiceId : constants/* SEO_SERVICE_SHORT_NAMES */.Mk[serviceShortName];
    var serviceDetails = constants/* SEO_SERVICE_DETAILS */.Jm[serviceId];
    var fromSeoPage = "fromSeoPage=".concat(constants/* COMMON_SEO_ENROLLMENT_PARAMS.fromSeoPage */.BC.fromSeoPage);
    var serviceIdParam = "serviceId=".concat(serviceId);
    var memberServiceId = serviceIdForMember !== null && serviceIdForMember !== void 0 ? serviceIdForMember : constants/* SEO_SERVICE_DETAILS */.Jm[serviceId].serviceIdForMemberVal;
    var segmentUrl = (router === null || router === void 0 ? void 0 : router.query.segment) ? getSegmentUrl(router.query) : "";
    if (memberServiceId === memberServiceId.toUpperCase()) {
        memberServiceId = memberServiceId.toLowerCase();
    }
    var adultCareSegments = [
        "/adult-care",
        "/special-needs-adult-care",
        "/post-surgery-care"
    ];
    if (serviceIdForMember === "childCareLocation") {
        memberServiceId = "dayCare";
    } else if (adultCareSegments.includes(segmentUrl)) {
        memberServiceId = "adultCare";
    }
    var serviceIdForMemberParam = "serviceIdForMember=".concat(memberServiceId);
    var source = "source=".concat(constants/* COMMON_SEO_ENROLLMENT_PARAMS.source */.BC.source);
    var pageSource = "pageSource=".concat(serviceDetails.pageSource);
    var visitedServiceProfileId = serviceProfileId ? "&visitedServiceProfileId=".concat(serviceProfileId) : "";
    var enrollmentQueryParams = "".concat(fromSeoPage, "&").concat(serviceIdParam, "&").concat(serviceIdForMemberParam, "&").concat(source, "&").concat(pageSource).concat(visitedServiceProfileId);
    var enrollmentType = memberServiceId.slice(memberServiceId.length - 3) === "Job" ? "provider" : "seeker";
    if (serviceIdForMember === constants/* ServiceIdForMember.CARE_GIGS */.u2.CARE_GIGS) {
        return "/app/vhp/care-kind?".concat(enrollmentQueryParams);
    }
    if (directoryFirstExperience && serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE_LOCATION */.u2.CHILD_CARE_LOCATION) {
        return "/app/business-search?".concat(enrollmentQueryParams);
    }
    if (serviceIdForMember === constants/* ServiceIdForMember.SPECIAL_NEEDS */.u2.SPECIAL_NEEDS) {
        return "/app/enrollment/".concat(enrollmentType, "/cc?").concat(enrollmentQueryParams);
    }
    // careGigsJob and specialNeedsJob to vertical-triage enrollment flow since they dont have a dedicated flow.
    // The multi-vertical flow will be used on "/jobs, /full-time-jobs, and /part-time-jobs" segmentation pages (these are under childCareJobs):
    if (serviceIdForMember === constants/* ServiceIdForMember.CARE_GIGS_JOB */.u2.CARE_GIGS_JOB || serviceIdForMember === constants/* ServiceIdForMember.SPECIAL_NEEDS_JOB */.u2.SPECIAL_NEEDS_JOB || segmentUrl === "/jobs" || segmentUrl === "/full-time-jobs" || segmentUrl === "/part-time-jobs") {
        return "/app/vhp/vertical-triage?memberType=sitter&".concat(enrollmentQueryParams);
    }
    // Job search enrollment URL
    if (enrollmentType === "provider") {
        return "/app/enrollment/provider/mv/".concat(serviceId, "?").concat(enrollmentQueryParams);
    }
    if (serviceId === constants/* ServiceId.SENIRCARE */.Xs.SENIRCARE && serviceIdForMember === constants/* ServiceIdForMember.HOUSING_LOCATION */.u2.HOUSING_LOCATION) {
        // This is specific to Senior Assisted Living Communities( In facility care or OOH)
        return "/app/enrollment/".concat(enrollmentType, "/").concat(serviceDetails.shortName, "/").concat(constants/* SC_SEEKER_IN_FACILITY_ROUTES.WHO_NEEDS_CARE */.oF.WHO_NEEDS_CARE, "?").concat(enrollmentQueryParams);
    }
    return "/app/enrollment/".concat(enrollmentType, "/").concat(serviceDetails.shortName, "?").concat(enrollmentQueryParams);
};
/* harmony default export */ var utils_generateEnrollmentUrl = (generateEnrollmentUrl);


/***/ }),

/***/ 7772:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var getUserInitials = function() {
    var displayName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return displayName.split(" ").map(function(name) {
        return name[0];
    }).join("").toUpperCase();
};
/* harmony default export */ __webpack_exports__["Z"] = (getUserInitials);


/***/ }),

/***/ 32150:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var payRangeHelper = function(hourlyRateTo, hourlyRateFrom) {
    var showUnit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if ((hourlyRateTo === null || hourlyRateTo === void 0 ? void 0 : hourlyRateTo.length) > 0 && Number(hourlyRateTo) < 10) {
        return "< $10/hr";
    }
    if ((hourlyRateFrom === null || hourlyRateFrom === void 0 ? void 0 : hourlyRateFrom.length) > 0 && (hourlyRateTo === null || hourlyRateTo === void 0 ? void 0 : hourlyRateTo.length) > 0) {
        var str = "";
        if (Number(hourlyRateFrom) === Number(hourlyRateTo)) {
            str = "$".concat(hourlyRateFrom);
        } else if (Number(hourlyRateFrom) === 0) {
            str = ">$".concat(hourlyRateTo);
        } else {
            str = "$".concat(hourlyRateFrom, "-").concat(hourlyRateTo);
        }
        return showUnit ? "".concat(str, "/hr") : str;
    }
    if ((hourlyRateFrom === null || hourlyRateFrom === void 0 ? void 0 : hourlyRateFrom.length) > 0) {
        return "> $".concat(hourlyRateFrom);
    }
    return (hourlyRateTo === null || hourlyRateTo === void 0 ? void 0 : hourlyRateTo.length) > 0 ? "< $".concat(hourlyRateTo) : "";
};
/* harmony default export */ __webpack_exports__["Z"] = (payRangeHelper);


/***/ })

}]);